const iconMap = {
	"ab-testing": 983497,
	"abacus": 988896,
	"abjad-arabic": 987944,
	"abjad-hebrew": 987945,
	"abugida-devanagari": 987946,
	"abugida-thai": 987947,
	"access-point": 983043,
	"access-point-check": 988472,
	"access-point-minus": 988473,
	"access-point-network": 983042,
	"access-point-network-off": 986081,
	"access-point-off": 988433,
	"access-point-plus": 988474,
	"access-point-remove": 988475,
	"account": 983044,
	"account-alert": 983045,
	"account-alert-outline": 985936,
	"account-arrow-down": 989288,
	"account-arrow-down-outline": 989289,
	"account-arrow-left": 985937,
	"account-arrow-left-outline": 985938,
	"account-arrow-right": 985939,
	"account-arrow-right-outline": 985940,
	"account-arrow-up": 989287,
	"account-arrow-up-outline": 989290,
	"account-box": 983046,
	"account-box-multiple": 985396,
	"account-box-multiple-outline": 987146,
	"account-box-outline": 983047,
	"account-cancel": 987871,
	"account-cancel-outline": 987872,
	"account-cash": 987287,
	"account-cash-outline": 987288,
	"account-check": 983048,
	"account-check-outline": 986082,
	"account-child": 985737,
	"account-child-circle": 985738,
	"account-child-outline": 987336,
	"account-circle": 983049,
	"account-circle-outline": 985941,
	"account-clock": 985942,
	"account-clock-outline": 985943,
	"account-cog": 988016,
	"account-cog-outline": 988017,
	"account-convert": 983050,
	"account-convert-outline": 987905,
	"account-cowboy-hat": 986779,
	"account-cowboy-hat-outline": 989171,
	"account-details": 984625,
	"account-details-outline": 988018,
	"account-edit": 984764,
	"account-edit-outline": 987131,
	"account-eye": 984096,
	"account-eye-outline": 987771,
	"account-filter": 985398,
	"account-filter-outline": 987037,
	"account-group": 985161,
	"account-group-outline": 985944,
	"account-hard-hat": 984501,
	"account-heart": 985241,
	"account-heart-outline": 986083,
	"account-injury": 989205,
	"account-injury-outline": 989206,
	"account-key": 983051,
	"account-key-outline": 986084,
	"account-lock": 987486,
	"account-lock-open": 989536,
	"account-lock-open-outline": 989537,
	"account-lock-outline": 987487,
	"account-minus": 983053,
	"account-minus-outline": 985836,
	"account-multiple": 983054,
	"account-multiple-check": 985285,
	"account-multiple-check-outline": 987646,
	"account-multiple-minus": 984531,
	"account-multiple-minus-outline": 986085,
	"account-multiple-outline": 983055,
	"account-multiple-plus": 983056,
	"account-multiple-plus-outline": 985088,
	"account-multiple-remove": 987658,
	"account-multiple-remove-outline": 987659,
	"account-music": 985091,
	"account-music-outline": 986345,
	"account-network": 983057,
	"account-network-outline": 986086,
	"account-off": 983058,
	"account-off-outline": 986087,
	"account-outline": 983059,
	"account-plus": 983060,
	"account-plus-outline": 985089,
	"account-question": 985945,
	"account-question-outline": 985946,
	"account-reactivate": 988459,
	"account-reactivate-outline": 988460,
	"account-remove": 983061,
	"account-remove-outline": 985837,
	"account-search": 983062,
	"account-search-outline": 985397,
	"account-settings": 984624,
	"account-settings-outline": 987337,
	"account-star": 983063,
	"account-star-outline": 986088,
	"account-supervisor": 985739,
	"account-supervisor-circle": 985740,
	"account-supervisor-circle-outline": 988396,
	"account-supervisor-outline": 987437,
	"account-switch": 983065,
	"account-switch-outline": 984267,
	"account-sync": 989467,
	"account-sync-outline": 989468,
	"account-tie": 986339,
	"account-tie-hat": 989336,
	"account-tie-hat-outline": 989337,
	"account-tie-outline": 987338,
	"account-tie-voice": 987912,
	"account-tie-voice-off": 987914,
	"account-tie-voice-off-outline": 987915,
	"account-tie-voice-outline": 987913,
	"account-voice": 984523,
	"account-voice-off": 986836,
	"account-wrench": 989338,
	"account-wrench-outline": 989339,
	"adjust": 983066,
	"advertisements": 989482,
	"advertisements-off": 989483,
	"air-conditioner": 983067,
	"air-filter": 986435,
	"air-horn": 986540,
	"air-humidifier": 987289,
	"air-humidifier-off": 988262,
	"air-purifier": 986436,
	"airbag": 986089,
	"airballoon": 983068,
	"airballoon-outline": 987147,
	"airplane": 983069,
	"airplane-alert": 989306,
	"airplane-check": 989307,
	"airplane-clock": 989308,
	"airplane-cog": 989309,
	"airplane-edit": 989310,
	"airplane-landing": 984532,
	"airplane-marker": 989311,
	"airplane-minus": 989312,
	"airplane-off": 983070,
	"airplane-plus": 989313,
	"airplane-remove": 989314,
	"airplane-search": 989315,
	"airplane-settings": 989316,
	"airplane-takeoff": 984533,
	"airport": 985163,
	"alarm": 983072,
	"alarm-bell": 984974,
	"alarm-check": 983073,
	"alarm-light": 984975,
	"alarm-light-off": 988958,
	"alarm-light-off-outline": 988959,
	"alarm-light-outline": 986090,
	"alarm-multiple": 983074,
	"alarm-note": 986737,
	"alarm-note-off": 986738,
	"alarm-off": 983075,
	"alarm-panel": 988612,
	"alarm-panel-outline": 988613,
	"alarm-plus": 983076,
	"alarm-snooze": 984718,
	"album": 983077,
	"alert": 983078,
	"alert-box": 983079,
	"alert-box-outline": 986340,
	"alert-circle": 983080,
	"alert-circle-check": 987629,
	"alert-circle-check-outline": 987630,
	"alert-circle-outline": 984534,
	"alert-decagram": 984765,
	"alert-decagram-outline": 986341,
	"alert-minus": 988347,
	"alert-minus-outline": 988350,
	"alert-octagon": 983081,
	"alert-octagon-outline": 986342,
	"alert-octagram": 984935,
	"alert-octagram-outline": 986343,
	"alert-outline": 983082,
	"alert-plus": 988346,
	"alert-plus-outline": 988349,
	"alert-remove": 988348,
	"alert-remove-outline": 988351,
	"alert-rhombus": 987598,
	"alert-rhombus-outline": 987599,
	"alien": 985242,
	"alien-outline": 987339,
	"align-horizontal-center": 987587,
	"align-horizontal-distribute": 989538,
	"align-horizontal-left": 987586,
	"align-horizontal-right": 987588,
	"align-vertical-bottom": 987589,
	"align-vertical-center": 987590,
	"align-vertical-distribute": 989539,
	"align-vertical-top": 987591,
	"all-inclusive": 984766,
	"all-inclusive-box": 989325,
	"all-inclusive-box-outline": 989326,
	"allergy": 987736,
	"alpha": 983083,
	"alpha-a": 985838,
	"alpha-a-box": 985864,
	"alpha-a-box-outline": 986091,
	"alpha-a-circle": 986092,
	"alpha-a-circle-outline": 986093,
	"alpha-b": 985839,
	"alpha-b-box": 985865,
	"alpha-b-box-outline": 986094,
	"alpha-b-circle": 986095,
	"alpha-b-circle-outline": 986096,
	"alpha-c": 985840,
	"alpha-c-box": 985866,
	"alpha-c-box-outline": 986097,
	"alpha-c-circle": 986098,
	"alpha-c-circle-outline": 986099,
	"alpha-d": 985841,
	"alpha-d-box": 985867,
	"alpha-d-box-outline": 986100,
	"alpha-d-circle": 986101,
	"alpha-d-circle-outline": 986102,
	"alpha-e": 985842,
	"alpha-e-box": 985868,
	"alpha-e-box-outline": 986103,
	"alpha-e-circle": 986104,
	"alpha-e-circle-outline": 986105,
	"alpha-f": 985843,
	"alpha-f-box": 985869,
	"alpha-f-box-outline": 986106,
	"alpha-f-circle": 986107,
	"alpha-f-circle-outline": 986108,
	"alpha-g": 985844,
	"alpha-g-box": 985870,
	"alpha-g-box-outline": 986109,
	"alpha-g-circle": 986110,
	"alpha-g-circle-outline": 986111,
	"alpha-h": 985845,
	"alpha-h-box": 985871,
	"alpha-h-box-outline": 986112,
	"alpha-h-circle": 986113,
	"alpha-h-circle-outline": 986114,
	"alpha-i": 985846,
	"alpha-i-box": 985872,
	"alpha-i-box-outline": 986115,
	"alpha-i-circle": 986116,
	"alpha-i-circle-outline": 986117,
	"alpha-j": 985847,
	"alpha-j-box": 985873,
	"alpha-j-box-outline": 986118,
	"alpha-j-circle": 986119,
	"alpha-j-circle-outline": 986120,
	"alpha-k": 985848,
	"alpha-k-box": 985874,
	"alpha-k-box-outline": 986121,
	"alpha-k-circle": 986122,
	"alpha-k-circle-outline": 986123,
	"alpha-l": 985849,
	"alpha-l-box": 985875,
	"alpha-l-box-outline": 986124,
	"alpha-l-circle": 986125,
	"alpha-l-circle-outline": 986126,
	"alpha-m": 985850,
	"alpha-m-box": 985876,
	"alpha-m-box-outline": 986127,
	"alpha-m-circle": 986128,
	"alpha-m-circle-outline": 986129,
	"alpha-n": 985851,
	"alpha-n-box": 985877,
	"alpha-n-box-outline": 986130,
	"alpha-n-circle": 986131,
	"alpha-n-circle-outline": 986132,
	"alpha-o": 985852,
	"alpha-o-box": 985878,
	"alpha-o-box-outline": 986133,
	"alpha-o-circle": 986134,
	"alpha-o-circle-outline": 986135,
	"alpha-p": 985853,
	"alpha-p-box": 985879,
	"alpha-p-box-outline": 986136,
	"alpha-p-circle": 986137,
	"alpha-p-circle-outline": 986138,
	"alpha-q": 985854,
	"alpha-q-box": 985880,
	"alpha-q-box-outline": 986139,
	"alpha-q-circle": 986140,
	"alpha-q-circle-outline": 986141,
	"alpha-r": 985855,
	"alpha-r-box": 985881,
	"alpha-r-box-outline": 986142,
	"alpha-r-circle": 986143,
	"alpha-r-circle-outline": 986144,
	"alpha-s": 985856,
	"alpha-s-box": 985882,
	"alpha-s-box-outline": 986145,
	"alpha-s-circle": 986146,
	"alpha-s-circle-outline": 986147,
	"alpha-t": 985857,
	"alpha-t-box": 985883,
	"alpha-t-box-outline": 986148,
	"alpha-t-circle": 986149,
	"alpha-t-circle-outline": 986150,
	"alpha-u": 985858,
	"alpha-u-box": 985884,
	"alpha-u-box-outline": 986151,
	"alpha-u-circle": 986152,
	"alpha-u-circle-outline": 986153,
	"alpha-v": 985859,
	"alpha-v-box": 985885,
	"alpha-v-box-outline": 986154,
	"alpha-v-circle": 986155,
	"alpha-v-circle-outline": 986156,
	"alpha-w": 985860,
	"alpha-w-box": 985886,
	"alpha-w-box-outline": 986157,
	"alpha-w-circle": 986158,
	"alpha-w-circle-outline": 986159,
	"alpha-x": 985861,
	"alpha-x-box": 985887,
	"alpha-x-box-outline": 986160,
	"alpha-x-circle": 986161,
	"alpha-x-circle-outline": 986162,
	"alpha-y": 985862,
	"alpha-y-box": 985888,
	"alpha-y-box-outline": 986163,
	"alpha-y-circle": 986164,
	"alpha-y-circle-outline": 986165,
	"alpha-z": 985863,
	"alpha-z-box": 985889,
	"alpha-z-box-outline": 986166,
	"alpha-z-circle": 986167,
	"alpha-z-circle-outline": 986168,
	"alphabet-aurebesh": 987948,
	"alphabet-cyrillic": 987949,
	"alphabet-greek": 987950,
	"alphabet-latin": 987951,
	"alphabet-piqad": 987952,
	"alphabet-tengwar": 987959,
	"alphabetical": 983084,
	"alphabetical-off": 987148,
	"alphabetical-variant": 987149,
	"alphabetical-variant-off": 987150,
	"altimeter": 984535,
	"ambulance": 983087,
	"ammunition": 986344,
	"ampersand": 985741,
	"amplifier": 983088,
	"amplifier-off": 987573,
	"anchor": 983089,
	"android": 983090,
	"android-messages": 986437,
	"android-studio": 983092,
	"angle-acute": 985399,
	"angle-obtuse": 985400,
	"angle-right": 985401,
	"angular": 984754,
	"angularjs": 984767,
	"animation": 984536,
	"animation-outline": 985743,
	"animation-play": 985402,
	"animation-play-outline": 985744,
	"ansible": 987290,
	"antenna": 987417,
	"anvil": 985243,
	"apache-kafka": 987151,
	"api": 987291,
	"api-off": 987735,
	"apple": 983093,
	"apple-finder": 983094,
	"apple-icloud": 983096,
	"apple-ios": 983095,
	"apple-keyboard-caps": 984626,
	"apple-keyboard-command": 984627,
	"apple-keyboard-control": 984628,
	"apple-keyboard-option": 984629,
	"apple-keyboard-shift": 984630,
	"apple-safari": 983097,
	"application": 985286,
	"application-array": 987381,
	"application-array-outline": 987382,
	"application-braces": 987383,
	"application-braces-outline": 987384,
	"application-brackets": 986251,
	"application-brackets-outline": 986252,
	"application-cog": 984693,
	"application-cog-outline": 988535,
	"application-edit": 983214,
	"application-edit-outline": 984601,
	"application-export": 986541,
	"application-import": 986542,
	"application-outline": 984596,
	"application-parentheses": 987385,
	"application-parentheses-outline": 987386,
	"application-settings": 985952,
	"application-settings-outline": 988501,
	"application-variable": 987387,
	"application-variable-outline": 987388,
	"approximately-equal": 987038,
	"approximately-equal-box": 987039,
	"apps": 983099,
	"apps-box": 986438,
	"arch": 985287,
	"archive": 983100,
	"archive-alert": 988413,
	"archive-alert-outline": 988414,
	"archive-arrow-down": 987737,
	"archive-arrow-down-outline": 987738,
	"archive-arrow-up": 987739,
	"archive-arrow-up-outline": 987740,
	"archive-cancel": 989003,
	"archive-cancel-outline": 989004,
	"archive-check": 989005,
	"archive-check-outline": 989006,
	"archive-clock": 989007,
	"archive-clock-outline": 989008,
	"archive-cog": 989009,
	"archive-cog-outline": 989010,
	"archive-edit": 989011,
	"archive-edit-outline": 989012,
	"archive-eye": 989013,
	"archive-eye-outline": 989014,
	"archive-lock": 989015,
	"archive-lock-open": 989016,
	"archive-lock-open-outline": 989017,
	"archive-lock-outline": 989018,
	"archive-marker": 989019,
	"archive-marker-outline": 989020,
	"archive-minus": 989021,
	"archive-minus-outline": 989022,
	"archive-music": 989023,
	"archive-music-outline": 989024,
	"archive-off": 989025,
	"archive-off-outline": 989026,
	"archive-outline": 987662,
	"archive-plus": 989027,
	"archive-plus-outline": 989028,
	"archive-refresh": 989029,
	"archive-refresh-outline": 989030,
	"archive-remove": 989031,
	"archive-remove-outline": 989032,
	"archive-search": 989033,
	"archive-search-outline": 989034,
	"archive-settings": 989035,
	"archive-settings-outline": 989036,
	"archive-star": 989037,
	"archive-star-outline": 989038,
	"archive-sync": 989039,
	"archive-sync-outline": 989040,
	"arm-flex": 987095,
	"arm-flex-outline": 987094,
	"arrange-bring-forward": 983101,
	"arrange-bring-to-front": 983102,
	"arrange-send-backward": 983103,
	"arrange-send-to-back": 983104,
	"arrow-all": 983105,
	"arrow-bottom-left": 983106,
	"arrow-bottom-left-bold-box": 989540,
	"arrow-bottom-left-bold-box-outline": 989541,
	"arrow-bottom-left-bold-outline": 985527,
	"arrow-bottom-left-thick": 985528,
	"arrow-bottom-left-thin": 989622,
	"arrow-bottom-left-thin-circle-outline": 988566,
	"arrow-bottom-right": 983107,
	"arrow-bottom-right-bold-box": 989542,
	"arrow-bottom-right-bold-box-outline": 989543,
	"arrow-bottom-right-bold-outline": 985529,
	"arrow-bottom-right-thick": 985530,
	"arrow-bottom-right-thin": 989623,
	"arrow-bottom-right-thin-circle-outline": 988565,
	"arrow-collapse": 984597,
	"arrow-collapse-all": 983108,
	"arrow-collapse-down": 984978,
	"arrow-collapse-horizontal": 985164,
	"arrow-collapse-left": 984979,
	"arrow-collapse-right": 984980,
	"arrow-collapse-up": 984981,
	"arrow-collapse-vertical": 985165,
	"arrow-decision": 985531,
	"arrow-decision-auto": 985532,
	"arrow-decision-auto-outline": 985533,
	"arrow-decision-outline": 985534,
	"arrow-down": 983109,
	"arrow-down-bold": 984878,
	"arrow-down-bold-box": 984879,
	"arrow-down-bold-box-outline": 984880,
	"arrow-down-bold-circle": 983111,
	"arrow-down-bold-circle-outline": 983112,
	"arrow-down-bold-hexagon-outline": 983113,
	"arrow-down-bold-outline": 985535,
	"arrow-down-box": 984768,
	"arrow-down-circle": 986331,
	"arrow-down-circle-outline": 986332,
	"arrow-down-drop-circle": 983114,
	"arrow-down-drop-circle-outline": 983115,
	"arrow-down-left": 989089,
	"arrow-down-left-bold": 989090,
	"arrow-down-right": 989091,
	"arrow-down-right-bold": 989092,
	"arrow-down-thick": 983110,
	"arrow-down-thin": 989619,
	"arrow-down-thin-circle-outline": 988569,
	"arrow-expand": 984598,
	"arrow-expand-all": 983116,
	"arrow-expand-down": 984982,
	"arrow-expand-horizontal": 985166,
	"arrow-expand-left": 984983,
	"arrow-expand-right": 984984,
	"arrow-expand-up": 984985,
	"arrow-expand-vertical": 985167,
	"arrow-horizontal-lock": 987483,
	"arrow-left": 983117,
	"arrow-left-bold": 984881,
	"arrow-left-bold-box": 984882,
	"arrow-left-bold-box-outline": 984883,
	"arrow-left-bold-circle": 983119,
	"arrow-left-bold-circle-outline": 983120,
	"arrow-left-bold-hexagon-outline": 983121,
	"arrow-left-bold-outline": 985536,
	"arrow-left-bottom": 989093,
	"arrow-left-bottom-bold": 989094,
	"arrow-left-box": 984769,
	"arrow-left-circle": 986333,
	"arrow-left-circle-outline": 986334,
	"arrow-left-drop-circle": 983122,
	"arrow-left-drop-circle-outline": 983123,
	"arrow-left-right": 986739,
	"arrow-left-right-bold": 986740,
	"arrow-left-right-bold-outline": 985537,
	"arrow-left-thick": 983118,
	"arrow-left-thin": 989617,
	"arrow-left-thin-circle-outline": 988570,
	"arrow-left-top": 989095,
	"arrow-left-top-bold": 989096,
	"arrow-projectile": 989248,
	"arrow-projectile-multiple": 989247,
	"arrow-right": 983124,
	"arrow-right-bold": 984884,
	"arrow-right-bold-box": 984885,
	"arrow-right-bold-box-outline": 984886,
	"arrow-right-bold-circle": 983126,
	"arrow-right-bold-circle-outline": 983127,
	"arrow-right-bold-hexagon-outline": 983128,
	"arrow-right-bold-outline": 985538,
	"arrow-right-bottom": 989097,
	"arrow-right-bottom-bold": 989098,
	"arrow-right-box": 984770,
	"arrow-right-circle": 986335,
	"arrow-right-circle-outline": 986336,
	"arrow-right-drop-circle": 983129,
	"arrow-right-drop-circle-outline": 983130,
	"arrow-right-thick": 983125,
	"arrow-right-thin": 989616,
	"arrow-right-thin-circle-outline": 988568,
	"arrow-right-top": 989099,
	"arrow-right-top-bold": 989100,
	"arrow-split-horizontal": 985403,
	"arrow-split-vertical": 985404,
	"arrow-top-left": 983131,
	"arrow-top-left-bold-box": 989544,
	"arrow-top-left-bold-box-outline": 989545,
	"arrow-top-left-bold-outline": 985539,
	"arrow-top-left-bottom-right": 986741,
	"arrow-top-left-bottom-right-bold": 986742,
	"arrow-top-left-thick": 985540,
	"arrow-top-left-thin": 989621,
	"arrow-top-left-thin-circle-outline": 988563,
	"arrow-top-right": 983132,
	"arrow-top-right-bold-box": 989546,
	"arrow-top-right-bold-box-outline": 989547,
	"arrow-top-right-bold-outline": 985541,
	"arrow-top-right-bottom-left": 986743,
	"arrow-top-right-bottom-left-bold": 986744,
	"arrow-top-right-thick": 985542,
	"arrow-top-right-thin": 989620,
	"arrow-top-right-thin-circle-outline": 988564,
	"arrow-u-down-left": 989101,
	"arrow-u-down-left-bold": 989102,
	"arrow-u-down-right": 989103,
	"arrow-u-down-right-bold": 989104,
	"arrow-u-left-bottom": 989105,
	"arrow-u-left-bottom-bold": 989106,
	"arrow-u-left-top": 989107,
	"arrow-u-left-top-bold": 989108,
	"arrow-u-right-bottom": 989109,
	"arrow-u-right-bottom-bold": 989110,
	"arrow-u-right-top": 989111,
	"arrow-u-right-top-bold": 989112,
	"arrow-u-up-left": 989113,
	"arrow-u-up-left-bold": 989114,
	"arrow-u-up-right": 989115,
	"arrow-u-up-right-bold": 989116,
	"arrow-up": 983133,
	"arrow-up-bold": 984887,
	"arrow-up-bold-box": 984888,
	"arrow-up-bold-box-outline": 984889,
	"arrow-up-bold-circle": 983135,
	"arrow-up-bold-circle-outline": 983136,
	"arrow-up-bold-hexagon-outline": 983137,
	"arrow-up-bold-outline": 985543,
	"arrow-up-box": 984771,
	"arrow-up-circle": 986337,
	"arrow-up-circle-outline": 986338,
	"arrow-up-down": 986745,
	"arrow-up-down-bold": 986746,
	"arrow-up-down-bold-outline": 985544,
	"arrow-up-drop-circle": 983138,
	"arrow-up-drop-circle-outline": 983139,
	"arrow-up-left": 989117,
	"arrow-up-left-bold": 989118,
	"arrow-up-right": 989119,
	"arrow-up-right-bold": 989120,
	"arrow-up-thick": 983134,
	"arrow-up-thin": 989618,
	"arrow-up-thin-circle-outline": 988567,
	"arrow-vertical-lock": 987484,
	"artstation": 985947,
	"aspect-ratio": 985636,
	"assistant": 983140,
	"asterisk": 984772,
	"at": 983141,
	"atlassian": 985092,
	"atm": 986439,
	"atom": 984936,
	"atom-variant": 986747,
	"attachment": 983142,
	"audio-input-rca": 989291,
	"audio-input-stereo-minijack": 989292,
	"audio-input-xlr": 989293,
	"audio-video": 985405,
	"audio-video-off": 987574,
	"augmented-reality": 985168,
	"auto-download": 988030,
	"auto-fix": 983144,
	"auto-upload": 983145,
	"autorenew": 983146,
	"av-timer": 983147,
	"aws": 986639,
	"axe": 985288,
	"axe-battle": 989250,
	"axis": 986440,
	"axis-arrow": 986441,
	"axis-arrow-info": 988174,
	"axis-arrow-lock": 986442,
	"axis-lock": 986443,
	"axis-x-arrow": 986444,
	"axis-x-arrow-lock": 986445,
	"axis-x-rotate-clockwise": 986446,
	"axis-x-rotate-counterclockwise": 986447,
	"axis-x-y-arrow-lock": 986448,
	"axis-y-arrow": 986449,
	"axis-y-arrow-lock": 986450,
	"axis-y-rotate-clockwise": 986451,
	"axis-y-rotate-counterclockwise": 986452,
	"axis-z-arrow": 986453,
	"axis-z-arrow-lock": 986454,
	"axis-z-rotate-clockwise": 986455,
	"axis-z-rotate-counterclockwise": 986456,
	"babel": 985637,
	"baby": 983148,
	"baby-bottle": 986937,
	"baby-bottle-outline": 986938,
	"baby-buggy": 988128,
	"baby-carriage": 984719,
	"baby-carriage-off": 987040,
	"baby-face": 986748,
	"baby-face-outline": 986749,
	"backburger": 983149,
	"backspace": 983150,
	"backspace-outline": 985948,
	"backspace-reverse": 986750,
	"backspace-reverse-outline": 986751,
	"backup-restore": 983151,
	"bacteria": 986837,
	"bacteria-outline": 986838,
	"badge-account": 986535,
	"badge-account-alert": 986536,
	"badge-account-alert-outline": 986537,
	"badge-account-horizontal": 986637,
	"badge-account-horizontal-outline": 986638,
	"badge-account-outline": 986538,
	"badminton": 985169,
	"bag-carry-on": 986939,
	"bag-carry-on-check": 986469,
	"bag-carry-on-off": 986940,
	"bag-checked": 986941,
	"bag-personal": 986640,
	"bag-personal-off": 986641,
	"bag-personal-off-outline": 986642,
	"bag-personal-outline": 986643,
	"bag-suitcase": 988555,
	"bag-suitcase-off": 988557,
	"bag-suitcase-off-outline": 988558,
	"bag-suitcase-outline": 988556,
	"baguette": 986942,
	"balcony": 989207,
	"balloon": 985638,
	"ballot": 985545,
	"ballot-outline": 985546,
	"ballot-recount": 986169,
	"ballot-recount-outline": 986170,
	"bandage": 986543,
	"bank": 983152,
	"bank-check": 988757,
	"bank-minus": 986544,
	"bank-off": 988758,
	"bank-off-outline": 988759,
	"bank-outline": 986752,
	"bank-plus": 986545,
	"bank-remove": 986546,
	"bank-transfer": 985639,
	"bank-transfer-in": 985640,
	"bank-transfer-out": 985641,
	"barcode": 983153,
	"barcode-off": 987702,
	"barcode-scan": 983154,
	"barley": 983155,
	"barley-off": 985949,
	"barn": 985950,
	"barrel": 983156,
	"baseball": 985170,
	"baseball-bat": 985171,
	"baseball-diamond": 988652,
	"baseball-diamond-outline": 988653,
	"bash": 987523,
	"basket": 983158,
	"basket-check": 989413,
	"basket-check-outline": 989414,
	"basket-fill": 983159,
	"basket-minus": 988451,
	"basket-minus-outline": 988452,
	"basket-off": 988453,
	"basket-off-outline": 988454,
	"basket-outline": 987521,
	"basket-plus": 988455,
	"basket-plus-outline": 988456,
	"basket-remove": 988457,
	"basket-remove-outline": 988458,
	"basket-unfill": 983160,
	"basketball": 985094,
	"basketball-hoop": 986171,
	"basketball-hoop-outline": 986172,
	"bat": 985951,
	"bathtub": 989208,
	"bathtub-outline": 989209,
	"battery": 983161,
	"battery-10": 983162,
	"battery-10-bluetooth": 985406,
	"battery-20": 983163,
	"battery-20-bluetooth": 985407,
	"battery-30": 983164,
	"battery-30-bluetooth": 985408,
	"battery-40": 983165,
	"battery-40-bluetooth": 985409,
	"battery-50": 983166,
	"battery-50-bluetooth": 985410,
	"battery-60": 983167,
	"battery-60-bluetooth": 985411,
	"battery-70": 983168,
	"battery-70-bluetooth": 985412,
	"battery-80": 983169,
	"battery-80-bluetooth": 985413,
	"battery-90": 983170,
	"battery-90-bluetooth": 985414,
	"battery-alert": 983171,
	"battery-alert-bluetooth": 985415,
	"battery-alert-variant": 987340,
	"battery-alert-variant-outline": 987341,
	"battery-arrow-down": 989150,
	"battery-arrow-down-outline": 989151,
	"battery-arrow-up": 989152,
	"battery-arrow-up-outline": 989153,
	"battery-bluetooth": 985416,
	"battery-bluetooth-variant": 985417,
	"battery-charging": 983172,
	"battery-charging-10": 985244,
	"battery-charging-100": 983173,
	"battery-charging-20": 983174,
	"battery-charging-30": 983175,
	"battery-charging-40": 983176,
	"battery-charging-50": 985245,
	"battery-charging-60": 983177,
	"battery-charging-70": 985246,
	"battery-charging-80": 983178,
	"battery-charging-90": 983179,
	"battery-charging-high": 987814,
	"battery-charging-low": 987812,
	"battery-charging-medium": 987813,
	"battery-charging-outline": 985247,
	"battery-charging-wireless": 985095,
	"battery-charging-wireless-10": 985096,
	"battery-charging-wireless-20": 985097,
	"battery-charging-wireless-30": 985098,
	"battery-charging-wireless-40": 985099,
	"battery-charging-wireless-50": 985100,
	"battery-charging-wireless-60": 985101,
	"battery-charging-wireless-70": 985102,
	"battery-charging-wireless-80": 985103,
	"battery-charging-wireless-90": 985104,
	"battery-charging-wireless-alert": 985105,
	"battery-charging-wireless-outline": 985106,
	"battery-check": 989154,
	"battery-check-outline": 989155,
	"battery-heart": 987663,
	"battery-heart-outline": 987664,
	"battery-heart-variant": 987665,
	"battery-high": 987811,
	"battery-lock": 989084,
	"battery-lock-open": 989085,
	"battery-low": 987809,
	"battery-medium": 987810,
	"battery-minus": 989156,
	"battery-minus-outline": 989157,
	"battery-minus-variant": 983180,
	"battery-negative": 983181,
	"battery-off": 987741,
	"battery-off-outline": 987742,
	"battery-outline": 983182,
	"battery-plus": 989158,
	"battery-plus-outline": 989159,
	"battery-plus-variant": 983183,
	"battery-positive": 983184,
	"battery-remove": 989160,
	"battery-remove-outline": 989161,
	"battery-sync": 989236,
	"battery-sync-outline": 989237,
	"battery-unknown": 983185,
	"battery-unknown-bluetooth": 985418,
	"beach": 983186,
	"beaker": 986346,
	"beaker-alert": 987689,
	"beaker-alert-outline": 987690,
	"beaker-check": 987691,
	"beaker-check-outline": 987692,
	"beaker-minus": 987693,
	"beaker-minus-outline": 987694,
	"beaker-outline": 984720,
	"beaker-plus": 987695,
	"beaker-plus-outline": 987696,
	"beaker-question": 987697,
	"beaker-question-outline": 987698,
	"beaker-remove": 987699,
	"beaker-remove-outline": 987700,
	"bed": 983779,
	"bed-double": 987092,
	"bed-double-outline": 987091,
	"bed-empty": 985248,
	"bed-king": 987090,
	"bed-king-outline": 987089,
	"bed-outline": 983193,
	"bed-queen": 987088,
	"bed-queen-outline": 987099,
	"bed-single": 987245,
	"bed-single-outline": 987246,
	"bee": 987041,
	"bee-flower": 987042,
	"beehive-off-outline": 988141,
	"beehive-outline": 987342,
	"beekeeper": 988386,
	"beer": 983192,
	"beer-outline": 987916,
	"bell": 983194,
	"bell-alert": 986457,
	"bell-alert-outline": 986753,
	"bell-badge": 987499,
	"bell-badge-outline": 983416,
	"bell-cancel": 988135,
	"bell-cancel-outline": 988136,
	"bell-check": 987621,
	"bell-check-outline": 987622,
	"bell-circle": 986458,
	"bell-circle-outline": 986459,
	"bell-minus": 988137,
	"bell-minus-outline": 988138,
	"bell-off": 983195,
	"bell-off-outline": 985745,
	"bell-outline": 983196,
	"bell-plus": 983197,
	"bell-plus-outline": 985746,
	"bell-remove": 988139,
	"bell-remove-outline": 988140,
	"bell-ring": 983198,
	"bell-ring-outline": 983199,
	"bell-sleep": 983200,
	"bell-sleep-outline": 985747,
	"beta": 983201,
	"betamax": 985547,
	"biathlon": 986644,
	"bicycle": 987292,
	"bicycle-basket": 987701,
	"bicycle-cargo": 989340,
	"bicycle-electric": 988596,
	"bicycle-penny-farthing": 988649,
	"bike": 983203,
	"bike-fast": 987423,
	"billboard": 987152,
	"billiards": 985953,
	"billiards-rack": 985954,
	"binoculars": 983205,
	"bio": 983206,
	"biohazard": 983207,
	"bird": 988614,
	"bitbucket": 983208,
	"bitcoin": 985107,
	"black-mesa": 983209,
	"blender": 986347,
	"blender-outline": 989210,
	"blender-software": 983211,
	"blinds": 983212,
	"blinds-open": 987153,
	"block-helper": 983213,
	"blood-bag": 986348,
	"bluetooth": 983215,
	"bluetooth-audio": 983216,
	"bluetooth-connect": 983217,
	"bluetooth-off": 983218,
	"bluetooth-settings": 983219,
	"bluetooth-transfer": 983220,
	"blur": 983221,
	"blur-linear": 983222,
	"blur-off": 983223,
	"blur-radial": 983224,
	"bolt": 986547,
	"bomb": 984721,
	"bomb-off": 984773,
	"bone": 983225,
	"book": 983226,
	"book-account": 988077,
	"book-account-outline": 988078,
	"book-alert": 988796,
	"book-alert-outline": 988797,
	"book-alphabet": 984605,
	"book-arrow-down": 988798,
	"book-arrow-down-outline": 988799,
	"book-arrow-left": 988800,
	"book-arrow-left-outline": 988801,
	"book-arrow-right": 988802,
	"book-arrow-right-outline": 988803,
	"book-arrow-up": 988804,
	"book-arrow-up-outline": 988805,
	"book-cancel": 988806,
	"book-cancel-outline": 988807,
	"book-check": 988403,
	"book-check-outline": 988404,
	"book-clock": 988808,
	"book-clock-outline": 988809,
	"book-cog": 988810,
	"book-cog-outline": 988811,
	"book-cross": 983202,
	"book-edit": 988812,
	"book-edit-outline": 988813,
	"book-education": 988873,
	"book-education-outline": 988874,
	"book-information-variant": 987247,
	"book-lock": 984986,
	"book-lock-open": 984987,
	"book-lock-open-outline": 988814,
	"book-lock-outline": 988815,
	"book-marker": 988816,
	"book-marker-outline": 988817,
	"book-minus": 984537,
	"book-minus-multiple": 985748,
	"book-minus-multiple-outline": 985355,
	"book-minus-outline": 988818,
	"book-multiple": 983227,
	"book-multiple-outline": 984118,
	"book-music": 983143,
	"book-music-outline": 988819,
	"book-off": 988820,
	"book-off-outline": 988821,
	"book-open": 983229,
	"book-open-blank-variant": 983230,
	"book-open-outline": 985955,
	"book-open-page-variant": 984538,
	"book-open-page-variant-outline": 988630,
	"book-open-variant": 988407,
	"book-outline": 985956,
	"book-play": 986754,
	"book-play-outline": 986755,
	"book-plus": 984539,
	"book-plus-multiple": 985749,
	"book-plus-multiple-outline": 985822,
	"book-plus-outline": 988822,
	"book-refresh": 988823,
	"book-refresh-outline": 988824,
	"book-remove": 985751,
	"book-remove-multiple": 985750,
	"book-remove-multiple-outline": 984266,
	"book-remove-outline": 988825,
	"book-search": 986756,
	"book-search-outline": 986757,
	"book-settings": 988826,
	"book-settings-outline": 988827,
	"book-sync": 988828,
	"book-sync-outline": 988872,
	"book-variant": 983231,
	"book-variant-multiple": 983228,
	"bookmark": 983232,
	"bookmark-box-multiple": 989548,
	"bookmark-box-multiple-outline": 989549,
	"bookmark-check": 983233,
	"bookmark-check-outline": 988027,
	"bookmark-minus": 985548,
	"bookmark-minus-outline": 985549,
	"bookmark-multiple": 986645,
	"bookmark-multiple-outline": 986646,
	"bookmark-music": 983234,
	"bookmark-music-outline": 988025,
	"bookmark-off": 985550,
	"bookmark-off-outline": 985551,
	"bookmark-outline": 983235,
	"bookmark-plus": 983237,
	"bookmark-plus-outline": 983236,
	"bookmark-remove": 983238,
	"bookmark-remove-outline": 988026,
	"bookshelf": 987743,
	"boom-gate": 986758,
	"boom-gate-alert": 986759,
	"boom-gate-alert-outline": 986760,
	"boom-gate-arrow-down": 986761,
	"boom-gate-arrow-down-outline": 986762,
	"boom-gate-arrow-up": 986764,
	"boom-gate-arrow-up-outline": 986765,
	"boom-gate-outline": 986763,
	"boom-gate-up": 989177,
	"boom-gate-up-outline": 989178,
	"boombox": 984540,
	"boomerang": 987343,
	"bootstrap": 984774,
	"border-all": 983239,
	"border-all-variant": 985249,
	"border-bottom": 983240,
	"border-bottom-variant": 985250,
	"border-color": 983241,
	"border-horizontal": 983242,
	"border-inside": 983243,
	"border-left": 983244,
	"border-left-variant": 985251,
	"border-none": 983245,
	"border-none-variant": 985252,
	"border-outside": 983246,
	"border-right": 983247,
	"border-right-variant": 985253,
	"border-style": 983248,
	"border-top": 983249,
	"border-top-variant": 985254,
	"border-vertical": 983250,
	"bottle-soda": 987248,
	"bottle-soda-classic": 987249,
	"bottle-soda-classic-outline": 988003,
	"bottle-soda-outline": 987250,
	"bottle-tonic": 987438,
	"bottle-tonic-outline": 987439,
	"bottle-tonic-plus": 987440,
	"bottle-tonic-plus-outline": 987441,
	"bottle-tonic-skull": 987442,
	"bottle-tonic-skull-outline": 987443,
	"bottle-wine": 985172,
	"bottle-wine-outline": 987920,
	"bow-arrow": 989249,
	"bow-tie": 984696,
	"bowl": 983694,
	"bowl-mix": 984599,
	"bowl-mix-outline": 983780,
	"bowl-outline": 983721,
	"bowling": 983251,
	"box": 983252,
	"box-cutter": 983253,
	"box-cutter-off": 985930,
	"box-shadow": 984631,
	"boxing-glove": 985957,
	"braille": 985552,
	"brain": 985553,
	"bread-slice": 986350,
	"bread-slice-outline": 986351,
	"bridge": 984600,
	"briefcase": 983254,
	"briefcase-account": 986352,
	"briefcase-account-outline": 986353,
	"briefcase-check": 983255,
	"briefcase-check-outline": 987934,
	"briefcase-clock": 987344,
	"briefcase-clock-outline": 987345,
	"briefcase-download": 983256,
	"briefcase-download-outline": 986173,
	"briefcase-edit": 985752,
	"briefcase-edit-outline": 986174,
	"briefcase-eye": 989145,
	"briefcase-eye-outline": 989146,
	"briefcase-minus": 985642,
	"briefcase-minus-outline": 986175,
	"briefcase-off": 988760,
	"briefcase-off-outline": 988761,
	"briefcase-outline": 985108,
	"briefcase-plus": 985643,
	"briefcase-plus-outline": 986176,
	"briefcase-remove": 985644,
	"briefcase-remove-outline": 986177,
	"briefcase-search": 985645,
	"briefcase-search-outline": 986178,
	"briefcase-upload": 983257,
	"briefcase-upload-outline": 986179,
	"briefcase-variant": 988308,
	"briefcase-variant-off": 988762,
	"briefcase-variant-off-outline": 988763,
	"briefcase-variant-outline": 988309,
	"brightness-1": 983258,
	"brightness-2": 983259,
	"brightness-3": 983260,
	"brightness-4": 983261,
	"brightness-5": 983262,
	"brightness-6": 983263,
	"brightness-7": 983264,
	"brightness-auto": 983265,
	"brightness-percent": 986354,
	"broadcast": 988960,
	"broadcast-off": 988961,
	"broom": 983266,
	"brush": 983267,
	"brush-off": 989041,
	"brush-variant": 989203,
	"bucket": 988181,
	"bucket-outline": 988182,
	"buffet": 984440,
	"bug": 983268,
	"bug-check": 985646,
	"bug-check-outline": 985647,
	"bug-outline": 985648,
	"bugle": 986548,
	"bulldozer": 985890,
	"bullet": 986355,
	"bulletin-board": 983269,
	"bullhorn": 983270,
	"bullhorn-outline": 985891,
	"bullhorn-variant": 989550,
	"bullhorn-variant-outline": 989551,
	"bullseye": 984541,
	"bullseye-arrow": 985289,
	"bulma": 987879,
	"bunk-bed": 987906,
	"bunk-bed-outline": 983191,
	"bus": 983271,
	"bus-alert": 985753,
	"bus-articulated-end": 984988,
	"bus-articulated-front": 984989,
	"bus-clock": 985290,
	"bus-double-decker": 984990,
	"bus-electric": 989469,
	"bus-marker": 987666,
	"bus-multiple": 986943,
	"bus-school": 984991,
	"bus-side": 984992,
	"bus-stop": 987154,
	"bus-stop-covered": 987155,
	"bus-stop-uncovered": 987156,
	"butterfly": 988553,
	"butterfly-outline": 988554,
	"cabin-a-frame": 989324,
	"cable-data": 988052,
	"cached": 983272,
	"cactus": 986549,
	"cake": 983273,
	"cake-layered": 983274,
	"cake-variant": 983275,
	"cake-variant-outline": 989168,
	"calculator": 983276,
	"calculator-variant": 985754,
	"calculator-variant-outline": 988582,
	"calendar": 983277,
	"calendar-account": 986839,
	"calendar-account-outline": 986840,
	"calendar-alert": 985649,
	"calendar-arrow-left": 987444,
	"calendar-arrow-right": 987445,
	"calendar-blank": 983278,
	"calendar-blank-multiple": 987251,
	"calendar-blank-outline": 985958,
	"calendar-check": 983279,
	"calendar-check-outline": 986180,
	"calendar-clock": 983280,
	"calendar-clock-outline": 988897,
	"calendar-collapse-horizontal": 989341,
	"calendar-cursor": 988539,
	"calendar-edit": 985255,
	"calendar-end": 988780,
	"calendar-expand-horizontal": 989342,
	"calendar-export": 985892,
	"calendar-heart": 985554,
	"calendar-import": 985893,
	"calendar-lock": 988737,
	"calendar-lock-outline": 988738,
	"calendar-minus": 986460,
	"calendar-month": 986647,
	"calendar-month-outline": 986648,
	"calendar-multiple": 983281,
	"calendar-multiple-check": 983282,
	"calendar-multiselect": 985650,
	"calendar-outline": 985959,
	"calendar-plus": 983283,
	"calendar-question": 984722,
	"calendar-range": 984697,
	"calendar-range-outline": 985960,
	"calendar-refresh": 983521,
	"calendar-refresh-outline": 983555,
	"calendar-remove": 983284,
	"calendar-remove-outline": 986181,
	"calendar-search": 985420,
	"calendar-star": 985555,
	"calendar-start": 988781,
	"calendar-sync": 986766,
	"calendar-sync-outline": 986767,
	"calendar-text": 983285,
	"calendar-text-outline": 986182,
	"calendar-today": 983286,
	"calendar-week": 985651,
	"calendar-week-begin": 985652,
	"calendar-weekend": 986841,
	"calendar-weekend-outline": 986842,
	"call-made": 983287,
	"call-merge": 983288,
	"call-missed": 983289,
	"call-received": 983290,
	"call-split": 983291,
	"camcorder": 983292,
	"camcorder-off": 983295,
	"camera": 983296,
	"camera-account": 985291,
	"camera-burst": 984723,
	"camera-control": 985961,
	"camera-document": 989297,
	"camera-document-off": 989298,
	"camera-enhance": 983297,
	"camera-enhance-outline": 985962,
	"camera-flip": 988633,
	"camera-flip-outline": 988634,
	"camera-front": 983298,
	"camera-front-variant": 983299,
	"camera-gopro": 984993,
	"camera-image": 985292,
	"camera-iris": 983300,
	"camera-marker": 989607,
	"camera-marker-outline": 989608,
	"camera-metering-center": 984994,
	"camera-metering-matrix": 984995,
	"camera-metering-partial": 984996,
	"camera-metering-spot": 984997,
	"camera-off": 984543,
	"camera-off-outline": 989631,
	"camera-outline": 986461,
	"camera-party-mode": 983301,
	"camera-plus": 986843,
	"camera-plus-outline": 986844,
	"camera-rear": 983302,
	"camera-rear-variant": 983303,
	"camera-retake": 986649,
	"camera-retake-outline": 986650,
	"camera-switch": 983304,
	"camera-switch-outline": 985162,
	"camera-timer": 983305,
	"camera-wireless": 986550,
	"camera-wireless-outline": 986551,
	"campfire": 986845,
	"cancel": 984890,
	"candelabra": 989138,
	"candelabra-fire": 989139,
	"candle": 984546,
	"candy": 989552,
	"candy-off": 989553,
	"candy-off-outline": 989554,
	"candy-outline": 989555,
	"candycane": 983306,
	"cannabis": 984998,
	"cannabis-off": 988782,
	"caps-lock": 985755,
	"car": 983307,
	"car-2-plus": 987157,
	"car-3-plus": 987158,
	"car-arrow-left": 988082,
	"car-arrow-right": 988083,
	"car-back": 986651,
	"car-battery": 983308,
	"car-brake-abs": 986183,
	"car-brake-alert": 986184,
	"car-brake-fluid-level": 989449,
	"car-brake-hold": 986462,
	"car-brake-low-pressure": 989450,
	"car-brake-parking": 986463,
	"car-brake-retarder": 987159,
	"car-brake-temperature": 989451,
	"car-brake-worn-linings": 989452,
	"car-child-seat": 987043,
	"car-clock": 989556,
	"car-clutch": 987160,
	"car-cog": 988108,
	"car-connected": 983309,
	"car-convertible": 984999,
	"car-coolant-level": 987161,
	"car-cruise-control": 986464,
	"car-defrost-front": 986465,
	"car-defrost-rear": 986466,
	"car-door": 985963,
	"car-door-lock": 987293,
	"car-electric": 985964,
	"car-electric-outline": 988597,
	"car-emergency": 988687,
	"car-esp": 986185,
	"car-estate": 985000,
	"car-hatchback": 985001,
	"car-info": 987582,
	"car-key": 985965,
	"car-lifted-pickup": 988461,
	"car-light-alert": 989453,
	"car-light-dimmed": 986186,
	"car-light-fog": 986187,
	"car-light-high": 986188,
	"car-limousine": 985293,
	"car-multiple": 985966,
	"car-off": 986652,
	"car-outline": 988397,
	"car-parking-lights": 986467,
	"car-pickup": 985002,
	"car-seat": 987044,
	"car-seat-cooler": 987045,
	"car-seat-heater": 987046,
	"car-select": 989305,
	"car-settings": 988109,
	"car-shift-pattern": 986944,
	"car-side": 985003,
	"car-speed-limiter": 989454,
	"car-sports": 985004,
	"car-tire-alert": 986189,
	"car-traction-control": 986468,
	"car-turbocharger": 987162,
	"car-wash": 983310,
	"car-windshield": 987163,
	"car-windshield-outline": 987164,
	"car-wireless": 989304,
	"car-wrench": 989204,
	"carabiner": 988352,
	"caravan": 985005,
	"card": 985967,
	"card-account-details": 984530,
	"card-account-details-outline": 986539,
	"card-account-details-star": 983715,
	"card-account-details-star-outline": 984795,
	"card-account-mail": 983438,
	"card-account-mail-outline": 986776,
	"card-account-phone": 986777,
	"card-account-phone-outline": 986778,
	"card-bulleted": 985968,
	"card-bulleted-off": 985969,
	"card-bulleted-off-outline": 985970,
	"card-bulleted-outline": 985971,
	"card-bulleted-settings": 985972,
	"card-bulleted-settings-outline": 985973,
	"card-minus": 988672,
	"card-minus-outline": 988673,
	"card-multiple": 989169,
	"card-multiple-outline": 989170,
	"card-off": 988674,
	"card-off-outline": 988675,
	"card-outline": 985974,
	"card-plus": 987647,
	"card-plus-outline": 987648,
	"card-remove": 988676,
	"card-remove-outline": 988677,
	"card-search": 987252,
	"card-search-outline": 987253,
	"card-text": 985975,
	"card-text-outline": 985976,
	"cards": 984632,
	"cards-club": 985294,
	"cards-club-outline": 989343,
	"cards-diamond": 985295,
	"cards-diamond-outline": 987165,
	"cards-heart": 985296,
	"cards-heart-outline": 989344,
	"cards-outline": 984633,
	"cards-playing": 989345,
	"cards-playing-club": 989346,
	"cards-playing-club-multiple": 989347,
	"cards-playing-club-multiple-outline": 989348,
	"cards-playing-club-outline": 989349,
	"cards-playing-diamond": 989350,
	"cards-playing-diamond-multiple": 989351,
	"cards-playing-diamond-multiple-outline": 989352,
	"cards-playing-diamond-outline": 989353,
	"cards-playing-heart": 989354,
	"cards-playing-heart-multiple": 989355,
	"cards-playing-heart-multiple-outline": 989356,
	"cards-playing-heart-outline": 989357,
	"cards-playing-outline": 984634,
	"cards-playing-spade": 989358,
	"cards-playing-spade-multiple": 989359,
	"cards-playing-spade-multiple-outline": 989360,
	"cards-playing-spade-outline": 989361,
	"cards-spade": 985297,
	"cards-spade-outline": 989362,
	"cards-variant": 984775,
	"carrot": 983311,
	"cart": 983312,
	"cart-arrow-down": 986470,
	"cart-arrow-right": 986190,
	"cart-arrow-up": 986471,
	"cart-check": 988650,
	"cart-heart": 989408,
	"cart-minus": 986472,
	"cart-off": 984683,
	"cart-outline": 983313,
	"cart-plus": 983314,
	"cart-remove": 986473,
	"cart-variant": 988651,
	"case-sensitive-alt": 983315,
	"cash": 983316,
	"cash-100": 983317,
	"cash-check": 988398,
	"cash-fast": 989276,
	"cash-lock": 988394,
	"cash-lock-open": 988395,
	"cash-marker": 986552,
	"cash-minus": 987744,
	"cash-multiple": 983318,
	"cash-plus": 987745,
	"cash-refund": 985756,
	"cash-register": 986356,
	"cash-remove": 987746,
	"cassette": 985556,
	"cast": 983320,
	"cast-audio": 987166,
	"cast-audio-variant": 989001,
	"cast-connected": 983321,
	"cast-education": 986653,
	"cast-off": 984970,
	"cast-variant": 983071,
	"castle": 983322,
	"cat": 983323,
	"cctv": 985006,
	"cctv-off": 989279,
	"ceiling-fan": 989079,
	"ceiling-fan-light": 989080,
	"ceiling-light": 984937,
	"ceiling-light-multiple": 989405,
	"ceiling-light-multiple-outline": 989406,
	"ceiling-light-outline": 989127,
	"cellphone": 983324,
	"cellphone-arrow-down": 985557,
	"cellphone-basic": 983326,
	"cellphone-charging": 988055,
	"cellphone-check": 989181,
	"cellphone-cog": 985425,
	"cellphone-dock": 983327,
	"cellphone-information": 986945,
	"cellphone-key": 985422,
	"cellphone-link": 983329,
	"cellphone-link-off": 983330,
	"cellphone-lock": 985423,
	"cellphone-marker": 989242,
	"cellphone-message": 985299,
	"cellphone-message-off": 987346,
	"cellphone-nfc": 986768,
	"cellphone-nfc-off": 987864,
	"cellphone-off": 985424,
	"cellphone-play": 987167,
	"cellphone-remove": 985421,
	"cellphone-screenshot": 985653,
	"cellphone-settings": 983331,
	"cellphone-sound": 985426,
	"cellphone-text": 985298,
	"cellphone-wireless": 985109,
	"centos": 987418,
	"certificate": 983332,
	"certificate-outline": 987528,
	"chair-rolling": 986952,
	"chair-school": 983333,
	"chandelier": 989075,
	"charity": 986191,
	"chart-arc": 983334,
	"chart-areaspline": 983335,
	"chart-areaspline-variant": 986769,
	"chart-bar": 983336,
	"chart-bar-stacked": 984938,
	"chart-bell-curve": 986192,
	"chart-bell-curve-cumulative": 987047,
	"chart-box": 988493,
	"chart-box-outline": 988494,
	"chart-box-plus-outline": 988495,
	"chart-bubble": 984547,
	"chart-donut": 985007,
	"chart-donut-variant": 985008,
	"chart-gantt": 984684,
	"chart-histogram": 983337,
	"chart-line": 983338,
	"chart-line-stacked": 984939,
	"chart-line-variant": 985009,
	"chart-multiline": 985300,
	"chart-multiple": 987667,
	"chart-pie": 983339,
	"chart-ppf": 988032,
	"chart-sankey": 987615,
	"chart-sankey-variant": 987616,
	"chart-scatter-plot": 986770,
	"chart-scatter-plot-hexbin": 984685,
	"chart-timeline": 984686,
	"chart-timeline-variant": 986771,
	"chart-timeline-variant-shimmer": 988598,
	"chart-tree": 986772,
	"chart-waterfall": 989464,
	"chat": 985977,
	"chat-alert": 985978,
	"chat-alert-outline": 987849,
	"chat-minus": 988176,
	"chat-minus-outline": 988179,
	"chat-outline": 986846,
	"chat-plus": 988175,
	"chat-plus-outline": 988178,
	"chat-processing": 985979,
	"chat-processing-outline": 987850,
	"chat-question": 988984,
	"chat-question-outline": 988985,
	"chat-remove": 988177,
	"chat-remove-outline": 988180,
	"chat-sleep": 987857,
	"chat-sleep-outline": 987858,
	"check": 983340,
	"check-all": 983341,
	"check-bold": 986654,
	"check-circle": 984544,
	"check-circle-outline": 984545,
	"check-decagram": 984977,
	"check-decagram-outline": 988992,
	"check-network": 986195,
	"check-network-outline": 986196,
	"check-outline": 985173,
	"check-underline": 986655,
	"check-underline-circle": 986656,
	"check-underline-circle-outline": 986657,
	"checkbook": 985757,
	"checkbox-blank": 983342,
	"checkbox-blank-badge": 987510,
	"checkbox-blank-badge-outline": 983319,
	"checkbox-blank-circle": 983343,
	"checkbox-blank-circle-outline": 983344,
	"checkbox-blank-off": 987884,
	"checkbox-blank-off-outline": 987885,
	"checkbox-blank-outline": 983345,
	"checkbox-intermediate": 985174,
	"checkbox-marked": 983346,
	"checkbox-marked-circle": 983347,
	"checkbox-marked-circle-outline": 983348,
	"checkbox-marked-circle-plus-outline": 989479,
	"checkbox-marked-outline": 983349,
	"checkbox-multiple-blank": 983350,
	"checkbox-multiple-blank-circle": 984635,
	"checkbox-multiple-blank-circle-outline": 984636,
	"checkbox-multiple-blank-outline": 983351,
	"checkbox-multiple-marked": 983352,
	"checkbox-multiple-marked-circle": 984637,
	"checkbox-multiple-marked-circle-outline": 984638,
	"checkbox-multiple-marked-outline": 983353,
	"checkbox-multiple-outline": 986193,
	"checkbox-outline": 986194,
	"checkerboard": 983354,
	"checkerboard-minus": 987650,
	"checkerboard-plus": 987649,
	"checkerboard-remove": 987651,
	"cheese": 987833,
	"cheese-off": 988142,
	"chef-hat": 985980,
	"chemical-weapon": 983355,
	"chess-bishop": 985180,
	"chess-king": 985175,
	"chess-knight": 985176,
	"chess-pawn": 985177,
	"chess-queen": 985178,
	"chess-rook": 985179,
	"chevron-double-down": 983356,
	"chevron-double-left": 983357,
	"chevron-double-right": 983358,
	"chevron-double-up": 983359,
	"chevron-down": 983360,
	"chevron-down-box": 985558,
	"chevron-down-box-outline": 985559,
	"chevron-down-circle": 985894,
	"chevron-down-circle-outline": 985895,
	"chevron-left": 983361,
	"chevron-left-box": 985560,
	"chevron-left-box-outline": 985561,
	"chevron-left-circle": 985896,
	"chevron-left-circle-outline": 985897,
	"chevron-right": 983362,
	"chevron-right-box": 985562,
	"chevron-right-box-outline": 985563,
	"chevron-right-circle": 985898,
	"chevron-right-circle-outline": 985899,
	"chevron-triple-down": 986553,
	"chevron-triple-left": 986554,
	"chevron-triple-right": 986555,
	"chevron-triple-up": 986556,
	"chevron-up": 983363,
	"chevron-up-box": 985564,
	"chevron-up-box-outline": 985565,
	"chevron-up-circle": 985900,
	"chevron-up-circle-outline": 985901,
	"chili-alert": 989162,
	"chili-alert-outline": 989163,
	"chili-hot": 985010,
	"chili-hot-outline": 989164,
	"chili-medium": 985011,
	"chili-medium-outline": 989165,
	"chili-mild": 985012,
	"chili-mild-outline": 989166,
	"chili-off": 988263,
	"chili-off-outline": 989167,
	"chip": 984602,
	"church": 983364,
	"cigar": 987529,
	"cigar-off": 988187,
	"circle": 984933,
	"circle-box": 988636,
	"circle-box-outline": 988637,
	"circle-double": 986773,
	"circle-edit-outline": 985301,
	"circle-expand": 986774,
	"circle-half": 988053,
	"circle-half-full": 988054,
	"circle-medium": 985566,
	"circle-multiple": 985912,
	"circle-multiple-outline": 984725,
	"circle-off-outline": 987347,
	"circle-opacity": 989267,
	"circle-outline": 984934,
	"circle-slice-1": 985758,
	"circle-slice-2": 985759,
	"circle-slice-3": 985760,
	"circle-slice-4": 985761,
	"circle-slice-5": 985762,
	"circle-slice-6": 985763,
	"circle-slice-7": 985764,
	"circle-slice-8": 985765,
	"circle-small": 985567,
	"circular-saw": 986658,
	"city": 983366,
	"city-variant": 985654,
	"city-variant-outline": 985655,
	"clipboard": 983367,
	"clipboard-account": 983368,
	"clipboard-account-outline": 986197,
	"clipboard-alert": 983369,
	"clipboard-alert-outline": 986359,
	"clipboard-arrow-down": 983370,
	"clipboard-arrow-down-outline": 986198,
	"clipboard-arrow-left": 983371,
	"clipboard-arrow-left-outline": 986360,
	"clipboard-arrow-right": 986361,
	"clipboard-arrow-right-outline": 986362,
	"clipboard-arrow-up": 986199,
	"clipboard-arrow-up-outline": 986200,
	"clipboard-check": 983374,
	"clipboard-check-multiple": 987747,
	"clipboard-check-multiple-outline": 987748,
	"clipboard-check-outline": 985256,
	"clipboard-clock": 988898,
	"clipboard-clock-outline": 988899,
	"clipboard-edit": 988389,
	"clipboard-edit-outline": 988390,
	"clipboard-file": 987749,
	"clipboard-file-outline": 987750,
	"clipboard-flow": 984776,
	"clipboard-flow-outline": 987415,
	"clipboard-list": 987348,
	"clipboard-list-outline": 987349,
	"clipboard-minus": 988696,
	"clipboard-minus-outline": 988697,
	"clipboard-multiple": 987751,
	"clipboard-multiple-outline": 987752,
	"clipboard-off": 988698,
	"clipboard-off-outline": 988699,
	"clipboard-outline": 983372,
	"clipboard-play": 986201,
	"clipboard-play-multiple": 987753,
	"clipboard-play-multiple-outline": 987754,
	"clipboard-play-outline": 986202,
	"clipboard-plus": 984913,
	"clipboard-plus-outline": 987935,
	"clipboard-pulse": 985181,
	"clipboard-pulse-outline": 985182,
	"clipboard-remove": 988700,
	"clipboard-remove-outline": 988701,
	"clipboard-search": 988702,
	"clipboard-search-outline": 988703,
	"clipboard-text": 983373,
	"clipboard-text-clock": 989433,
	"clipboard-text-clock-outline": 989434,
	"clipboard-text-multiple": 987755,
	"clipboard-text-multiple-outline": 987756,
	"clipboard-text-off": 988704,
	"clipboard-text-off-outline": 988705,
	"clipboard-text-outline": 985656,
	"clipboard-text-play": 986203,
	"clipboard-text-play-outline": 986204,
	"clipboard-text-search": 988706,
	"clipboard-text-search-outline": 988707,
	"clippy": 983375,
	"clock": 985428,
	"clock-alert": 985429,
	"clock-alert-outline": 984526,
	"clock-check": 987048,
	"clock-check-outline": 987049,
	"clock-digital": 986775,
	"clock-edit": 989626,
	"clock-edit-outline": 989627,
	"clock-end": 983377,
	"clock-fast": 983378,
	"clock-in": 983379,
	"clock-minus": 989283,
	"clock-minus-outline": 989284,
	"clock-out": 983380,
	"clock-outline": 983376,
	"clock-plus": 989281,
	"clock-plus-outline": 989282,
	"clock-remove": 989285,
	"clock-remove-outline": 989286,
	"clock-start": 983381,
	"clock-time-eight": 988230,
	"clock-time-eight-outline": 988242,
	"clock-time-eleven": 988233,
	"clock-time-eleven-outline": 988245,
	"clock-time-five": 988227,
	"clock-time-five-outline": 988239,
	"clock-time-four": 988226,
	"clock-time-four-outline": 988238,
	"clock-time-nine": 988231,
	"clock-time-nine-outline": 988243,
	"clock-time-one": 988223,
	"clock-time-one-outline": 988235,
	"clock-time-seven": 988229,
	"clock-time-seven-outline": 988241,
	"clock-time-six": 988228,
	"clock-time-six-outline": 988240,
	"clock-time-ten": 988232,
	"clock-time-ten-outline": 988244,
	"clock-time-three": 988225,
	"clock-time-three-outline": 988237,
	"clock-time-twelve": 988234,
	"clock-time-twelve-outline": 988246,
	"clock-time-two": 988224,
	"clock-time-two-outline": 988236,
	"close": 983382,
	"close-box": 983383,
	"close-box-multiple": 986205,
	"close-box-multiple-outline": 986206,
	"close-box-outline": 983384,
	"close-circle": 983385,
	"close-circle-multiple": 984618,
	"close-circle-multiple-outline": 985219,
	"close-circle-outline": 983386,
	"close-network": 983387,
	"close-network-outline": 986207,
	"close-octagon": 983388,
	"close-octagon-outline": 983389,
	"close-outline": 984777,
	"close-thick": 988056,
	"closed-caption": 983390,
	"closed-caption-outline": 986557,
	"cloud": 983391,
	"cloud-alert": 985568,
	"cloud-braces": 985013,
	"cloud-check": 983392,
	"cloud-check-outline": 987852,
	"cloud-circle": 983393,
	"cloud-download": 983394,
	"cloud-download-outline": 985981,
	"cloud-lock": 987633,
	"cloud-lock-outline": 987634,
	"cloud-off-outline": 983396,
	"cloud-outline": 983395,
	"cloud-print": 983397,
	"cloud-print-outline": 983398,
	"cloud-question": 985657,
	"cloud-refresh": 984362,
	"cloud-search": 985430,
	"cloud-search-outline": 985431,
	"cloud-sync": 984639,
	"cloud-sync-outline": 987862,
	"cloud-tags": 985014,
	"cloud-upload": 983399,
	"cloud-upload-outline": 985982,
	"clover": 985110,
	"coach-lamp": 987168,
	"coat-rack": 987294,
	"code-array": 983400,
	"code-braces": 983401,
	"code-braces-box": 987350,
	"code-brackets": 983402,
	"code-equal": 983403,
	"code-greater-than": 983404,
	"code-greater-than-or-equal": 983405,
	"code-json": 984614,
	"code-less-than": 983406,
	"code-less-than-or-equal": 983407,
	"code-not-equal": 983408,
	"code-not-equal-variant": 983409,
	"code-parentheses": 983410,
	"code-parentheses-box": 987351,
	"code-string": 983411,
	"code-tags": 983412,
	"code-tags-check": 984724,
	"codepen": 983413,
	"coffee": 983414,
	"coffee-maker": 987295,
	"coffee-maker-check": 989489,
	"coffee-maker-check-outline": 989490,
	"coffee-maker-outline": 989211,
	"coffee-off": 987050,
	"coffee-off-outline": 987051,
	"coffee-outline": 984778,
	"coffee-to-go": 983415,
	"coffee-to-go-outline": 987918,
	"coffin": 985983,
	"cog": 984211,
	"cog-box": 984212,
	"cog-clockwise": 987613,
	"cog-counterclockwise": 987614,
	"cog-off": 988110,
	"cog-off-outline": 988111,
	"cog-outline": 985275,
	"cog-pause": 989491,
	"cog-pause-outline": 989492,
	"cog-play": 989493,
	"cog-play-outline": 989494,
	"cog-refresh": 988254,
	"cog-refresh-outline": 988255,
	"cog-stop": 989495,
	"cog-stop-outline": 989496,
	"cog-sync": 988256,
	"cog-sync-outline": 988257,
	"cog-transfer": 987227,
	"cog-transfer-outline": 987228,
	"cogs": 985302,
	"collage": 984640,
	"collapse-all": 985766,
	"collapse-all-outline": 985767,
	"color-helper": 983417,
	"comma": 986659,
	"comma-box": 986667,
	"comma-box-outline": 986660,
	"comma-circle": 986661,
	"comma-circle-outline": 986662,
	"comment": 983418,
	"comment-account": 983419,
	"comment-account-outline": 983420,
	"comment-alert": 983421,
	"comment-alert-outline": 983422,
	"comment-arrow-left": 985569,
	"comment-arrow-left-outline": 985570,
	"comment-arrow-right": 985571,
	"comment-arrow-right-outline": 985572,
	"comment-bookmark": 988590,
	"comment-bookmark-outline": 988591,
	"comment-check": 983423,
	"comment-check-outline": 983424,
	"comment-edit": 987583,
	"comment-edit-outline": 987844,
	"comment-eye": 985658,
	"comment-eye-outline": 985659,
	"comment-flash": 988592,
	"comment-flash-outline": 988593,
	"comment-minus": 988639,
	"comment-minus-outline": 988640,
	"comment-multiple": 985183,
	"comment-multiple-outline": 983425,
	"comment-off": 988641,
	"comment-off-outline": 988642,
	"comment-outline": 983426,
	"comment-plus": 985573,
	"comment-plus-outline": 983427,
	"comment-processing": 983428,
	"comment-processing-outline": 983429,
	"comment-question": 985111,
	"comment-question-outline": 983430,
	"comment-quote": 987169,
	"comment-quote-outline": 987170,
	"comment-remove": 984542,
	"comment-remove-outline": 983431,
	"comment-search": 985660,
	"comment-search-outline": 985661,
	"comment-text": 983432,
	"comment-text-multiple": 985184,
	"comment-text-multiple-outline": 985185,
	"comment-text-outline": 983433,
	"compare": 983434,
	"compare-horizontal": 988306,
	"compare-remove": 989363,
	"compare-vertical": 988307,
	"compass": 983435,
	"compass-off": 985984,
	"compass-off-outline": 985985,
	"compass-outline": 983436,
	"compass-rose": 988034,
	"cone": 989516,
	"cone-off": 989517,
	"connection": 988694,
	"console": 983437,
	"console-line": 985015,
	"console-network": 985257,
	"console-network-outline": 986208,
	"consolidate": 987352,
	"contactless-payment": 986474,
	"contactless-payment-circle": 983841,
	"contactless-payment-circle-outline": 984072,
	"contacts": 984779,
	"contacts-outline": 984504,
	"contain": 985662,
	"contain-end": 985663,
	"contain-start": 985664,
	"content-copy": 983439,
	"content-cut": 983440,
	"content-duplicate": 983441,
	"content-paste": 983442,
	"content-save": 983443,
	"content-save-alert": 986946,
	"content-save-alert-outline": 986947,
	"content-save-all": 983444,
	"content-save-all-outline": 986948,
	"content-save-check": 989418,
	"content-save-check-outline": 989419,
	"content-save-cog": 988251,
	"content-save-cog-outline": 988252,
	"content-save-edit": 986363,
	"content-save-edit-outline": 986364,
	"content-save-move": 986663,
	"content-save-move-outline": 986664,
	"content-save-off": 988739,
	"content-save-off-outline": 988740,
	"content-save-outline": 985112,
	"content-save-settings": 984603,
	"content-save-settings-outline": 985902,
	"contrast": 983445,
	"contrast-box": 983446,
	"contrast-circle": 983447,
	"controller-classic": 985986,
	"controller-classic-outline": 985987,
	"cookie": 983448,
	"cookie-alert": 988880,
	"cookie-alert-outline": 988881,
	"cookie-check": 988882,
	"cookie-check-outline": 988883,
	"cookie-clock": 988900,
	"cookie-clock-outline": 988901,
	"cookie-cog": 988884,
	"cookie-cog-outline": 988885,
	"cookie-edit": 988902,
	"cookie-edit-outline": 988903,
	"cookie-lock": 988904,
	"cookie-lock-outline": 988905,
	"cookie-minus": 988890,
	"cookie-minus-outline": 988891,
	"cookie-off": 988906,
	"cookie-off-outline": 988907,
	"cookie-outline": 988894,
	"cookie-plus": 988886,
	"cookie-plus-outline": 988887,
	"cookie-refresh": 988908,
	"cookie-refresh-outline": 988909,
	"cookie-remove": 988888,
	"cookie-remove-outline": 988889,
	"cookie-settings": 988892,
	"cookie-settings-outline": 988893,
	"coolant-temperature": 984008,
	"copyleft": 989497,
	"copyright": 984550,
	"cordova": 985432,
	"corn": 985016,
	"corn-off": 988143,
	"cosine-wave": 988281,
	"counter": 983449,
	"countertop": 989212,
	"countertop-outline": 989213,
	"cow": 983450,
	"cow-off": 989436,
	"cpu-32-bit": 986847,
	"cpu-64-bit": 986848,
	"cradle": 989579,
	"cradle-outline": 989585,
	"crane": 985186,
	"creation": 984692,
	"creative-commons": 986475,
	"credit-card": 987119,
	"credit-card-check": 988112,
	"credit-card-check-outline": 988113,
	"credit-card-chip": 989455,
	"credit-card-chip-outline": 989456,
	"credit-card-clock": 986849,
	"credit-card-clock-outline": 986850,
	"credit-card-edit": 989143,
	"credit-card-edit-outline": 989144,
	"credit-card-fast": 989457,
	"credit-card-fast-outline": 989458,
	"credit-card-lock": 989415,
	"credit-card-lock-outline": 989416,
	"credit-card-marker": 984744,
	"credit-card-marker-outline": 986558,
	"credit-card-minus": 987052,
	"credit-card-minus-outline": 987053,
	"credit-card-multiple": 987120,
	"credit-card-multiple-outline": 983452,
	"credit-card-off": 987121,
	"credit-card-off-outline": 984548,
	"credit-card-outline": 983451,
	"credit-card-plus": 987122,
	"credit-card-plus-outline": 984694,
	"credit-card-refresh": 988741,
	"credit-card-refresh-outline": 988742,
	"credit-card-refund": 987123,
	"credit-card-refund-outline": 985768,
	"credit-card-remove": 987054,
	"credit-card-remove-outline": 987055,
	"credit-card-scan": 987124,
	"credit-card-scan-outline": 983453,
	"credit-card-search": 988743,
	"credit-card-search-outline": 988744,
	"credit-card-settings": 987125,
	"credit-card-settings-outline": 985303,
	"credit-card-sync": 988745,
	"credit-card-sync-outline": 988746,
	"credit-card-wireless": 985090,
	"credit-card-wireless-off": 984442,
	"credit-card-wireless-off-outline": 984443,
	"credit-card-wireless-outline": 986476,
	"cricket": 986477,
	"crop": 983454,
	"crop-free": 983455,
	"crop-landscape": 983456,
	"crop-portrait": 983457,
	"crop-rotate": 984726,
	"crop-square": 983458,
	"cross": 985427,
	"cross-bolnisi": 986349,
	"cross-celtic": 986357,
	"cross-outline": 986358,
	"crosshairs": 983459,
	"crosshairs-gps": 983460,
	"crosshairs-off": 986949,
	"crosshairs-question": 987446,
	"crowd": 989557,
	"crown": 983461,
	"crown-circle": 989148,
	"crown-circle-outline": 989149,
	"crown-outline": 987600,
	"cryengine": 985433,
	"crystal-ball": 985903,
	"cube": 983462,
	"cube-off": 988188,
	"cube-off-outline": 988189,
	"cube-outline": 983463,
	"cube-scan": 985988,
	"cube-send": 983464,
	"cube-unfolded": 983465,
	"cup": 983466,
	"cup-off": 984549,
	"cup-off-outline": 988029,
	"cup-outline": 987919,
	"cup-water": 983467,
	"cupboard": 986950,
	"cupboard-outline": 986951,
	"cupcake": 985434,
	"curling": 985187,
	"currency-bdt": 985188,
	"currency-brl": 985989,
	"currency-btc": 983468,
	"currency-cny": 985018,
	"currency-eth": 985019,
	"currency-eur": 983469,
	"currency-eur-off": 987925,
	"currency-gbp": 983470,
	"currency-ils": 986209,
	"currency-inr": 983471,
	"currency-jpy": 985020,
	"currency-krw": 985021,
	"currency-kzt": 985189,
	"currency-mnt": 988434,
	"currency-ngn": 983472,
	"currency-php": 985574,
	"currency-rial": 986780,
	"currency-rub": 983473,
	"currency-rupee": 989558,
	"currency-sign": 985022,
	"currency-try": 983474,
	"currency-twd": 985023,
	"currency-usd": 983489,
	"currency-usd-off": 984698,
	"current-ac": 988288,
	"current-dc": 985436,
	"cursor-default": 983488,
	"cursor-default-click": 986365,
	"cursor-default-click-outline": 986366,
	"cursor-default-gesture": 987431,
	"cursor-default-gesture-outline": 987432,
	"cursor-default-outline": 983487,
	"cursor-move": 983486,
	"cursor-pointer": 983485,
	"cursor-text": 984551,
	"curtains": 989254,
	"curtains-closed": 989255,
	"cylinder": 989518,
	"cylinder-off": 989519,
	"dance-ballroom": 988667,
	"dance-pole": 988536,
	"data-matrix": 988476,
	"data-matrix-edit": 988477,
	"data-matrix-minus": 988478,
	"data-matrix-plus": 988479,
	"data-matrix-remove": 988480,
	"data-matrix-scan": 988481,
	"database": 983484,
	"database-alert": 988730,
	"database-alert-outline": 988708,
	"database-arrow-down": 988731,
	"database-arrow-down-outline": 988709,
	"database-arrow-left": 988732,
	"database-arrow-left-outline": 988710,
	"database-arrow-right": 988733,
	"database-arrow-right-outline": 988711,
	"database-arrow-up": 988734,
	"database-arrow-up-outline": 988712,
	"database-check": 985769,
	"database-check-outline": 988713,
	"database-clock": 988735,
	"database-clock-outline": 988714,
	"database-cog": 988747,
	"database-cog-outline": 988748,
	"database-edit": 985990,
	"database-edit-outline": 988715,
	"database-export": 985438,
	"database-export-outline": 988716,
	"database-eye": 989471,
	"database-eye-off": 989472,
	"database-eye-off-outline": 989473,
	"database-eye-outline": 989474,
	"database-import": 985437,
	"database-import-outline": 988717,
	"database-lock": 985770,
	"database-lock-outline": 988718,
	"database-marker": 987894,
	"database-marker-outline": 988719,
	"database-minus": 983483,
	"database-minus-outline": 988720,
	"database-off": 988736,
	"database-off-outline": 988721,
	"database-outline": 988722,
	"database-plus": 983482,
	"database-plus-outline": 988723,
	"database-refresh": 984514,
	"database-refresh-outline": 988724,
	"database-remove": 986368,
	"database-remove-outline": 988725,
	"database-search": 985190,
	"database-search-outline": 988726,
	"database-settings": 986369,
	"database-settings-outline": 988727,
	"database-sync": 986367,
	"database-sync-outline": 988728,
	"death-star": 985304,
	"death-star-variant": 985305,
	"deathly-hallows": 985991,
	"debian": 985306,
	"debug-step-into": 983481,
	"debug-step-out": 983480,
	"debug-step-over": 983479,
	"decagram": 984940,
	"decagram-outline": 984941,
	"decimal": 987297,
	"decimal-comma": 987298,
	"decimal-comma-decrease": 987299,
	"decimal-comma-increase": 987300,
	"decimal-decrease": 983478,
	"decimal-increase": 983477,
	"delete": 983476,
	"delete-alert": 987301,
	"delete-alert-outline": 987302,
	"delete-circle": 984707,
	"delete-circle-outline": 985992,
	"delete-clock": 988502,
	"delete-clock-outline": 988503,
	"delete-empty": 984780,
	"delete-empty-outline": 986781,
	"delete-forever": 984552,
	"delete-forever-outline": 985993,
	"delete-off": 987303,
	"delete-off-outline": 987304,
	"delete-outline": 985575,
	"delete-restore": 985113,
	"delete-sweep": 984553,
	"delete-sweep-outline": 986210,
	"delete-variant": 983475,
	"delta": 983490,
	"desk": 987705,
	"desk-lamp": 985439,
	"deskphone": 983491,
	"desktop-classic": 985024,
	"desktop-mac": 983492,
	"desktop-mac-dashboard": 985576,
	"desktop-tower": 983493,
	"desktop-tower-monitor": 985771,
	"details": 983494,
	"dev-to": 986478,
	"developer-board": 984727,
	"deviantart": 983495,
	"devices": 987056,
	"dharmachakra": 985419,
	"diabetes": 987430,
	"dialpad": 984604,
	"diameter": 986211,
	"diameter-outline": 986212,
	"diameter-variant": 986213,
	"diamond": 985994,
	"diamond-outline": 985995,
	"diamond-stone": 983496,
	"dice-1": 983498,
	"dice-1-outline": 987466,
	"dice-2": 983499,
	"dice-2-outline": 987467,
	"dice-3": 983500,
	"dice-3-outline": 987468,
	"dice-4": 983501,
	"dice-4-outline": 987469,
	"dice-5": 983502,
	"dice-5-outline": 987470,
	"dice-6": 983503,
	"dice-6-outline": 987471,
	"dice-d10": 987475,
	"dice-d10-outline": 984943,
	"dice-d12": 987476,
	"dice-d12-outline": 985191,
	"dice-d20": 987477,
	"dice-d20-outline": 984554,
	"dice-d4": 987472,
	"dice-d4-outline": 984555,
	"dice-d6": 987473,
	"dice-d6-outline": 984557,
	"dice-d8": 987474,
	"dice-d8-outline": 984556,
	"dice-multiple": 984942,
	"dice-multiple-outline": 987478,
	"digital-ocean": 987703,
	"dip-switch": 985025,
	"directions": 983504,
	"directions-fork": 984641,
	"disc": 984558,
	"disc-alert": 983505,
	"disc-player": 985440,
	"discord": 984687,
	"dishwasher": 985772,
	"dishwasher-alert": 987576,
	"dishwasher-off": 987577,
	"disqus": 983506,
	"distribute-horizontal-center": 987593,
	"distribute-horizontal-left": 987592,
	"distribute-horizontal-right": 987594,
	"distribute-vertical-bottom": 987595,
	"distribute-vertical-center": 987596,
	"distribute-vertical-top": 987597,
	"diversify": 989303,
	"diving": 989559,
	"diving-flippers": 986559,
	"diving-helmet": 986560,
	"diving-scuba": 986561,
	"diving-scuba-flag": 986562,
	"diving-scuba-tank": 986563,
	"diving-scuba-tank-multiple": 986564,
	"diving-snorkel": 986565,
	"division": 983508,
	"division-box": 983509,
	"dlna": 985665,
	"dna": 984708,
	"dns": 983510,
	"dns-outline": 985996,
	"dock-bottom": 987305,
	"dock-left": 987306,
	"dock-right": 987307,
	"dock-top": 988435,
	"dock-window": 987308,
	"docker": 985192,
	"doctor": 985666,
	"dog": 985667,
	"dog-service": 985773,
	"dog-side": 985668,
	"dog-side-off": 988910,
	"dolby": 984755,
	"dolly": 986782,
	"dolphin": 989364,
	"domain": 983511,
	"domain-off": 986479,
	"domain-plus": 987309,
	"domain-remove": 987310,
	"dome-light": 988190,
	"domino-mask": 987171,
	"donkey": 985026,
	"door": 985114,
	"door-closed": 985115,
	"door-closed-lock": 987311,
	"door-open": 985116,
	"door-sliding": 989214,
	"door-sliding-lock": 989215,
	"door-sliding-open": 989216,
	"doorbell": 987878,
	"doorbell-video": 985193,
	"dot-net": 985774,
	"dots-circle": 989560,
	"dots-grid": 988668,
	"dots-hexagon": 988671,
	"dots-horizontal": 983512,
	"dots-horizontal-circle": 985027,
	"dots-horizontal-circle-outline": 985997,
	"dots-square": 988669,
	"dots-triangle": 988670,
	"dots-vertical": 983513,
	"dots-vertical-circle": 985028,
	"dots-vertical-circle-outline": 985998,
	"download": 983514,
	"download-box": 988258,
	"download-box-outline": 988259,
	"download-circle": 988260,
	"download-circle-outline": 988261,
	"download-lock": 987936,
	"download-lock-outline": 987937,
	"download-multiple": 985577,
	"download-network": 984820,
	"download-network-outline": 986214,
	"download-off": 987312,
	"download-off-outline": 987313,
	"download-outline": 985999,
	"drag": 983515,
	"drag-horizontal": 983516,
	"drag-horizontal-variant": 987888,
	"drag-variant": 986000,
	"drag-vertical": 983517,
	"drag-vertical-variant": 987889,
	"drama-masks": 986370,
	"draw": 986953,
	"draw-pen": 989625,
	"drawing": 983518,
	"drawing-box": 983519,
	"dresser": 986954,
	"dresser-outline": 986955,
	"drone": 983522,
	"dropbox": 983523,
	"drupal": 983524,
	"duck": 983525,
	"dumbbell": 983526,
	"dump-truck": 986215,
	"ear-hearing": 985029,
	"ear-hearing-off": 985669,
	"earbuds": 989263,
	"earbuds-off": 989264,
	"earbuds-off-outline": 989265,
	"earbuds-outline": 989266,
	"earth": 983527,
	"earth-arrow-right": 987921,
	"earth-box": 984781,
	"earth-box-minus": 988167,
	"earth-box-off": 984782,
	"earth-box-plus": 988166,
	"earth-box-remove": 988168,
	"earth-minus": 988164,
	"earth-off": 983528,
	"earth-plus": 988163,
	"earth-remove": 988165,
	"egg": 985775,
	"egg-easter": 985776,
	"egg-fried": 989258,
	"egg-off": 988144,
	"egg-off-outline": 988145,
	"egg-outline": 988146,
	"eiffel-tower": 988523,
	"eight-track": 985578,
	"eject": 983530,
	"eject-outline": 986001,
	"electric-switch": 986783,
	"electric-switch-closed": 987353,
	"electron-framework": 987172,
	"elephant": 985030,
	"elevation-decline": 983531,
	"elevation-rise": 983532,
	"elevator": 983533,
	"elevator-down": 987842,
	"elevator-passenger": 988033,
	"elevator-passenger-off": 989561,
	"elevator-passenger-off-outline": 989562,
	"elevator-passenger-outline": 989563,
	"elevator-up": 987841,
	"ellipse": 986784,
	"ellipse-outline": 986785,
	"email": 983534,
	"email-alert": 984783,
	"email-alert-outline": 986434,
	"email-box": 986371,
	"email-check": 985777,
	"email-check-outline": 985778,
	"email-edit": 986851,
	"email-edit-outline": 986852,
	"email-fast": 989295,
	"email-fast-outline": 989296,
	"email-lock": 983537,
	"email-mark-as-unread": 986002,
	"email-minus": 986853,
	"email-minus-outline": 986854,
	"email-multiple": 986855,
	"email-multiple-outline": 986856,
	"email-newsletter": 987057,
	"email-off": 988131,
	"email-off-outline": 988132,
	"email-open": 983535,
	"email-open-multiple": 986857,
	"email-open-multiple-outline": 986858,
	"email-open-outline": 984559,
	"email-outline": 983536,
	"email-plus": 985579,
	"email-plus-outline": 985580,
	"email-receive": 987354,
	"email-receive-outline": 987355,
	"email-remove": 988769,
	"email-remove-outline": 988770,
	"email-seal": 989531,
	"email-seal-outline": 989532,
	"email-search": 985441,
	"email-search-outline": 985442,
	"email-send": 987356,
	"email-send-outline": 987357,
	"email-sync": 987847,
	"email-sync-outline": 987848,
	"email-variant": 984560,
	"ember": 985904,
	"emby": 984756,
	"emoticon": 986216,
	"emoticon-angry": 986217,
	"emoticon-angry-outline": 986218,
	"emoticon-confused": 987358,
	"emoticon-confused-outline": 987359,
	"emoticon-cool": 986219,
	"emoticon-cool-outline": 983539,
	"emoticon-cry": 986220,
	"emoticon-cry-outline": 986221,
	"emoticon-dead": 986222,
	"emoticon-dead-outline": 984731,
	"emoticon-devil": 986223,
	"emoticon-devil-outline": 983540,
	"emoticon-excited": 986224,
	"emoticon-excited-outline": 984732,
	"emoticon-frown": 986956,
	"emoticon-frown-outline": 986957,
	"emoticon-happy": 986225,
	"emoticon-happy-outline": 983541,
	"emoticon-kiss": 986226,
	"emoticon-kiss-outline": 986227,
	"emoticon-lol": 987668,
	"emoticon-lol-outline": 987669,
	"emoticon-neutral": 986228,
	"emoticon-neutral-outline": 983542,
	"emoticon-outline": 983538,
	"emoticon-poop": 983543,
	"emoticon-poop-outline": 986229,
	"emoticon-sad": 986230,
	"emoticon-sad-outline": 983544,
	"emoticon-sick": 988540,
	"emoticon-sick-outline": 988541,
	"emoticon-tongue": 983545,
	"emoticon-tongue-outline": 986231,
	"emoticon-wink": 986232,
	"emoticon-wink-outline": 986233,
	"engine": 983546,
	"engine-off": 985670,
	"engine-off-outline": 985671,
	"engine-outline": 983547,
	"epsilon": 987360,
	"equal": 983548,
	"equal-box": 983549,
	"equalizer": 986786,
	"equalizer-outline": 986787,
	"eraser": 983550,
	"eraser-variant": 984642,
	"escalator": 983551,
	"escalator-box": 988057,
	"escalator-down": 987840,
	"escalator-up": 987839,
	"eslint": 986234,
	"et": 985779,
	"ethereum": 985194,
	"ethernet": 983552,
	"ethernet-cable": 983553,
	"ethernet-cable-off": 983554,
	"ev-plug-ccs1": 988441,
	"ev-plug-ccs2": 988442,
	"ev-plug-chademo": 988443,
	"ev-plug-tesla": 988444,
	"ev-plug-type1": 988445,
	"ev-plug-type2": 988446,
	"ev-station": 984561,
	"evernote": 983556,
	"excavator": 987173,
	"exclamation": 983557,
	"exclamation-thick": 987704,
	"exit-run": 985672,
	"exit-to-app": 983558,
	"expand-all": 985780,
	"expand-all-outline": 985781,
	"expansion-card": 985262,
	"expansion-card-variant": 987058,
	"exponent": 985443,
	"exponent-box": 985444,
	"export": 983559,
	"export-variant": 986003,
	"eye": 983560,
	"eye-arrow-left": 989437,
	"eye-arrow-left-outline": 989438,
	"eye-arrow-right": 989439,
	"eye-arrow-right-outline": 989440,
	"eye-check": 986372,
	"eye-check-outline": 986373,
	"eye-circle": 986004,
	"eye-circle-outline": 986005,
	"eye-minus": 987174,
	"eye-minus-outline": 987175,
	"eye-off": 983561,
	"eye-off-outline": 984785,
	"eye-outline": 984784,
	"eye-plus": 985195,
	"eye-plus-outline": 985196,
	"eye-refresh": 989564,
	"eye-refresh-outline": 989565,
	"eye-remove": 988643,
	"eye-remove-outline": 988644,
	"eye-settings": 985197,
	"eye-settings-outline": 985198,
	"eyedropper": 983562,
	"eyedropper-minus": 988125,
	"eyedropper-off": 988127,
	"eyedropper-plus": 988124,
	"eyedropper-remove": 988126,
	"eyedropper-variant": 983563,
	"face-agent": 986480,
	"face-man": 984643,
	"face-man-outline": 986006,
	"face-man-profile": 984644,
	"face-man-shimmer": 988620,
	"face-man-shimmer-outline": 988621,
	"face-mask": 988550,
	"face-mask-outline": 988551,
	"face-recognition": 986235,
	"face-woman": 987255,
	"face-woman-outline": 987256,
	"face-woman-profile": 987254,
	"face-woman-shimmer": 988622,
	"face-woman-shimmer-outline": 988623,
	"facebook": 983564,
	"facebook-gaming": 985053,
	"facebook-messenger": 983566,
	"facebook-workplace": 985905,
	"factory": 983567,
	"family-tree": 988686,
	"fan": 983568,
	"fan-alert": 988268,
	"fan-auto": 988957,
	"fan-chevron-down": 988269,
	"fan-chevron-up": 988270,
	"fan-minus": 988272,
	"fan-off": 985117,
	"fan-plus": 988271,
	"fan-remove": 988273,
	"fan-speed-1": 988274,
	"fan-speed-2": 988275,
	"fan-speed-3": 988276,
	"fast-forward": 983569,
	"fast-forward-10": 986481,
	"fast-forward-15": 989498,
	"fast-forward-30": 986374,
	"fast-forward-5": 987640,
	"fast-forward-60": 988683,
	"fast-forward-outline": 984786,
	"fax": 983570,
	"feather": 984787,
	"feature-search": 985673,
	"feature-search-outline": 985674,
	"fedora": 985307,
	"fence": 989082,
	"fence-electric": 989174,
	"fencing": 988353,
	"ferris-wheel": 986788,
	"ferry": 983571,
	"file": 983572,
	"file-account": 984891,
	"file-account-outline": 987176,
	"file-alert": 985675,
	"file-alert-outline": 985676,
	"file-cabinet": 985782,
	"file-cad": 986859,
	"file-cad-box": 986860,
	"file-cancel": 986566,
	"file-cancel-outline": 986567,
	"file-certificate": 987526,
	"file-certificate-outline": 987527,
	"file-chart": 983573,
	"file-chart-outline": 987177,
	"file-check": 983574,
	"file-check-outline": 986665,
	"file-clock": 987873,
	"file-clock-outline": 987874,
	"file-cloud": 983575,
	"file-cloud-outline": 987178,
	"file-code": 983598,
	"file-code-outline": 987179,
	"file-cog": 987259,
	"file-cog-outline": 987260,
	"file-compare": 985258,
	"file-delimited": 983576,
	"file-delimited-outline": 986789,
	"file-document": 983577,
	"file-document-edit": 986568,
	"file-document-edit-outline": 986569,
	"file-document-multiple": 988439,
	"file-document-multiple-outline": 988440,
	"file-document-outline": 985582,
	"file-download": 985445,
	"file-download-outline": 985446,
	"file-edit": 987623,
	"file-edit-outline": 987624,
	"file-excel": 983579,
	"file-excel-box": 983580,
	"file-excel-box-outline": 987180,
	"file-excel-outline": 987181,
	"file-export": 983581,
	"file-export-outline": 987182,
	"file-eye": 986570,
	"file-eye-outline": 986571,
	"file-find": 983582,
	"file-find-outline": 986007,
	"file-gif-box": 986488,
	"file-hidden": 984595,
	"file-image": 983583,
	"file-image-marker": 989042,
	"file-image-marker-outline": 989043,
	"file-image-minus": 989499,
	"file-image-minus-outline": 989500,
	"file-image-outline": 986800,
	"file-image-plus": 989501,
	"file-image-plus-outline": 989502,
	"file-image-remove": 989503,
	"file-image-remove-outline": 989504,
	"file-import": 983584,
	"file-import-outline": 987183,
	"file-jpg-box": 983589,
	"file-key": 987524,
	"file-key-outline": 987525,
	"file-link": 987511,
	"file-link-outline": 987512,
	"file-lock": 983585,
	"file-lock-outline": 987184,
	"file-marker": 989044,
	"file-marker-outline": 989045,
	"file-move": 985785,
	"file-move-outline": 987185,
	"file-multiple": 983586,
	"file-multiple-outline": 987186,
	"file-music": 983587,
	"file-music-outline": 986666,
	"file-outline": 983588,
	"file-pdf-box": 983590,
	"file-percent": 985118,
	"file-percent-outline": 987187,
	"file-phone": 987513,
	"file-phone-outline": 987514,
	"file-plus": 984914,
	"file-plus-outline": 986861,
	"file-png-box": 986669,
	"file-powerpoint": 983591,
	"file-powerpoint-box": 983592,
	"file-powerpoint-box-outline": 987188,
	"file-powerpoint-outline": 987189,
	"file-presentation-box": 983593,
	"file-question": 985199,
	"file-question-outline": 987190,
	"file-refresh": 985368,
	"file-refresh-outline": 984385,
	"file-remove": 986008,
	"file-remove-outline": 987191,
	"file-replace": 985906,
	"file-replace-outline": 985907,
	"file-restore": 984688,
	"file-restore-outline": 987192,
	"file-search": 986236,
	"file-search-outline": 986237,
	"file-send": 983594,
	"file-send-outline": 987193,
	"file-settings": 987257,
	"file-settings-outline": 987258,
	"file-sign": 989635,
	"file-star": 987194,
	"file-star-outline": 987195,
	"file-swap": 987060,
	"file-swap-outline": 987061,
	"file-sync": 987670,
	"file-sync-outline": 987671,
	"file-table": 986238,
	"file-table-box": 987361,
	"file-table-box-multiple": 987362,
	"file-table-box-multiple-outline": 987363,
	"file-table-box-outline": 987364,
	"file-table-outline": 986239,
	"file-tree": 984645,
	"file-tree-outline": 988114,
	"file-undo": 985308,
	"file-undo-outline": 987196,
	"file-upload": 985677,
	"file-upload-outline": 985678,
	"file-video": 983595,
	"file-video-outline": 986668,
	"file-word": 983596,
	"file-word-box": 983597,
	"file-word-box-outline": 987197,
	"file-word-outline": 987198,
	"film": 983599,
	"filmstrip": 983600,
	"filmstrip-box": 983858,
	"filmstrip-box-multiple": 986392,
	"filmstrip-off": 983601,
	"filter": 983602,
	"filter-check": 989420,
	"filter-check-outline": 989421,
	"filter-menu": 987365,
	"filter-menu-outline": 987366,
	"filter-minus": 986862,
	"filter-minus-outline": 986863,
	"filter-off": 988399,
	"filter-off-outline": 988400,
	"filter-outline": 983603,
	"filter-plus": 986864,
	"filter-plus-outline": 986865,
	"filter-remove": 983604,
	"filter-remove-outline": 983605,
	"filter-variant": 983606,
	"filter-variant-minus": 987410,
	"filter-variant-plus": 987411,
	"filter-variant-remove": 987199,
	"finance": 985119,
	"find-replace": 984788,
	"fingerprint": 983607,
	"fingerprint-off": 986801,
	"fire": 983608,
	"fire-alert": 988631,
	"fire-circle": 989191,
	"fire-extinguisher": 986866,
	"fire-hydrant": 987447,
	"fire-hydrant-alert": 987448,
	"fire-hydrant-off": 987449,
	"fire-off": 988962,
	"fire-truck": 985259,
	"firebase": 985447,
	"firefox": 983609,
	"fireplace": 986670,
	"fireplace-off": 986671,
	"firewire": 984510,
	"firework": 986672,
	"firework-off": 988963,
	"fish": 983610,
	"fish-off": 988147,
	"fishbowl": 986867,
	"fishbowl-outline": 986868,
	"fit-to-page": 986869,
	"fit-to-page-outline": 986870,
	"fit-to-screen": 989428,
	"fit-to-screen-outline": 989429,
	"flag": 983611,
	"flag-checkered": 983612,
	"flag-minus": 986009,
	"flag-minus-outline": 987314,
	"flag-off": 989422,
	"flag-off-outline": 989423,
	"flag-outline": 983613,
	"flag-plus": 986010,
	"flag-plus-outline": 987315,
	"flag-remove": 986011,
	"flag-remove-outline": 987316,
	"flag-triangle": 983615,
	"flag-variant": 983616,
	"flag-variant-outline": 983614,
	"flare": 986482,
	"flash": 983617,
	"flash-alert": 986871,
	"flash-alert-outline": 986872,
	"flash-auto": 983618,
	"flash-off": 983619,
	"flash-outline": 984789,
	"flash-red-eye": 984699,
	"flashlight": 983620,
	"flashlight-off": 983621,
	"flask": 983187,
	"flask-empty": 983188,
	"flask-empty-minus": 987706,
	"flask-empty-minus-outline": 987707,
	"flask-empty-off": 988148,
	"flask-empty-off-outline": 988149,
	"flask-empty-outline": 983189,
	"flask-empty-plus": 987708,
	"flask-empty-plus-outline": 987709,
	"flask-empty-remove": 987710,
	"flask-empty-remove-outline": 987711,
	"flask-minus": 987712,
	"flask-minus-outline": 987713,
	"flask-off": 988150,
	"flask-off-outline": 988151,
	"flask-outline": 983190,
	"flask-plus": 987714,
	"flask-plus-outline": 987715,
	"flask-remove": 987716,
	"flask-remove-outline": 987717,
	"flask-round-bottom": 987723,
	"flask-round-bottom-empty": 987724,
	"flask-round-bottom-empty-outline": 987725,
	"flask-round-bottom-outline": 987726,
	"fleur-de-lis": 987907,
	"flip-horizontal": 987367,
	"flip-to-back": 983623,
	"flip-to-front": 983624,
	"flip-vertical": 987368,
	"floor-lamp": 985309,
	"floor-lamp-dual": 987200,
	"floor-lamp-dual-outline": 989134,
	"floor-lamp-outline": 989128,
	"floor-lamp-torchiere": 988999,
	"floor-lamp-torchiere-outline": 989142,
	"floor-lamp-torchiere-variant": 987201,
	"floor-lamp-torchiere-variant-outline": 989135,
	"floor-plan": 985121,
	"floppy": 983625,
	"floppy-variant": 985583,
	"flower": 983626,
	"flower-outline": 985584,
	"flower-pollen": 989317,
	"flower-pollen-outline": 989318,
	"flower-poppy": 986376,
	"flower-tulip": 985585,
	"flower-tulip-outline": 985586,
	"focus-auto": 986958,
	"focus-field": 986959,
	"focus-field-horizontal": 986960,
	"focus-field-vertical": 986961,
	"folder": 983627,
	"folder-account": 983628,
	"folder-account-outline": 986012,
	"folder-alert": 986572,
	"folder-alert-outline": 986573,
	"folder-check": 989566,
	"folder-check-outline": 989567,
	"folder-clock": 985786,
	"folder-clock-outline": 985787,
	"folder-cog": 987263,
	"folder-cog-outline": 987264,
	"folder-download": 983629,
	"folder-download-outline": 987369,
	"folder-edit": 985310,
	"folder-edit-outline": 986574,
	"folder-eye": 989066,
	"folder-eye-outline": 989067,
	"folder-google-drive": 983630,
	"folder-heart": 987370,
	"folder-heart-outline": 987371,
	"folder-hidden": 989086,
	"folder-home": 987317,
	"folder-home-outline": 987318,
	"folder-image": 983631,
	"folder-information": 987319,
	"folder-information-outline": 987320,
	"folder-key": 985260,
	"folder-key-network": 985261,
	"folder-key-network-outline": 986240,
	"folder-key-outline": 987372,
	"folder-lock": 983632,
	"folder-lock-open": 983633,
	"folder-marker": 987757,
	"folder-marker-outline": 987758,
	"folder-move": 983634,
	"folder-move-outline": 987718,
	"folder-multiple": 983635,
	"folder-multiple-image": 983636,
	"folder-multiple-outline": 983637,
	"folder-multiple-plus": 988286,
	"folder-multiple-plus-outline": 988287,
	"folder-music": 987993,
	"folder-music-outline": 987994,
	"folder-network": 985200,
	"folder-network-outline": 986241,
	"folder-open": 984944,
	"folder-open-outline": 986575,
	"folder-outline": 983638,
	"folder-plus": 983639,
	"folder-plus-outline": 986013,
	"folder-pound": 986377,
	"folder-pound-outline": 986378,
	"folder-refresh": 984905,
	"folder-refresh-outline": 984386,
	"folder-remove": 983640,
	"folder-remove-outline": 986014,
	"folder-search": 985448,
	"folder-search-outline": 985449,
	"folder-settings": 987261,
	"folder-settings-outline": 987262,
	"folder-star": 984733,
	"folder-star-multiple": 988115,
	"folder-star-multiple-outline": 988116,
	"folder-star-outline": 986015,
	"folder-swap": 987062,
	"folder-swap-outline": 987063,
	"folder-sync": 986379,
	"folder-sync-outline": 986380,
	"folder-table": 987875,
	"folder-table-outline": 987876,
	"folder-text": 986242,
	"folder-text-outline": 986243,
	"folder-upload": 983641,
	"folder-upload-outline": 987373,
	"folder-zip": 984811,
	"folder-zip-outline": 985017,
	"font-awesome": 983098,
	"food": 983642,
	"food-apple": 983643,
	"food-apple-outline": 986244,
	"food-croissant": 985032,
	"food-drumstick": 988191,
	"food-drumstick-off": 988264,
	"food-drumstick-off-outline": 988265,
	"food-drumstick-outline": 988192,
	"food-fork-drink": 984562,
	"food-halal": 988530,
	"food-hot-dog": 989259,
	"food-kosher": 988531,
	"food-off": 984563,
	"food-off-outline": 989461,
	"food-outline": 989462,
	"food-steak": 988266,
	"food-steak-off": 988267,
	"food-takeout-box": 989238,
	"food-takeout-box-outline": 989239,
	"food-turkey": 988956,
	"food-variant": 983644,
	"food-variant-off": 988133,
	"foot-print": 986962,
	"football": 983645,
	"football-australian": 983646,
	"football-helmet": 983647,
	"forest": 989335,
	"forklift": 985033,
	"form-dropdown": 988160,
	"form-select": 988161,
	"form-textarea": 987285,
	"form-textbox": 984590,
	"form-textbox-lock": 987997,
	"form-textbox-password": 985077,
	"format-align-bottom": 984915,
	"format-align-center": 983648,
	"format-align-justify": 983649,
	"format-align-left": 983650,
	"format-align-middle": 984916,
	"format-align-right": 983651,
	"format-align-top": 984917,
	"format-annotation-minus": 985788,
	"format-annotation-plus": 984646,
	"format-bold": 983652,
	"format-clear": 983653,
	"format-color-fill": 983654,
	"format-color-highlight": 986673,
	"format-color-marker-cancel": 987923,
	"format-color-text": 984734,
	"format-columns": 985311,
	"format-float-center": 983655,
	"format-float-left": 983656,
	"format-float-none": 983657,
	"format-float-right": 983658,
	"format-font": 984790,
	"format-font-size-decrease": 985587,
	"format-font-size-increase": 985588,
	"format-header-1": 983659,
	"format-header-2": 983660,
	"format-header-3": 983661,
	"format-header-4": 983662,
	"format-header-5": 983663,
	"format-header-6": 983664,
	"format-header-decrease": 983665,
	"format-header-equal": 983666,
	"format-header-increase": 983667,
	"format-header-pound": 983668,
	"format-horizontal-align-center": 984606,
	"format-horizontal-align-left": 984607,
	"format-horizontal-align-right": 984608,
	"format-indent-decrease": 983669,
	"format-indent-increase": 983670,
	"format-italic": 983671,
	"format-letter-case": 985908,
	"format-letter-case-lower": 985909,
	"format-letter-case-upper": 985910,
	"format-letter-ends-with": 987064,
	"format-letter-matches": 987065,
	"format-letter-spacing": 989526,
	"format-letter-starts-with": 987066,
	"format-line-spacing": 983672,
	"format-line-style": 984520,
	"format-line-weight": 984521,
	"format-list-bulleted": 983673,
	"format-list-bulleted-square": 986576,
	"format-list-bulleted-triangle": 986802,
	"format-list-bulleted-type": 983674,
	"format-list-checkbox": 985450,
	"format-list-checks": 984918,
	"format-list-group": 989280,
	"format-list-numbered": 983675,
	"format-list-numbered-rtl": 986381,
	"format-list-text": 987759,
	"format-overline": 986803,
	"format-page-break": 984791,
	"format-page-split": 989463,
	"format-paint": 983676,
	"format-paragraph": 983677,
	"format-pilcrow": 984792,
	"format-quote-close": 983678,
	"format-quote-close-outline": 987560,
	"format-quote-open": 984919,
	"format-quote-open-outline": 987559,
	"format-rotate-90": 984746,
	"format-section": 984735,
	"format-size": 983679,
	"format-strikethrough": 983680,
	"format-strikethrough-variant": 983681,
	"format-subscript": 983682,
	"format-superscript": 983683,
	"format-text": 983684,
	"format-text-rotation-angle-down": 987067,
	"format-text-rotation-angle-up": 987068,
	"format-text-rotation-down": 986483,
	"format-text-rotation-down-vertical": 987069,
	"format-text-rotation-none": 986484,
	"format-text-rotation-up": 987070,
	"format-text-rotation-vertical": 987071,
	"format-text-variant": 986674,
	"format-text-variant-outline": 988431,
	"format-text-wrapping-clip": 986382,
	"format-text-wrapping-overflow": 986383,
	"format-text-wrapping-wrap": 986384,
	"format-textbox": 986385,
	"format-textdirection-l-to-r": 983685,
	"format-textdirection-r-to-l": 983686,
	"format-title": 984564,
	"format-underline": 983687,
	"format-underline-wavy": 989417,
	"format-vertical-align-bottom": 984609,
	"format-vertical-align-center": 984610,
	"format-vertical-align-top": 984611,
	"format-wrap-inline": 983688,
	"format-wrap-square": 983689,
	"format-wrap-tight": 983690,
	"format-wrap-top-bottom": 983691,
	"forum": 983692,
	"forum-outline": 985122,
	"forward": 983693,
	"forwardburger": 986485,
	"fountain": 985451,
	"fountain-pen": 986386,
	"fountain-pen-tip": 986387,
	"fraction-one-half": 989586,
	"freebsd": 985312,
	"french-fries": 989527,
	"frequently-asked-questions": 986804,
	"fridge": 983696,
	"fridge-alert": 987569,
	"fridge-alert-outline": 987570,
	"fridge-bottom": 983698,
	"fridge-industrial": 988654,
	"fridge-industrial-alert": 988655,
	"fridge-industrial-alert-outline": 988656,
	"fridge-industrial-off": 988657,
	"fridge-industrial-off-outline": 988658,
	"fridge-industrial-outline": 988659,
	"fridge-off": 987567,
	"fridge-off-outline": 987568,
	"fridge-outline": 983695,
	"fridge-top": 983697,
	"fridge-variant": 988660,
	"fridge-variant-alert": 988661,
	"fridge-variant-alert-outline": 988662,
	"fridge-variant-off": 988663,
	"fridge-variant-off-outline": 988664,
	"fridge-variant-outline": 988665,
	"fruit-cherries": 987202,
	"fruit-cherries-off": 988152,
	"fruit-citrus": 987203,
	"fruit-citrus-off": 988153,
	"fruit-grapes": 987204,
	"fruit-grapes-outline": 987205,
	"fruit-pineapple": 987206,
	"fruit-watermelon": 987207,
	"fuel": 985034,
	"fuel-cell": 989365,
	"fullscreen": 983699,
	"fullscreen-exit": 983700,
	"function": 983701,
	"function-variant": 985201,
	"furigana-horizontal": 987265,
	"furigana-vertical": 987266,
	"fuse": 986245,
	"fuse-alert": 988205,
	"fuse-blade": 986246,
	"fuse-off": 988204,
	"gamepad": 983702,
	"gamepad-circle": 986675,
	"gamepad-circle-down": 986676,
	"gamepad-circle-left": 986677,
	"gamepad-circle-outline": 986678,
	"gamepad-circle-right": 986679,
	"gamepad-circle-up": 986680,
	"gamepad-down": 986681,
	"gamepad-left": 986682,
	"gamepad-outline": 989465,
	"gamepad-right": 986683,
	"gamepad-round": 986684,
	"gamepad-round-down": 986685,
	"gamepad-round-left": 986686,
	"gamepad-round-outline": 986687,
	"gamepad-round-right": 986688,
	"gamepad-round-up": 986689,
	"gamepad-square": 986805,
	"gamepad-square-outline": 986806,
	"gamepad-up": 986690,
	"gamepad-variant": 983703,
	"gamepad-variant-outline": 986807,
	"gamma": 987374,
	"gantry-crane": 986577,
	"garage": 984793,
	"garage-alert": 985202,
	"garage-alert-variant": 987861,
	"garage-lock": 989179,
	"garage-open": 984794,
	"garage-open-variant": 987860,
	"garage-variant": 987859,
	"garage-variant-lock": 989180,
	"gas-cylinder": 984647,
	"gas-station": 983704,
	"gas-station-off": 988169,
	"gas-station-off-outline": 988170,
	"gas-station-outline": 986808,
	"gate": 983705,
	"gate-alert": 989176,
	"gate-and": 985313,
	"gate-arrow-left": 989175,
	"gate-arrow-right": 987497,
	"gate-nand": 985314,
	"gate-nor": 985315,
	"gate-not": 985316,
	"gate-open": 987498,
	"gate-or": 985317,
	"gate-xnor": 985318,
	"gate-xor": 985319,
	"gatsby": 986691,
	"gauge": 983706,
	"gauge-empty": 985203,
	"gauge-full": 985204,
	"gauge-low": 985205,
	"gavel": 983707,
	"gender-female": 983708,
	"gender-male": 983709,
	"gender-male-female": 983710,
	"gender-male-female-variant": 987455,
	"gender-non-binary": 987456,
	"gender-transgender": 983711,
	"gentoo": 985320,
	"gesture": 985035,
	"gesture-double-tap": 984892,
	"gesture-pinch": 985789,
	"gesture-spread": 985790,
	"gesture-swipe": 986486,
	"gesture-swipe-down": 984893,
	"gesture-swipe-horizontal": 985791,
	"gesture-swipe-left": 984894,
	"gesture-swipe-right": 984895,
	"gesture-swipe-up": 984896,
	"gesture-swipe-vertical": 985792,
	"gesture-tap": 984897,
	"gesture-tap-box": 987817,
	"gesture-tap-button": 987816,
	"gesture-tap-hold": 986487,
	"gesture-two-double-tap": 984898,
	"gesture-two-tap": 984899,
	"ghost": 983712,
	"ghost-off": 985589,
	"ghost-off-outline": 988764,
	"ghost-outline": 988765,
	"gift": 986692,
	"gift-off": 988911,
	"gift-off-outline": 988912,
	"gift-open": 988913,
	"gift-open-outline": 988914,
	"gift-outline": 983713,
	"git": 983714,
	"github": 983716,
	"gitlab": 986016,
	"glass-cocktail": 983894,
	"glass-cocktail-off": 988646,
	"glass-flute": 983717,
	"glass-fragile": 989299,
	"glass-mug": 983718,
	"glass-mug-off": 988647,
	"glass-mug-variant": 987414,
	"glass-mug-variant-off": 988648,
	"glass-pint-outline": 987917,
	"glass-stange": 983719,
	"glass-tulip": 983720,
	"glass-wine": 985206,
	"glasses": 983722,
	"globe-light": 987863,
	"globe-model": 985321,
	"gmail": 983723,
	"gnome": 983724,
	"go-kart": 986489,
	"go-kart-track": 986490,
	"gog": 986017,
	"gold": 987727,
	"golf": 985123,
	"golf-cart": 987556,
	"golf-tee": 987267,
	"gondola": 984710,
	"goodreads": 986491,
	"google": 983725,
	"google-ads": 986247,
	"google-analytics": 985036,
	"google-assistant": 985037,
	"google-cardboard": 983726,
	"google-chrome": 983727,
	"google-circles": 983728,
	"google-circles-communities": 983729,
	"google-circles-extended": 983730,
	"google-circles-group": 983731,
	"google-classroom": 983744,
	"google-cloud": 987638,
	"google-controller": 983732,
	"google-controller-off": 983733,
	"google-downasaur": 988002,
	"google-drive": 983734,
	"google-earth": 983735,
	"google-fit": 985452,
	"google-glass": 983736,
	"google-hangouts": 983753,
	"google-home": 985124,
	"google-keep": 984796,
	"google-lens": 985590,
	"google-maps": 984565,
	"google-my-business": 987208,
	"google-nearby": 983737,
	"google-play": 983740,
	"google-plus": 983741,
	"google-podcast": 986809,
	"google-spreadsheet": 985591,
	"google-street-view": 986248,
	"google-translate": 983743,
	"gradient-horizontal": 989002,
	"gradient-vertical": 984736,
	"grain": 986492,
	"graph": 987209,
	"graph-outline": 987210,
	"graphql": 985207,
	"grass": 988432,
	"grave-stone": 986018,
	"grease-pencil": 984648,
	"greater-than": 985453,
	"greater-than-or-equal": 985454,
	"greenhouse": 983085,
	"grid": 983745,
	"grid-large": 984920,
	"grid-off": 983746,
	"grill": 986693,
	"grill-outline": 987530,
	"group": 983747,
	"guitar-acoustic": 984945,
	"guitar-electric": 983748,
	"guitar-pick": 983749,
	"guitar-pick-outline": 983750,
	"guy-fawkes-mask": 985125,
	"hail": 985793,
	"hair-dryer": 987375,
	"hair-dryer-outline": 987376,
	"halloween": 986019,
	"hamburger": 984709,
	"hamburger-check": 989046,
	"hamburger-minus": 989047,
	"hamburger-off": 989048,
	"hamburger-plus": 989049,
	"hamburger-remove": 989050,
	"hammer": 985322,
	"hammer-screwdriver": 987938,
	"hammer-sickle": 989319,
	"hammer-wrench": 987939,
	"hand-back-left": 986694,
	"hand-back-left-off": 989232,
	"hand-back-left-off-outline": 989234,
	"hand-back-left-outline": 989228,
	"hand-back-right": 986695,
	"hand-back-right-off": 989233,
	"hand-back-right-off-outline": 989235,
	"hand-back-right-outline": 989229,
	"hand-clap": 989515,
	"hand-coin": 989327,
	"hand-coin-outline": 989328,
	"hand-extended": 989366,
	"hand-extended-outline": 989367,
	"hand-front-left": 989227,
	"hand-front-left-outline": 989230,
	"hand-front-right": 985679,
	"hand-front-right-outline": 989231,
	"hand-heart": 987377,
	"hand-heart-outline": 988542,
	"hand-okay": 985680,
	"hand-peace": 985681,
	"hand-peace-variant": 985682,
	"hand-pointing-down": 985683,
	"hand-pointing-left": 985684,
	"hand-pointing-right": 983751,
	"hand-pointing-up": 985685,
	"hand-saw": 986696,
	"hand-wash": 988543,
	"hand-wash-outline": 988544,
	"hand-water": 988063,
	"hand-wave": 989217,
	"hand-wave-outline": 989218,
	"handball": 986963,
	"handcuffs": 987454,
	"hands-pray": 984441,
	"handshake": 987672,
	"handshake-outline": 988577,
	"hanger": 983752,
	"hard-hat": 985455,
	"harddisk": 983754,
	"harddisk-plus": 987211,
	"harddisk-remove": 987212,
	"hat-fedora": 986020,
	"hazard-lights": 986249,
	"hdr": 986493,
	"hdr-off": 986494,
	"head": 987998,
	"head-alert": 987960,
	"head-alert-outline": 987961,
	"head-check": 987962,
	"head-check-outline": 987963,
	"head-cog": 987964,
	"head-cog-outline": 987965,
	"head-dots-horizontal": 987966,
	"head-dots-horizontal-outline": 987967,
	"head-flash": 987968,
	"head-flash-outline": 987969,
	"head-heart": 987970,
	"head-heart-outline": 987971,
	"head-lightbulb": 987972,
	"head-lightbulb-outline": 987973,
	"head-minus": 987974,
	"head-minus-outline": 987975,
	"head-outline": 987999,
	"head-plus": 987976,
	"head-plus-outline": 987977,
	"head-question": 987978,
	"head-question-outline": 987979,
	"head-remove": 987980,
	"head-remove-outline": 987981,
	"head-snowflake": 987982,
	"head-snowflake-outline": 987983,
	"head-sync": 987984,
	"head-sync-outline": 987985,
	"headphones": 983755,
	"headphones-bluetooth": 985456,
	"headphones-box": 983756,
	"headphones-off": 985038,
	"headphones-settings": 983757,
	"headset": 983758,
	"headset-dock": 983759,
	"headset-off": 983760,
	"heart": 983761,
	"heart-box": 983762,
	"heart-box-outline": 983763,
	"heart-broken": 983764,
	"heart-broken-outline": 986388,
	"heart-circle": 985457,
	"heart-circle-outline": 985458,
	"heart-cog": 988771,
	"heart-cog-outline": 988772,
	"heart-flash": 986873,
	"heart-half": 984799,
	"heart-half-full": 984798,
	"heart-half-outline": 984800,
	"heart-minus": 988207,
	"heart-minus-outline": 988210,
	"heart-multiple": 985686,
	"heart-multiple-outline": 985687,
	"heart-off": 984921,
	"heart-off-outline": 988212,
	"heart-outline": 983765,
	"heart-plus": 988206,
	"heart-plus-outline": 988209,
	"heart-pulse": 984566,
	"heart-remove": 988208,
	"heart-remove-outline": 988211,
	"heart-settings": 988773,
	"heart-settings-outline": 988774,
	"helicopter": 985794,
	"help": 983766,
	"help-box": 984971,
	"help-circle": 983767,
	"help-circle-outline": 984613,
	"help-network": 984821,
	"help-network-outline": 986250,
	"help-rhombus": 986021,
	"help-rhombus-outline": 986022,
	"hexadecimal": 987815,
	"hexagon": 983768,
	"hexagon-multiple": 984801,
	"hexagon-multiple-outline": 987378,
	"hexagon-outline": 983769,
	"hexagon-slice-1": 985795,
	"hexagon-slice-2": 985796,
	"hexagon-slice-3": 985797,
	"hexagon-slice-4": 985798,
	"hexagon-slice-5": 985799,
	"hexagon-slice-6": 985800,
	"hexagram": 985801,
	"hexagram-outline": 985802,
	"high-definition": 985039,
	"high-definition-box": 985208,
	"highway": 984567,
	"hiking": 986495,
	"history": 983770,
	"hockey-puck": 985209,
	"hockey-sticks": 985210,
	"hololens": 983771,
	"home": 983772,
	"home-account": 985126,
	"home-alert": 985211,
	"home-alert-outline": 988624,
	"home-analytics": 986810,
	"home-assistant": 985040,
	"home-automation": 985041,
	"home-battery": 989441,
	"home-battery-outline": 989442,
	"home-circle": 985042,
	"home-circle-outline": 987213,
	"home-city": 986389,
	"home-city-outline": 986390,
	"home-edit": 987481,
	"home-edit-outline": 987482,
	"home-export-outline": 987035,
	"home-flood": 986874,
	"home-floor-0": 986578,
	"home-floor-1": 986496,
	"home-floor-2": 986497,
	"home-floor-3": 986498,
	"home-floor-a": 986499,
	"home-floor-b": 986500,
	"home-floor-g": 986501,
	"home-floor-l": 986502,
	"home-floor-negative-1": 986579,
	"home-group": 986580,
	"home-group-minus": 989633,
	"home-group-plus": 989632,
	"home-group-remove": 989634,
	"home-heart": 985127,
	"home-import-outline": 987036,
	"home-lightbulb": 987729,
	"home-lightbulb-outline": 987730,
	"home-lightning-bolt": 989443,
	"home-lightning-bolt-outline": 989444,
	"home-lock": 985323,
	"home-lock-open": 985324,
	"home-map-marker": 984568,
	"home-minus": 985460,
	"home-minus-outline": 988117,
	"home-modern": 983773,
	"home-outline": 984737,
	"home-plus": 985461,
	"home-plus-outline": 988118,
	"home-remove": 987719,
	"home-remove-outline": 988119,
	"home-roof": 987435,
	"home-search": 988080,
	"home-search-outline": 988081,
	"home-switch": 989076,
	"home-switch-outline": 989077,
	"home-thermometer": 986964,
	"home-thermometer-outline": 986965,
	"home-variant": 983774,
	"home-variant-outline": 986023,
	"hook": 984802,
	"hook-off": 984803,
	"hoop-house": 986710,
	"hops": 983775,
	"horizontal-rotate-clockwise": 987379,
	"horizontal-rotate-counterclockwise": 987380,
	"horse": 988607,
	"horse-human": 988608,
	"horse-variant": 988609,
	"horse-variant-fast": 989294,
	"horseshoe": 985688,
	"hospital": 987126,
	"hospital-box": 983776,
	"hospital-box-outline": 987127,
	"hospital-building": 983777,
	"hospital-marker": 983778,
	"hot-tub": 985128,
	"hours-24": 988280,
	"hubspot": 986391,
	"hulu": 985129,
	"human": 983782,
	"human-baby-changing-table": 988043,
	"human-cane": 988545,
	"human-capacity-decrease": 988571,
	"human-capacity-increase": 988572,
	"human-child": 983783,
	"human-dolly": 989568,
	"human-edit": 988392,
	"human-female": 984649,
	"human-female-boy": 985689,
	"human-female-dance": 988617,
	"human-female-female": 985690,
	"human-female-girl": 985691,
	"human-greeting": 989124,
	"human-greeting-proximity": 988573,
	"human-greeting-variant": 984650,
	"human-handsdown": 984651,
	"human-handsup": 984652,
	"human-male": 984653,
	"human-male-board": 985232,
	"human-male-board-poll": 985158,
	"human-male-boy": 985692,
	"human-male-child": 988044,
	"human-male-female": 983784,
	"human-male-female-child": 989219,
	"human-male-girl": 985693,
	"human-male-height": 986875,
	"human-male-height-variant": 986876,
	"human-male-male": 985694,
	"human-non-binary": 989256,
	"human-pregnant": 984527,
	"human-queue": 988529,
	"human-scooter": 987625,
	"human-wheelchair": 988045,
	"human-white-cane": 989569,
	"humble-bundle": 984900,
	"hvac": 987986,
	"hvac-off": 988574,
	"hydraulic-oil-level": 987940,
	"hydraulic-oil-temperature": 987941,
	"hydro-power": 987877,
	"hydrogen-station": 989332,
	"ice-cream": 985130,
	"ice-cream-off": 986706,
	"ice-pop": 986877,
	"id-card": 987072,
	"identifier": 986878,
	"ideogram-cjk": 987953,
	"ideogram-cjk-variant": 987954,
	"image": 983785,
	"image-album": 983786,
	"image-area": 983787,
	"image-area-close": 983788,
	"image-auto-adjust": 987073,
	"image-broken": 983789,
	"image-broken-variant": 983790,
	"image-edit": 987619,
	"image-edit-outline": 987620,
	"image-filter-black-white": 983792,
	"image-filter-center-focus": 983793,
	"image-filter-center-focus-strong": 986879,
	"image-filter-center-focus-strong-outline": 986880,
	"image-filter-center-focus-weak": 983794,
	"image-filter-drama": 983795,
	"image-filter-frames": 983796,
	"image-filter-hdr": 983797,
	"image-filter-none": 983798,
	"image-filter-tilt-shift": 983799,
	"image-filter-vintage": 983800,
	"image-frame": 986697,
	"image-marker": 989051,
	"image-marker-outline": 989052,
	"image-minus": 988185,
	"image-move": 985592,
	"image-multiple": 983801,
	"image-multiple-outline": 983791,
	"image-off": 985131,
	"image-off-outline": 987601,
	"image-outline": 985462,
	"image-plus": 985212,
	"image-remove": 988184,
	"image-search": 985463,
	"image-search-outline": 985464,
	"image-size-select-actual": 986253,
	"image-size-select-large": 986254,
	"image-size-select-small": 986255,
	"image-text": 988685,
	"import": 983802,
	"inbox": 984711,
	"inbox-arrow-down": 983803,
	"inbox-arrow-down-outline": 987760,
	"inbox-arrow-up": 984017,
	"inbox-arrow-up-outline": 987761,
	"inbox-full": 987762,
	"inbox-full-outline": 987763,
	"inbox-multiple": 985264,
	"inbox-multiple-outline": 986024,
	"inbox-outline": 987764,
	"inbox-remove": 988575,
	"inbox-remove-outline": 988576,
	"incognito": 984569,
	"incognito-circle": 988193,
	"incognito-circle-off": 988194,
	"incognito-off": 983157,
	"induction": 989260,
	"infinity": 984804,
	"information": 983804,
	"information-off": 989068,
	"information-off-outline": 989069,
	"information-outline": 983805,
	"information-variant": 984654,
	"instagram": 983806,
	"instrument-triangle": 987214,
	"integrated-circuit-chip": 989459,
	"invert-colors": 983809,
	"invert-colors-off": 986698,
	"iobroker": 987880,
	"ip": 985695,
	"ip-network": 985696,
	"ip-network-outline": 986256,
	"ip-outline": 989570,
	"ipod": 986257,
	"iron": 989220,
	"iron-board": 989240,
	"iron-outline": 989221,
	"island": 987215,
	"iv-bag": 987321,
	"jabber": 986581,
	"jeepney": 983810,
	"jellyfish": 986881,
	"jellyfish-outline": 986882,
	"jira": 983811,
	"jquery": 985213,
	"jsfiddle": 983812,
	"jump-rope": 987903,
	"kabaddi": 986503,
	"kangaroo": 988504,
	"karate": 985132,
	"kayaking": 985263,
	"keg": 983813,
	"kettle": 984570,
	"kettle-alert": 987927,
	"kettle-alert-outline": 987928,
	"kettle-off": 987931,
	"kettle-off-outline": 987932,
	"kettle-outline": 986966,
	"kettle-pour-over": 988988,
	"kettle-steam": 987929,
	"kettle-steam-outline": 987930,
	"kettlebell": 987904,
	"key": 983814,
	"key-alert": 989571,
	"key-alert-outline": 989572,
	"key-arrow-right": 987922,
	"key-chain": 988532,
	"key-chain-variant": 988533,
	"key-change": 983815,
	"key-link": 987551,
	"key-minus": 983816,
	"key-outline": 986582,
	"key-plus": 983817,
	"key-remove": 983818,
	"key-star": 987550,
	"key-variant": 983819,
	"key-wireless": 987074,
	"keyboard": 983820,
	"keyboard-backspace": 983821,
	"keyboard-caps": 983822,
	"keyboard-close": 983823,
	"keyboard-esc": 987831,
	"keyboard-f1": 987819,
	"keyboard-f10": 987828,
	"keyboard-f11": 987829,
	"keyboard-f12": 987830,
	"keyboard-f2": 987820,
	"keyboard-f3": 987821,
	"keyboard-f4": 987822,
	"keyboard-f5": 987823,
	"keyboard-f6": 987824,
	"keyboard-f7": 987825,
	"keyboard-f8": 987826,
	"keyboard-f9": 987827,
	"keyboard-off": 983824,
	"keyboard-off-outline": 986699,
	"keyboard-outline": 985467,
	"keyboard-return": 983825,
	"keyboard-settings": 985593,
	"keyboard-settings-outline": 985594,
	"keyboard-space": 987216,
	"keyboard-tab": 983826,
	"keyboard-tab-reverse": 983845,
	"keyboard-variant": 983827,
	"khanda": 987389,
	"kickstarter": 984901,
	"kite": 989573,
	"kite-outline": 989574,
	"kitesurfing": 988996,
	"klingon": 987995,
	"knife": 985595,
	"knife-military": 985596,
	"koala": 988991,
	"kodi": 983828,
	"kubernetes": 987390,
	"label": 983829,
	"label-multiple": 988021,
	"label-multiple-outline": 988022,
	"label-off": 985803,
	"label-off-outline": 985804,
	"label-outline": 983830,
	"label-percent": 987882,
	"label-percent-outline": 987883,
	"label-variant": 985805,
	"label-variant-outline": 985806,
	"ladder": 988578,
	"ladybug": 985133,
	"lambda": 984615,
	"lamp": 984757,
	"lamp-outline": 989136,
	"lamps": 988534,
	"lamps-outline": 989137,
	"lan": 983831,
	"lan-check": 987818,
	"lan-connect": 983832,
	"lan-disconnect": 983833,
	"lan-pending": 983834,
	"language-c": 984689,
	"language-cpp": 984690,
	"language-csharp": 983835,
	"language-css3": 983836,
	"language-fortran": 987674,
	"language-go": 985043,
	"language-haskell": 986258,
	"language-html5": 983837,
	"language-java": 985911,
	"language-javascript": 983838,
	"language-kotlin": 987673,
	"language-lua": 985265,
	"language-markdown": 983892,
	"language-markdown-outline": 986971,
	"language-php": 983839,
	"language-python": 983840,
	"language-r": 985044,
	"language-ruby": 986413,
	"language-ruby-on-rails": 985807,
	"language-rust": 988695,
	"language-swift": 984805,
	"language-typescript": 984806,
	"language-xaml": 984691,
	"laptop": 983842,
	"laptop-off": 984807,
	"laravel": 985808,
	"laser-pointer": 988292,
	"lasso": 986883,
	"lastpass": 984134,
	"latitude": 986967,
	"launch": 983847,
	"lava-lamp": 985045,
	"layers": 983848,
	"layers-edit": 989330,
	"layers-minus": 986700,
	"layers-off": 983849,
	"layers-off-outline": 985597,
	"layers-outline": 985598,
	"layers-plus": 986701,
	"layers-remove": 986702,
	"layers-search": 987654,
	"layers-search-outline": 987655,
	"layers-triple": 986968,
	"layers-triple-outline": 986969,
	"lead-pencil": 984655,
	"leaf": 983850,
	"leaf-circle": 989445,
	"leaf-circle-outline": 989446,
	"leaf-maple": 986259,
	"leaf-maple-off": 987866,
	"leaf-off": 987865,
	"leak": 986583,
	"leak-off": 986584,
	"led-off": 983851,
	"led-on": 983852,
	"led-outline": 983853,
	"led-strip": 985046,
	"led-strip-variant": 987217,
	"led-variant-off": 983854,
	"led-variant-on": 983855,
	"led-variant-outline": 983856,
	"leek": 987517,
	"less-than": 985468,
	"less-than-or-equal": 985469,
	"library": 983857,
	"library-shelves": 986025,
	"license": 987075,
	"lifebuoy": 985214,
	"light-flood-down": 989575,
	"light-flood-up": 989576,
	"light-recessed": 989083,
	"light-switch": 985470,
	"lightbulb": 983861,
	"lightbulb-auto": 989184,
	"lightbulb-auto-outline": 989185,
	"lightbulb-cfl": 987656,
	"lightbulb-cfl-off": 987657,
	"lightbulb-cfl-spiral": 987765,
	"lightbulb-cfl-spiral-off": 987843,
	"lightbulb-fluorescent-tube": 989188,
	"lightbulb-fluorescent-tube-outline": 989189,
	"lightbulb-group": 987731,
	"lightbulb-group-off": 987853,
	"lightbulb-group-off-outline": 987854,
	"lightbulb-group-outline": 987732,
	"lightbulb-multiple": 987733,
	"lightbulb-multiple-off": 987855,
	"lightbulb-multiple-off-outline": 987856,
	"lightbulb-multiple-outline": 987734,
	"lightbulb-off": 986703,
	"lightbulb-off-outline": 986704,
	"lightbulb-on": 984808,
	"lightbulb-on-outline": 984809,
	"lightbulb-outline": 983862,
	"lightbulb-spot": 989172,
	"lightbulb-spot-off": 989173,
	"lightbulb-variant": 989186,
	"lightbulb-variant-outline": 989187,
	"lighthouse": 985599,
	"lighthouse-on": 985600,
	"lightning-bolt": 988171,
	"lightning-bolt-circle": 985120,
	"lightning-bolt-outline": 988172,
	"line-scan": 984612,
	"lingerie": 988278,
	"link": 983863,
	"link-box": 986394,
	"link-box-outline": 986395,
	"link-box-variant": 986396,
	"link-box-variant-outline": 986397,
	"link-lock": 987322,
	"link-off": 983864,
	"link-plus": 986260,
	"link-variant": 983865,
	"link-variant-minus": 987391,
	"link-variant-off": 983866,
	"link-variant-plus": 987392,
	"link-variant-remove": 987393,
	"linkedin": 983867,
	"linux": 983869,
	"linux-mint": 985325,
	"lipstick": 988085,
	"liquid-spot": 989222,
	"liquor": 989470,
	"list-status": 988587,
	"litecoin": 985697,
	"loading": 984946,
	"location-enter": 987076,
	"location-exit": 987077,
	"lock": 983870,
	"lock-alert": 985326,
	"lock-alert-outline": 988625,
	"lock-check": 988058,
	"lock-check-outline": 988840,
	"lock-clock": 985471,
	"lock-minus": 988841,
	"lock-minus-outline": 988842,
	"lock-off": 988785,
	"lock-off-outline": 988786,
	"lock-open": 983871,
	"lock-open-alert": 988059,
	"lock-open-alert-outline": 988626,
	"lock-open-check": 988060,
	"lock-open-check-outline": 988843,
	"lock-open-minus": 988844,
	"lock-open-minus-outline": 988845,
	"lock-open-outline": 983872,
	"lock-open-plus": 988846,
	"lock-open-plus-outline": 988847,
	"lock-open-remove": 988848,
	"lock-open-remove-outline": 988849,
	"lock-open-variant": 987078,
	"lock-open-variant-outline": 987079,
	"lock-outline": 983873,
	"lock-pattern": 984810,
	"lock-plus": 984571,
	"lock-plus-outline": 988850,
	"lock-question": 985327,
	"lock-remove": 988851,
	"lock-remove-outline": 988852,
	"lock-reset": 984947,
	"lock-smart": 985266,
	"locker": 985047,
	"locker-multiple": 985048,
	"login": 983874,
	"login-variant": 984572,
	"logout": 983875,
	"logout-variant": 984573,
	"longitude": 986970,
	"looks": 983876,
	"lotion": 988546,
	"lotion-outline": 988547,
	"lotion-plus": 988548,
	"lotion-plus-outline": 988549,
	"loupe": 983877,
	"lumx": 983878,
	"lungs": 987268,
	"mace": 989251,
	"magazine-pistol": 983844,
	"magazine-rifle": 983843,
	"magic-staff": 989252,
	"magnet": 983879,
	"magnet-on": 983880,
	"magnify": 983881,
	"magnify-close": 985472,
	"magnify-expand": 989300,
	"magnify-minus": 983882,
	"magnify-minus-cursor": 985698,
	"magnify-minus-outline": 984812,
	"magnify-plus": 983883,
	"magnify-plus-cursor": 985699,
	"magnify-plus-outline": 984813,
	"magnify-remove-cursor": 987660,
	"magnify-remove-outline": 987661,
	"magnify-scan": 987766,
	"mail": 986811,
	"mailbox": 984814,
	"mailbox-open": 986504,
	"mailbox-open-outline": 986505,
	"mailbox-open-up": 986506,
	"mailbox-open-up-outline": 986507,
	"mailbox-outline": 986508,
	"mailbox-up": 986509,
	"mailbox-up-outline": 986510,
	"manjaro": 988682,
	"map": 983885,
	"map-check": 986812,
	"map-check-outline": 986813,
	"map-clock": 986398,
	"map-clock-outline": 986399,
	"map-legend": 985601,
	"map-marker": 983886,
	"map-marker-account": 989411,
	"map-marker-account-outline": 989412,
	"map-marker-alert": 986885,
	"map-marker-alert-outline": 986886,
	"map-marker-check": 986261,
	"map-marker-check-outline": 987899,
	"map-marker-circle": 983887,
	"map-marker-distance": 985328,
	"map-marker-down": 987394,
	"map-marker-left": 987867,
	"map-marker-left-outline": 987869,
	"map-marker-minus": 984656,
	"map-marker-minus-outline": 987897,
	"map-marker-multiple": 983888,
	"map-marker-multiple-outline": 987767,
	"map-marker-off": 983889,
	"map-marker-off-outline": 987901,
	"map-marker-outline": 985049,
	"map-marker-path": 986400,
	"map-marker-plus": 984657,
	"map-marker-plus-outline": 987896,
	"map-marker-question": 986887,
	"map-marker-question-outline": 986888,
	"map-marker-radius": 983890,
	"map-marker-radius-outline": 987900,
	"map-marker-remove": 986889,
	"map-marker-remove-outline": 987898,
	"map-marker-remove-variant": 986890,
	"map-marker-right": 987868,
	"map-marker-right-outline": 987870,
	"map-marker-star": 988680,
	"map-marker-star-outline": 988681,
	"map-marker-up": 987395,
	"map-minus": 985473,
	"map-outline": 985474,
	"map-plus": 985475,
	"map-search": 985476,
	"map-search-outline": 985477,
	"mapbox": 986026,
	"margin": 983891,
	"marker": 984658,
	"marker-cancel": 986585,
	"marker-check": 983893,
	"mastodon": 985809,
	"material-design": 985478,
	"material-ui": 983895,
	"math-compass": 983896,
	"math-cos": 986262,
	"math-integral": 987080,
	"math-integral-box": 987081,
	"math-log": 987269,
	"math-norm": 987082,
	"math-norm-box": 987083,
	"math-sin": 986263,
	"math-tan": 986264,
	"matrix": 984616,
	"medal": 985479,
	"medal-outline": 987942,
	"medical-bag": 984815,
	"meditation": 987515,
	"memory": 983899,
	"menorah": 989140,
	"menorah-fire": 989141,
	"menu": 983900,
	"menu-down": 983901,
	"menu-down-outline": 984758,
	"menu-left": 983902,
	"menu-left-outline": 985602,
	"menu-open": 986027,
	"menu-right": 983903,
	"menu-right-outline": 985603,
	"menu-swap": 985700,
	"menu-swap-outline": 985701,
	"menu-up": 983904,
	"menu-up-outline": 984759,
	"merge": 986972,
	"message": 983905,
	"message-alert": 983906,
	"message-alert-outline": 985604,
	"message-arrow-left": 987890,
	"message-arrow-left-outline": 987891,
	"message-arrow-right": 987892,
	"message-arrow-right-outline": 987893,
	"message-badge": 989505,
	"message-badge-outline": 989506,
	"message-bookmark": 988588,
	"message-bookmark-outline": 988589,
	"message-bulleted": 984738,
	"message-bulleted-off": 984739,
	"message-cog": 984817,
	"message-cog-outline": 987506,
	"message-draw": 983907,
	"message-flash": 988585,
	"message-flash-outline": 988586,
	"message-image": 983908,
	"message-image-outline": 987500,
	"message-lock": 987084,
	"message-lock-outline": 987501,
	"message-minus": 987502,
	"message-minus-outline": 987503,
	"message-off": 988749,
	"message-off-outline": 988750,
	"message-outline": 983909,
	"message-plus": 984659,
	"message-plus-outline": 987323,
	"message-processing": 983910,
	"message-processing-outline": 987504,
	"message-question": 988986,
	"message-question-outline": 988987,
	"message-reply": 983911,
	"message-reply-outline": 988989,
	"message-reply-text": 983912,
	"message-reply-text-outline": 988990,
	"message-settings": 984816,
	"message-settings-outline": 987505,
	"message-star": 984730,
	"message-star-outline": 987728,
	"message-text": 983913,
	"message-text-clock": 987507,
	"message-text-clock-outline": 987508,
	"message-text-lock": 987085,
	"message-text-lock-outline": 987509,
	"message-text-outline": 983914,
	"message-video": 983915,
	"meteor": 984617,
	"metronome": 985050,
	"metronome-tick": 985051,
	"micro-sd": 985052,
	"microphone": 983916,
	"microphone-minus": 985267,
	"microphone-off": 983917,
	"microphone-outline": 983918,
	"microphone-plus": 985268,
	"microphone-question": 989577,
	"microphone-question-outline": 989578,
	"microphone-settings": 983919,
	"microphone-variant": 983920,
	"microphone-variant-off": 983921,
	"microscope": 984660,
	"microsoft": 983922,
	"microsoft-access": 988046,
	"microsoft-azure": 985093,
	"microsoft-azure-devops": 987093,
	"microsoft-bing": 983204,
	"microsoft-dynamics-365": 985480,
	"microsoft-edge": 983529,
	"microsoft-excel": 988047,
	"microsoft-internet-explorer": 983808,
	"microsoft-office": 984006,
	"microsoft-onedrive": 984010,
	"microsoft-onenote": 984903,
	"microsoft-outlook": 986402,
	"microsoft-powerpoint": 988048,
	"microsoft-sharepoint": 988049,
	"microsoft-teams": 983739,
	"microsoft-visual-studio": 984592,
	"microsoft-visual-studio-code": 985630,
	"microsoft-windows": 984499,
	"microsoft-windows-classic": 985633,
	"microsoft-word": 988050,
	"microsoft-xbox": 984505,
	"microsoft-xbox-controller": 984506,
	"microsoft-xbox-controller-battery-alert": 984907,
	"microsoft-xbox-controller-battery-charging": 985634,
	"microsoft-xbox-controller-battery-empty": 984908,
	"microsoft-xbox-controller-battery-full": 984909,
	"microsoft-xbox-controller-battery-low": 984910,
	"microsoft-xbox-controller-battery-medium": 984911,
	"microsoft-xbox-controller-battery-unknown": 984912,
	"microsoft-xbox-controller-menu": 986735,
	"microsoft-xbox-controller-off": 984507,
	"microsoft-xbox-controller-view": 986736,
	"microwave": 986265,
	"microwave-off": 988195,
	"middleware": 986973,
	"middleware-outline": 986974,
	"midi": 985329,
	"midi-port": 985330,
	"mine": 986586,
	"minecraft": 983923,
	"mini-sd": 985605,
	"minidisc": 985606,
	"minus": 983924,
	"minus-box": 983925,
	"minus-box-multiple": 987457,
	"minus-box-multiple-outline": 987458,
	"minus-box-outline": 984818,
	"minus-circle": 983926,
	"minus-circle-multiple": 983898,
	"minus-circle-multiple-outline": 985811,
	"minus-circle-off": 988249,
	"minus-circle-off-outline": 988250,
	"minus-circle-outline": 983927,
	"minus-network": 983928,
	"minus-network-outline": 986266,
	"minus-thick": 988729,
	"mirror": 987645,
	"mirror-rectangle": 989087,
	"mirror-variant": 989088,
	"mixed-martial-arts": 986511,
	"mixed-reality": 985215,
	"molecule": 986028,
	"molecule-co": 987902,
	"molecule-co2": 985060,
	"monitor": 983929,
	"monitor-cellphone": 985481,
	"monitor-cellphone-star": 985482,
	"monitor-dashboard": 985607,
	"monitor-edit": 987846,
	"monitor-eye": 988084,
	"monitor-lock": 986587,
	"monitor-multiple": 983930,
	"monitor-off": 986512,
	"monitor-screenshot": 986705,
	"monitor-share": 988291,
	"monitor-shimmer": 987396,
	"monitor-small": 989302,
	"monitor-speaker": 986975,
	"monitor-speaker-off": 986976,
	"monitor-star": 986588,
	"moon-first-quarter": 986977,
	"moon-full": 986978,
	"moon-last-quarter": 986979,
	"moon-new": 986980,
	"moon-waning-crescent": 986981,
	"moon-waning-gibbous": 986982,
	"moon-waxing-crescent": 986983,
	"moon-waxing-gibbous": 986984,
	"moped": 987270,
	"moped-electric": 988599,
	"moped-electric-outline": 988600,
	"moped-outline": 988601,
	"more": 983931,
	"mortar-pestle": 989000,
	"mortar-pestle-plus": 984049,
	"mosque": 989223,
	"mother-heart": 987924,
	"mother-nurse": 986401,
	"motion": 988594,
	"motion-outline": 988595,
	"motion-pause": 988560,
	"motion-pause-outline": 988562,
	"motion-play": 988559,
	"motion-play-outline": 988561,
	"motion-sensor": 986513,
	"motion-sensor-off": 988213,
	"motorbike": 983932,
	"motorbike-electric": 988602,
	"mouse": 983933,
	"mouse-bluetooth": 985483,
	"mouse-move-down": 988496,
	"mouse-move-up": 988497,
	"mouse-move-vertical": 988498,
	"mouse-off": 983934,
	"mouse-variant": 983935,
	"mouse-variant-off": 983936,
	"move-resize": 984661,
	"move-resize-variant": 984662,
	"movie": 983937,
	"movie-check": 988915,
	"movie-check-outline": 988916,
	"movie-cog": 988917,
	"movie-cog-outline": 988918,
	"movie-edit": 987426,
	"movie-edit-outline": 987427,
	"movie-filter": 987428,
	"movie-filter-outline": 987429,
	"movie-minus": 988919,
	"movie-minus-outline": 988920,
	"movie-off": 988921,
	"movie-off-outline": 988922,
	"movie-open": 987086,
	"movie-open-check": 988923,
	"movie-open-check-outline": 988924,
	"movie-open-cog": 988925,
	"movie-open-cog-outline": 988926,
	"movie-open-edit": 988927,
	"movie-open-edit-outline": 988928,
	"movie-open-minus": 988929,
	"movie-open-minus-outline": 988930,
	"movie-open-off": 988931,
	"movie-open-off-outline": 988932,
	"movie-open-outline": 987087,
	"movie-open-play": 988933,
	"movie-open-play-outline": 988934,
	"movie-open-plus": 988935,
	"movie-open-plus-outline": 988936,
	"movie-open-remove": 988937,
	"movie-open-remove-outline": 988938,
	"movie-open-settings": 988939,
	"movie-open-settings-outline": 988940,
	"movie-open-star": 988941,
	"movie-open-star-outline": 988942,
	"movie-outline": 986589,
	"movie-play": 988943,
	"movie-play-outline": 988944,
	"movie-plus": 988945,
	"movie-plus-outline": 988946,
	"movie-remove": 988947,
	"movie-remove-outline": 988948,
	"movie-roll": 985054,
	"movie-search": 987602,
	"movie-search-outline": 987603,
	"movie-settings": 988949,
	"movie-settings-outline": 988950,
	"movie-star": 988951,
	"movie-star-outline": 988952,
	"mower": 988783,
	"mower-bag": 988784,
	"muffin": 985484,
	"multicast": 989331,
	"multiplication": 983938,
	"multiplication-box": 983939,
	"mushroom": 985055,
	"mushroom-off": 988154,
	"mushroom-off-outline": 988155,
	"mushroom-outline": 985056,
	"music": 984922,
	"music-accidental-double-flat": 986985,
	"music-accidental-double-sharp": 986986,
	"music-accidental-flat": 986987,
	"music-accidental-natural": 986988,
	"music-accidental-sharp": 986989,
	"music-box": 983940,
	"music-box-multiple": 983859,
	"music-box-multiple-outline": 986884,
	"music-box-outline": 983941,
	"music-circle": 983942,
	"music-circle-outline": 985812,
	"music-clef-alto": 986990,
	"music-clef-bass": 986991,
	"music-clef-treble": 986992,
	"music-note": 983943,
	"music-note-bluetooth": 984574,
	"music-note-bluetooth-off": 984575,
	"music-note-eighth": 983944,
	"music-note-eighth-dotted": 986993,
	"music-note-half": 983945,
	"music-note-half-dotted": 986994,
	"music-note-off": 983946,
	"music-note-off-outline": 986995,
	"music-note-outline": 986996,
	"music-note-plus": 986590,
	"music-note-quarter": 983947,
	"music-note-quarter-dotted": 986997,
	"music-note-sixteenth": 983948,
	"music-note-sixteenth-dotted": 986998,
	"music-note-whole": 983949,
	"music-note-whole-dotted": 986999,
	"music-off": 984923,
	"music-rest-eighth": 987000,
	"music-rest-half": 987001,
	"music-rest-quarter": 987002,
	"music-rest-sixteenth": 987003,
	"music-rest-whole": 987004,
	"mustache": 988638,
	"nail": 986591,
	"nas": 985331,
	"nativescript": 985216,
	"nature": 983950,
	"nature-people": 983951,
	"navigation": 983952,
	"navigation-outline": 988679,
	"navigation-variant": 989424,
	"navigation-variant-outline": 989425,
	"near-me": 984525,
	"necklace": 986891,
	"needle": 983953,
	"netflix": 984902,
	"network": 984819,
	"network-off": 986267,
	"network-off-outline": 986268,
	"network-outline": 986269,
	"network-strength-1": 985332,
	"network-strength-1-alert": 985333,
	"network-strength-2": 985334,
	"network-strength-2-alert": 985335,
	"network-strength-3": 985336,
	"network-strength-3-alert": 985337,
	"network-strength-4": 985338,
	"network-strength-4-alert": 985339,
	"network-strength-4-cog": 989466,
	"network-strength-off": 985340,
	"network-strength-off-outline": 985341,
	"network-strength-outline": 985342,
	"new-box": 983956,
	"newspaper": 983957,
	"newspaper-check": 989507,
	"newspaper-minus": 986892,
	"newspaper-plus": 986893,
	"newspaper-remove": 989508,
	"newspaper-variant": 987137,
	"newspaper-variant-multiple": 987138,
	"newspaper-variant-multiple-outline": 987139,
	"newspaper-variant-outline": 987140,
	"nfc": 983958,
	"nfc-search-variant": 986707,
	"nfc-tap": 983959,
	"nfc-variant": 983960,
	"nfc-variant-off": 986708,
	"ninja": 984948,
	"nintendo-game-boy": 988051,
	"nintendo-switch": 985057,
	"nintendo-wii": 984491,
	"nintendo-wiiu": 984877,
	"nix": 987397,
	"nodejs": 983961,
	"noodles": 987518,
	"not-equal": 985485,
	"not-equal-variant": 985486,
	"note": 983962,
	"note-alert": 989053,
	"note-alert-outline": 989054,
	"note-check": 989055,
	"note-check-outline": 989056,
	"note-edit": 989057,
	"note-edit-outline": 989058,
	"note-minus": 988751,
	"note-minus-outline": 988752,
	"note-multiple": 984760,
	"note-multiple-outline": 984761,
	"note-off": 989059,
	"note-off-outline": 989060,
	"note-outline": 983963,
	"note-plus": 983964,
	"note-plus-outline": 983965,
	"note-remove": 988753,
	"note-remove-outline": 988754,
	"note-search": 988755,
	"note-search-outline": 988756,
	"note-text": 983966,
	"note-text-outline": 987607,
	"notebook": 985134,
	"notebook-check": 988405,
	"notebook-check-outline": 988406,
	"notebook-edit": 988391,
	"notebook-edit-outline": 988393,
	"notebook-minus": 988688,
	"notebook-minus-outline": 988689,
	"notebook-multiple": 986709,
	"notebook-outline": 986815,
	"notebook-plus": 988690,
	"notebook-plus-outline": 988691,
	"notebook-remove": 988692,
	"notebook-remove-outline": 988693,
	"notification-clear-all": 983967,
	"npm": 984823,
	"nuke": 984740,
	"null": 985058,
	"numeric": 983968,
	"numeric-0": 985913,
	"numeric-0-box": 983969,
	"numeric-0-box-multiple": 986894,
	"numeric-0-box-multiple-outline": 983970,
	"numeric-0-box-outline": 983971,
	"numeric-0-circle": 986270,
	"numeric-0-circle-outline": 986271,
	"numeric-1": 985914,
	"numeric-1-box": 983972,
	"numeric-1-box-multiple": 986895,
	"numeric-1-box-multiple-outline": 983973,
	"numeric-1-box-outline": 983974,
	"numeric-1-circle": 986272,
	"numeric-1-circle-outline": 986273,
	"numeric-10": 987113,
	"numeric-10-box": 987005,
	"numeric-10-box-multiple": 987114,
	"numeric-10-box-multiple-outline": 987115,
	"numeric-10-box-outline": 987006,
	"numeric-10-circle": 987116,
	"numeric-10-circle-outline": 987117,
	"numeric-2": 985915,
	"numeric-2-box": 983975,
	"numeric-2-box-multiple": 986896,
	"numeric-2-box-multiple-outline": 983976,
	"numeric-2-box-outline": 983977,
	"numeric-2-circle": 986274,
	"numeric-2-circle-outline": 986275,
	"numeric-3": 985916,
	"numeric-3-box": 983978,
	"numeric-3-box-multiple": 986897,
	"numeric-3-box-multiple-outline": 983979,
	"numeric-3-box-outline": 983980,
	"numeric-3-circle": 986276,
	"numeric-3-circle-outline": 986277,
	"numeric-4": 985917,
	"numeric-4-box": 983981,
	"numeric-4-box-multiple": 986898,
	"numeric-4-box-multiple-outline": 983986,
	"numeric-4-box-outline": 983982,
	"numeric-4-circle": 986278,
	"numeric-4-circle-outline": 986279,
	"numeric-5": 985918,
	"numeric-5-box": 983985,
	"numeric-5-box-multiple": 986899,
	"numeric-5-box-multiple-outline": 983983,
	"numeric-5-box-outline": 983984,
	"numeric-5-circle": 986280,
	"numeric-5-circle-outline": 986281,
	"numeric-6": 985919,
	"numeric-6-box": 983987,
	"numeric-6-box-multiple": 986900,
	"numeric-6-box-multiple-outline": 983988,
	"numeric-6-box-outline": 983989,
	"numeric-6-circle": 986282,
	"numeric-6-circle-outline": 986283,
	"numeric-7": 985920,
	"numeric-7-box": 983990,
	"numeric-7-box-multiple": 986901,
	"numeric-7-box-multiple-outline": 983991,
	"numeric-7-box-outline": 983992,
	"numeric-7-circle": 986284,
	"numeric-7-circle-outline": 986285,
	"numeric-8": 985921,
	"numeric-8-box": 983993,
	"numeric-8-box-multiple": 986902,
	"numeric-8-box-multiple-outline": 983994,
	"numeric-8-box-outline": 983995,
	"numeric-8-circle": 986286,
	"numeric-8-circle-outline": 986287,
	"numeric-9": 985922,
	"numeric-9-box": 983996,
	"numeric-9-box-multiple": 986903,
	"numeric-9-box-multiple-outline": 983997,
	"numeric-9-box-outline": 983998,
	"numeric-9-circle": 986288,
	"numeric-9-circle-outline": 986289,
	"numeric-9-plus": 987118,
	"numeric-9-plus-box": 983999,
	"numeric-9-plus-box-multiple": 986904,
	"numeric-9-plus-box-multiple-outline": 984000,
	"numeric-9-plus-box-outline": 984001,
	"numeric-9-plus-circle": 986290,
	"numeric-9-plus-circle-outline": 986291,
	"numeric-negative-1": 987218,
	"numeric-positive-1": 988619,
	"nut": 984824,
	"nutrition": 984002,
	"nuxt": 987398,
	"oar": 984700,
	"ocarina": 986592,
	"oci": 987881,
	"ocr": 987450,
	"octagon": 984003,
	"octagon-outline": 984004,
	"octagram": 984825,
	"octagram-outline": 984949,
	"octahedron": 989520,
	"octahedron-off": 989521,
	"odnoklassniki": 984005,
	"offer": 987675,
	"office-building": 985489,
	"office-building-cog": 989513,
	"office-building-cog-outline": 989514,
	"office-building-marker": 988448,
	"office-building-marker-outline": 988449,
	"office-building-outline": 988447,
	"oil": 984007,
	"oil-lamp": 986905,
	"oil-level": 987219,
	"oil-temperature": 987128,
	"om": 985459,
	"omega": 984009,
	"one-up": 986029,
	"onepassword": 985217,
	"opacity": 984524,
	"open-in-app": 984011,
	"open-in-new": 984012,
	"open-source-initiative": 986030,
	"openid": 984013,
	"opera": 984014,
	"orbit": 983064,
	"orbit-variant": 988635,
	"order-alphabetical-ascending": 983565,
	"order-alphabetical-descending": 986375,
	"order-bool-ascending": 983742,
	"order-bool-ascending-variant": 985487,
	"order-bool-descending": 988036,
	"order-bool-descending-variant": 985488,
	"order-numeric-ascending": 984389,
	"order-numeric-descending": 984390,
	"origin": 985923,
	"ornament": 984015,
	"ornament-variant": 984016,
	"outdoor-lamp": 987220,
	"overscan": 987141,
	"owl": 984018,
	"pac-man": 986031,
	"package": 984019,
	"package-down": 984020,
	"package-up": 984021,
	"package-variant": 984022,
	"package-variant-closed": 984023,
	"page-first": 984576,
	"page-last": 984577,
	"page-layout-body": 984826,
	"page-layout-footer": 984827,
	"page-layout-header": 984828,
	"page-layout-header-footer": 987007,
	"page-layout-sidebar-left": 984829,
	"page-layout-sidebar-right": 984830,
	"page-next": 986032,
	"page-next-outline": 986033,
	"page-previous": 986034,
	"page-previous-outline": 986035,
	"pail": 988183,
	"pail-minus": 988215,
	"pail-minus-outline": 988220,
	"pail-off": 988217,
	"pail-off-outline": 988222,
	"pail-outline": 988218,
	"pail-plus": 988214,
	"pail-plus-outline": 988219,
	"pail-remove": 988216,
	"pail-remove-outline": 988221,
	"palette": 984024,
	"palette-advanced": 984025,
	"palette-outline": 986636,
	"palette-swatch": 985269,
	"palette-swatch-outline": 987996,
	"palette-swatch-variant": 989530,
	"palm-tree": 987221,
	"pan": 986036,
	"pan-bottom-left": 986037,
	"pan-bottom-right": 986038,
	"pan-down": 986039,
	"pan-horizontal": 986040,
	"pan-left": 986041,
	"pan-right": 986042,
	"pan-top-left": 986043,
	"pan-top-right": 986044,
	"pan-up": 986045,
	"pan-vertical": 986046,
	"panda": 984026,
	"pandora": 984027,
	"panorama": 984028,
	"panorama-fisheye": 984029,
	"panorama-horizontal": 989480,
	"panorama-horizontal-outline": 984030,
	"panorama-outline": 989580,
	"panorama-sphere": 989581,
	"panorama-sphere-outline": 989582,
	"panorama-variant": 989583,
	"panorama-variant-outline": 989584,
	"panorama-vertical": 989481,
	"panorama-vertical-outline": 984031,
	"panorama-wide-angle": 989535,
	"panorama-wide-angle-outline": 984032,
	"paper-cut-vertical": 984033,
	"paper-roll": 987479,
	"paper-roll-outline": 987480,
	"paperclip": 984034,
	"parachute": 986292,
	"parachute-outline": 986293,
	"paragliding": 988997,
	"parking": 984035,
	"party-popper": 987222,
	"passport": 985059,
	"passport-biometric": 986593,
	"pasta": 987488,
	"patio-heater": 987008,
	"patreon": 985218,
	"pause": 984036,
	"pause-circle": 984037,
	"pause-circle-outline": 984038,
	"pause-octagon": 984039,
	"pause-octagon-outline": 984040,
	"paw": 984041,
	"paw-off": 984663,
	"paw-off-outline": 988790,
	"paw-outline": 988789,
	"peace": 985220,
	"peanut": 987132,
	"peanut-off": 987133,
	"peanut-off-outline": 987135,
	"peanut-outline": 987134,
	"pen": 984042,
	"pen-lock": 986594,
	"pen-minus": 986595,
	"pen-off": 986596,
	"pen-plus": 986597,
	"pen-remove": 986598,
	"pencil": 984043,
	"pencil-box": 984044,
	"pencil-box-multiple": 987460,
	"pencil-box-multiple-outline": 987461,
	"pencil-box-outline": 984045,
	"pencil-circle": 984831,
	"pencil-circle-outline": 984950,
	"pencil-lock": 984046,
	"pencil-lock-outline": 986599,
	"pencil-minus": 986600,
	"pencil-minus-outline": 986601,
	"pencil-off": 984047,
	"pencil-off-outline": 986602,
	"pencil-outline": 986294,
	"pencil-plus": 986603,
	"pencil-plus-outline": 986604,
	"pencil-remove": 986605,
	"pencil-remove-outline": 986606,
	"pencil-ruler": 987987,
	"penguin": 986816,
	"pentagon": 984833,
	"pentagon-outline": 984832,
	"pentagram": 988775,
	"percent": 984048,
	"percent-outline": 987768,
	"periodic-table": 985270,
	"perspective-less": 986403,
	"perspective-more": 986404,
	"ph": 989125,
	"phone": 984050,
	"phone-alert": 986906,
	"phone-alert-outline": 987534,
	"phone-bluetooth": 984051,
	"phone-bluetooth-outline": 987535,
	"phone-cancel": 987324,
	"phone-cancel-outline": 987536,
	"phone-check": 987561,
	"phone-check-outline": 987562,
	"phone-classic": 984578,
	"phone-classic-off": 987769,
	"phone-dial": 988505,
	"phone-dial-outline": 988506,
	"phone-forward": 984052,
	"phone-forward-outline": 987537,
	"phone-hangup": 984053,
	"phone-hangup-outline": 987538,
	"phone-in-talk": 984054,
	"phone-in-talk-outline": 987522,
	"phone-incoming": 984055,
	"phone-incoming-outline": 987539,
	"phone-lock": 984056,
	"phone-lock-outline": 987540,
	"phone-log": 984057,
	"phone-log-outline": 987541,
	"phone-message": 987542,
	"phone-message-outline": 987543,
	"phone-minus": 984664,
	"phone-minus-outline": 987544,
	"phone-missed": 984058,
	"phone-missed-outline": 987557,
	"phone-off": 986607,
	"phone-off-outline": 987558,
	"phone-outgoing": 984059,
	"phone-outgoing-outline": 987545,
	"phone-outline": 986608,
	"phone-paused": 984060,
	"phone-paused-outline": 987546,
	"phone-plus": 984665,
	"phone-plus-outline": 987547,
	"phone-refresh": 989587,
	"phone-refresh-outline": 989588,
	"phone-remove": 988463,
	"phone-remove-outline": 988464,
	"phone-return": 985135,
	"phone-return-outline": 987548,
	"phone-ring": 987563,
	"phone-ring-outline": 987564,
	"phone-rotate-landscape": 985221,
	"phone-rotate-portrait": 985222,
	"phone-settings": 984061,
	"phone-settings-outline": 987549,
	"phone-sync": 989589,
	"phone-sync-outline": 989590,
	"phone-voip": 984062,
	"pi": 984063,
	"pi-box": 984064,
	"pi-hole": 986609,
	"piano": 984701,
	"piano-off": 984728,
	"pickaxe": 985271,
	"picture-in-picture-bottom-right": 986711,
	"picture-in-picture-bottom-right-outline": 986712,
	"picture-in-picture-top-right": 986713,
	"picture-in-picture-top-right-outline": 986714,
	"pier": 985223,
	"pier-crane": 985224,
	"pig": 984065,
	"pig-variant": 987142,
	"pig-variant-outline": 988792,
	"piggy-bank": 987143,
	"piggy-bank-outline": 988793,
	"pill": 984066,
	"pillar": 984834,
	"pin": 984067,
	"pin-off": 984068,
	"pin-off-outline": 985392,
	"pin-outline": 985393,
	"pine-tree": 984069,
	"pine-tree-box": 984070,
	"pine-tree-fire": 988186,
	"pinterest": 984071,
	"pinwheel": 985813,
	"pinwheel-outline": 985814,
	"pipe": 985061,
	"pipe-disconnected": 985062,
	"pipe-leak": 985225,
	"pipe-valve": 989261,
	"pipe-wrench": 987988,
	"pirate": 985608,
	"pistol": 984835,
	"piston": 985226,
	"pitchfork": 988499,
	"pizza": 984073,
	"play": 984074,
	"play-box": 987770,
	"play-box-multiple": 986393,
	"play-box-multiple-outline": 988134,
	"play-box-outline": 984075,
	"play-circle": 984076,
	"play-circle-outline": 984077,
	"play-network": 985227,
	"play-network-outline": 986295,
	"play-outline": 986907,
	"play-pause": 984078,
	"play-protected-content": 984079,
	"play-speed": 985343,
	"playlist-check": 984519,
	"playlist-edit": 985344,
	"playlist-minus": 984080,
	"playlist-music": 986296,
	"playlist-music-outline": 986297,
	"playlist-play": 984081,
	"playlist-plus": 984082,
	"playlist-remove": 984083,
	"playlist-star": 986610,
	"plex": 984762,
	"pliers": 989604,
	"plus": 984085,
	"plus-box": 984086,
	"plus-box-multiple": 983860,
	"plus-box-multiple-outline": 987459,
	"plus-box-outline": 984836,
	"plus-circle": 984087,
	"plus-circle-multiple": 983884,
	"plus-circle-multiple-outline": 984088,
	"plus-circle-outline": 984089,
	"plus-minus": 985490,
	"plus-minus-box": 985491,
	"plus-minus-variant": 988361,
	"plus-network": 984090,
	"plus-network-outline": 986298,
	"plus-outline": 984837,
	"plus-thick": 987628,
	"podcast": 985492,
	"podium": 986405,
	"podium-bronze": 986406,
	"podium-gold": 986407,
	"podium-silver": 986408,
	"point-of-sale": 986514,
	"pokeball": 984093,
	"pokemon-go": 985609,
	"poker-chip": 985136,
	"polaroid": 984094,
	"police-badge": 987495,
	"police-badge-outline": 987496,
	"police-station": 989241,
	"poll": 984095,
	"polo": 988355,
	"polymer": 984097,
	"pool": 984582,
	"popcorn": 984098,
	"post": 987144,
	"post-outline": 987145,
	"postage-stamp": 986299,
	"pot": 983781,
	"pot-mix": 984667,
	"pot-mix-outline": 984695,
	"pot-outline": 983807,
	"pot-steam": 984666,
	"pot-steam-outline": 983846,
	"pound": 984099,
	"pound-box": 984100,
	"pound-box-outline": 987519,
	"power": 984101,
	"power-cycle": 985345,
	"power-off": 985346,
	"power-on": 985347,
	"power-plug": 984741,
	"power-plug-off": 984742,
	"power-plug-off-outline": 988196,
	"power-plug-outline": 988197,
	"power-settings": 984102,
	"power-sleep": 985348,
	"power-socket": 984103,
	"power-socket-au": 985349,
	"power-socket-ch": 987059,
	"power-socket-de": 987399,
	"power-socket-eu": 985063,
	"power-socket-fr": 987400,
	"power-socket-it": 988415,
	"power-socket-jp": 987401,
	"power-socket-uk": 985064,
	"power-socket-us": 985065,
	"power-standby": 985350,
	"powershell": 985610,
	"prescription": 984838,
	"presentation": 984104,
	"presentation-play": 984105,
	"pretzel": 988514,
	"printer": 984106,
	"printer-3d": 984107,
	"printer-3d-nozzle": 986715,
	"printer-3d-nozzle-alert": 987584,
	"printer-3d-nozzle-alert-outline": 987585,
	"printer-3d-nozzle-heat": 989368,
	"printer-3d-nozzle-heat-outline": 989369,
	"printer-3d-nozzle-outline": 986716,
	"printer-alert": 984108,
	"printer-check": 987462,
	"printer-eye": 988248,
	"printer-off": 986717,
	"printer-off-outline": 989061,
	"printer-outline": 989062,
	"printer-pos": 987223,
	"printer-search": 988247,
	"printer-settings": 984839,
	"printer-wireless": 985611,
	"priority-high": 984579,
	"priority-low": 984580,
	"professional-hexagon": 984109,
	"progress-alert": 986300,
	"progress-check": 985493,
	"progress-clock": 985494,
	"progress-close": 987402,
	"progress-download": 985495,
	"progress-pencil": 989063,
	"progress-question": 988450,
	"progress-star": 989064,
	"progress-upload": 985496,
	"progress-wrench": 986301,
	"projector": 984110,
	"projector-screen": 984111,
	"projector-screen-off": 989197,
	"projector-screen-off-outline": 989198,
	"projector-screen-outline": 988964,
	"projector-screen-variant": 989199,
	"projector-screen-variant-off": 989200,
	"projector-screen-variant-off-outline": 989201,
	"projector-screen-variant-outline": 989202,
	"propane-tank": 987991,
	"propane-tank-outline": 987992,
	"protocol": 987096,
	"publish": 984743,
	"publish-off": 989509,
	"pulse": 984112,
	"pump": 988162,
	"pumpkin": 986047,
	"purse": 986908,
	"purse-outline": 986909,
	"puzzle": 984113,
	"puzzle-check": 988198,
	"puzzle-check-outline": 988199,
	"puzzle-edit": 988371,
	"puzzle-edit-outline": 988377,
	"puzzle-heart": 988372,
	"puzzle-heart-outline": 988378,
	"puzzle-minus": 988369,
	"puzzle-minus-outline": 988375,
	"puzzle-outline": 985702,
	"puzzle-plus": 988368,
	"puzzle-plus-outline": 988374,
	"puzzle-remove": 988370,
	"puzzle-remove-outline": 988376,
	"puzzle-star": 988373,
	"puzzle-star-outline": 988379,
	"pyramid": 989522,
	"pyramid-off": 989523,
	"qi": 985497,
	"qqchat": 984581,
	"qrcode": 984114,
	"qrcode-edit": 985272,
	"qrcode-minus": 987532,
	"qrcode-plus": 987531,
	"qrcode-remove": 987533,
	"qrcode-scan": 984115,
	"quadcopter": 984116,
	"quality-high": 984117,
	"quality-low": 985612,
	"quality-medium": 985613,
	"quora": 986409,
	"rabbit": 985351,
	"racing-helmet": 986515,
	"racquetball": 986516,
	"radar": 984119,
	"radiator": 984120,
	"radiator-disabled": 985815,
	"radiator-off": 985816,
	"radio": 984121,
	"radio-am": 986302,
	"radio-fm": 986303,
	"radio-handheld": 984122,
	"radio-off": 987676,
	"radio-tower": 984123,
	"radioactive": 984124,
	"radioactive-circle": 989277,
	"radioactive-circle-outline": 989278,
	"radioactive-off": 986817,
	"radiobox-blank": 984125,
	"radiobox-marked": 984126,
	"radiology-box": 988357,
	"radiology-box-outline": 988358,
	"radius": 986304,
	"radius-outline": 986305,
	"railroad-light": 986910,
	"rake": 988484,
	"raspberry-pi": 984127,
	"ray-end": 984128,
	"ray-end-arrow": 984129,
	"ray-start": 984130,
	"ray-start-arrow": 984131,
	"ray-start-end": 984132,
	"ray-start-vertex-end": 988632,
	"ray-vertex": 984133,
	"razor-double-edge": 989591,
	"razor-single-edge": 989592,
	"react": 984840,
	"read": 984135,
	"receipt": 984137,
	"record": 984138,
	"record-circle": 986818,
	"record-circle-outline": 986819,
	"record-player": 985498,
	"record-rec": 984139,
	"rectangle": 986718,
	"rectangle-outline": 986719,
	"recycle": 984140,
	"recycle-variant": 988061,
	"reddit": 984141,
	"redhat": 987419,
	"redo": 984142,
	"redo-variant": 984143,
	"reflect-horizontal": 985614,
	"reflect-vertical": 985615,
	"refresh": 984144,
	"refresh-auto": 989426,
	"refresh-circle": 988023,
	"regex": 984145,
	"registered-trademark": 985703,
	"reiterate": 988552,
	"relation-many-to-many": 988310,
	"relation-many-to-one": 988311,
	"relation-many-to-one-or-many": 988312,
	"relation-many-to-only-one": 988313,
	"relation-many-to-zero-or-many": 988314,
	"relation-many-to-zero-or-one": 988315,
	"relation-one-or-many-to-many": 988316,
	"relation-one-or-many-to-one": 988317,
	"relation-one-or-many-to-one-or-many": 988318,
	"relation-one-or-many-to-only-one": 988319,
	"relation-one-or-many-to-zero-or-many": 988320,
	"relation-one-or-many-to-zero-or-one": 988321,
	"relation-one-to-many": 988322,
	"relation-one-to-one": 988323,
	"relation-one-to-one-or-many": 988324,
	"relation-one-to-only-one": 988325,
	"relation-one-to-zero-or-many": 988326,
	"relation-one-to-zero-or-one": 988327,
	"relation-only-one-to-many": 988328,
	"relation-only-one-to-one": 988329,
	"relation-only-one-to-one-or-many": 988330,
	"relation-only-one-to-only-one": 988331,
	"relation-only-one-to-zero-or-many": 988332,
	"relation-only-one-to-zero-or-one": 988333,
	"relation-zero-or-many-to-many": 988334,
	"relation-zero-or-many-to-one": 988335,
	"relation-zero-or-many-to-one-or-many": 988336,
	"relation-zero-or-many-to-only-one": 988337,
	"relation-zero-or-many-to-zero-or-many": 988338,
	"relation-zero-or-many-to-zero-or-one": 988339,
	"relation-zero-or-one-to-many": 988340,
	"relation-zero-or-one-to-one": 988341,
	"relation-zero-or-one-to-one-or-many": 988342,
	"relation-zero-or-one-to-only-one": 988343,
	"relation-zero-or-one-to-zero-or-many": 988344,
	"relation-zero-or-one-to-zero-or-one": 988345,
	"relative-scale": 984146,
	"reload": 984147,
	"reload-alert": 987403,
	"reminder": 985228,
	"remote": 984148,
	"remote-desktop": 985273,
	"remote-off": 986820,
	"remote-tv": 986821,
	"remote-tv-off": 986822,
	"rename-box": 984149,
	"reorder-horizontal": 984712,
	"reorder-vertical": 984713,
	"repeat": 984150,
	"repeat-off": 984151,
	"repeat-once": 984152,
	"repeat-variant": 984391,
	"replay": 984153,
	"reply": 984154,
	"reply-all": 984155,
	"reply-all-outline": 986911,
	"reply-circle": 987566,
	"reply-outline": 986912,
	"reproduction": 984156,
	"resistor": 985924,
	"resistor-nodes": 985925,
	"resize": 985704,
	"resize-bottom-right": 984157,
	"responsive": 984158,
	"restart": 984841,
	"restart-alert": 987404,
	"restart-off": 986517,
	"restore": 985499,
	"restore-alert": 987405,
	"rewind": 984159,
	"rewind-10": 986410,
	"rewind-15": 989510,
	"rewind-30": 986518,
	"rewind-5": 987641,
	"rewind-60": 988684,
	"rewind-outline": 984842,
	"rhombus": 984843,
	"rhombus-medium": 985616,
	"rhombus-medium-outline": 988380,
	"rhombus-outline": 984844,
	"rhombus-split": 985617,
	"rhombus-split-outline": 988381,
	"ribbon": 984160,
	"rice": 985066,
	"rickshaw": 988603,
	"rickshaw-electric": 988604,
	"ring": 985067,
	"rivet": 986720,
	"road": 984161,
	"road-variant": 984162,
	"robber": 987224,
	"robot": 984745,
	"robot-angry": 988829,
	"robot-angry-outline": 988830,
	"robot-confused": 988831,
	"robot-confused-outline": 988832,
	"robot-dead": 988833,
	"robot-dead-outline": 988834,
	"robot-excited": 988835,
	"robot-excited-outline": 988836,
	"robot-happy": 988953,
	"robot-happy-outline": 988954,
	"robot-industrial": 985926,
	"robot-love": 988837,
	"robot-love-outline": 988838,
	"robot-mower": 987639,
	"robot-mower-outline": 987635,
	"robot-off": 988839,
	"robot-off-outline": 988795,
	"robot-outline": 988794,
	"robot-vacuum": 984845,
	"robot-vacuum-variant": 985352,
	"rocket": 984163,
	"rocket-launch": 988382,
	"rocket-launch-outline": 988383,
	"rocket-outline": 988079,
	"rodent": 987943,
	"roller-skate": 986411,
	"roller-skate-off": 983365,
	"rollerblade": 986412,
	"rollerblade-off": 983086,
	"rollupjs": 986048,
	"roman-numeral-1": 987272,
	"roman-numeral-10": 987281,
	"roman-numeral-2": 987273,
	"roman-numeral-3": 987274,
	"roman-numeral-4": 987275,
	"roman-numeral-5": 987276,
	"roman-numeral-6": 987277,
	"roman-numeral-7": 987278,
	"roman-numeral-8": 987279,
	"roman-numeral-9": 987280,
	"room-service": 985229,
	"room-service-outline": 986519,
	"rotate-360": 989593,
	"rotate-3d": 986823,
	"rotate-3d-variant": 984164,
	"rotate-left": 984165,
	"rotate-left-variant": 984166,
	"rotate-orbit": 986520,
	"rotate-right": 984167,
	"rotate-right-variant": 984168,
	"rounded-corner": 984583,
	"router": 987618,
	"router-network": 987271,
	"router-wireless": 984169,
	"router-wireless-off": 988579,
	"router-wireless-settings": 985705,
	"routes": 984170,
	"routes-clock": 987225,
	"rowing": 984584,
	"rss": 984171,
	"rss-box": 984172,
	"rss-off": 986913,
	"rug": 988277,
	"rugby": 986521,
	"ruler": 984173,
	"ruler-square": 986306,
	"ruler-square-compass": 986814,
	"run": 984846,
	"run-fast": 984174,
	"rv-truck": 987604,
	"sack": 986414,
	"sack-percent": 986415,
	"safe": 985706,
	"safe-square": 987772,
	"safe-square-outline": 987773,
	"safety-goggles": 986416,
	"sail-boat": 986824,
	"sale": 984175,
	"salesforce": 985230,
	"sass": 985068,
	"satellite": 984176,
	"satellite-uplink": 985353,
	"satellite-variant": 984177,
	"sausage": 985274,
	"sausage-off": 989065,
	"saw-blade": 986721,
	"sawtooth-wave": 988282,
	"saxophone": 984585,
	"scale": 984178,
	"scale-balance": 984529,
	"scale-bathroom": 984179,
	"scale-off": 987226,
	"scale-unbalanced": 989624,
	"scan-helper": 988120,
	"scanner": 984747,
	"scanner-off": 985354,
	"scatter-plot": 986825,
	"scatter-plot-outline": 986826,
	"scent": 989528,
	"scent-off": 989529,
	"school": 984180,
	"school-outline": 987520,
	"scissors-cutting": 985707,
	"scooter": 988605,
	"scooter-electric": 988606,
	"scoreboard": 987774,
	"scoreboard-outline": 987775,
	"screen-rotation": 984181,
	"screen-rotation-lock": 984184,
	"screw-flat-top": 986611,
	"screw-lag": 986612,
	"screw-machine-flat-top": 986613,
	"screw-machine-round-top": 986614,
	"screw-round-top": 986615,
	"screwdriver": 984182,
	"script": 986049,
	"script-outline": 984183,
	"script-text": 986050,
	"script-text-key": 988965,
	"script-text-key-outline": 988966,
	"script-text-outline": 986051,
	"script-text-play": 988967,
	"script-text-play-outline": 988968,
	"sd": 984185,
	"seal": 984186,
	"seal-variant": 987097,
	"search-web": 984847,
	"seat": 986307,
	"seat-flat": 984187,
	"seat-flat-angled": 984188,
	"seat-individual-suite": 984189,
	"seat-legroom-extra": 984190,
	"seat-legroom-normal": 984191,
	"seat-legroom-reduced": 984192,
	"seat-outline": 986308,
	"seat-passenger": 987721,
	"seat-recline-extra": 984193,
	"seat-recline-normal": 984194,
	"seatbelt": 986309,
	"security": 984195,
	"security-network": 984196,
	"seed": 986722,
	"seed-off": 988157,
	"seed-off-outline": 988158,
	"seed-outline": 986723,
	"seesaw": 988580,
	"segment": 986827,
	"select": 984197,
	"select-all": 984198,
	"select-color": 986417,
	"select-compare": 985817,
	"select-drag": 985708,
	"select-group": 987010,
	"select-inverse": 984199,
	"select-marker": 987776,
	"select-multiple": 987777,
	"select-multiple-marker": 987778,
	"select-off": 984200,
	"select-place": 987098,
	"select-remove": 989121,
	"select-search": 987652,
	"selection": 984201,
	"selection-drag": 985709,
	"selection-ellipse": 986418,
	"selection-ellipse-arrow-inside": 986914,
	"selection-ellipse-remove": 989122,
	"selection-marker": 987779,
	"selection-multiple": 987781,
	"selection-multiple-marker": 987780,
	"selection-off": 984951,
	"selection-remove": 989123,
	"selection-search": 987653,
	"semantic-web": 987926,
	"send": 984202,
	"send-check": 987489,
	"send-check-outline": 987490,
	"send-circle": 986616,
	"send-circle-outline": 986617,
	"send-clock": 987491,
	"send-clock-outline": 987492,
	"send-lock": 985069,
	"send-lock-outline": 987494,
	"send-outline": 987493,
	"serial-port": 984668,
	"server": 984203,
	"server-minus": 984204,
	"server-network": 984205,
	"server-network-off": 984206,
	"server-off": 984207,
	"server-plus": 984208,
	"server-remove": 984209,
	"server-security": 984210,
	"set-all": 984952,
	"set-center": 984953,
	"set-center-right": 984954,
	"set-left": 984955,
	"set-left-center": 984956,
	"set-left-right": 984957,
	"set-merge": 988384,
	"set-none": 984958,
	"set-right": 984959,
	"set-split": 988385,
	"set-square": 988253,
	"set-top-box": 985503,
	"settings-helper": 985710,
	"shaker": 987406,
	"shaker-outline": 987407,
	"shape": 985137,
	"shape-circle-plus": 984669,
	"shape-outline": 985138,
	"shape-oval-plus": 987642,
	"shape-plus": 984213,
	"shape-polygon-plus": 984670,
	"shape-rectangle-plus": 984671,
	"shape-square-plus": 984672,
	"shape-square-rounded-plus": 988410,
	"share": 984214,
	"share-all": 987636,
	"share-all-outline": 987637,
	"share-circle": 987565,
	"share-off": 986915,
	"share-off-outline": 986916,
	"share-outline": 985394,
	"share-variant": 984215,
	"share-variant-outline": 988436,
	"shark": 989370,
	"shark-fin": 988787,
	"shark-fin-outline": 988788,
	"shark-off": 989371,
	"sheep": 986310,
	"shield": 984216,
	"shield-account": 985231,
	"shield-account-outline": 985618,
	"shield-account-variant": 988583,
	"shield-account-variant-outline": 988584,
	"shield-airplane": 984763,
	"shield-airplane-outline": 986311,
	"shield-alert": 986828,
	"shield-alert-outline": 986829,
	"shield-bug": 988122,
	"shield-bug-outline": 988123,
	"shield-car": 987011,
	"shield-check": 984421,
	"shield-check-outline": 986312,
	"shield-cross": 986313,
	"shield-cross-outline": 986314,
	"shield-crown": 989372,
	"shield-crown-outline": 989373,
	"shield-edit": 987552,
	"shield-edit-outline": 987553,
	"shield-half": 988000,
	"shield-half-full": 984960,
	"shield-home": 984714,
	"shield-home-outline": 986315,
	"shield-key": 986052,
	"shield-key-outline": 986053,
	"shield-link-variant": 986419,
	"shield-link-variant-outline": 986420,
	"shield-lock": 985501,
	"shield-lock-open": 989594,
	"shield-lock-open-outline": 989595,
	"shield-lock-outline": 986316,
	"shield-moon": 989224,
	"shield-moon-outline": 989225,
	"shield-off": 985502,
	"shield-off-outline": 985500,
	"shield-outline": 984217,
	"shield-plus": 985818,
	"shield-plus-outline": 985819,
	"shield-refresh": 983210,
	"shield-refresh-outline": 983520,
	"shield-remove": 985820,
	"shield-remove-outline": 985821,
	"shield-search": 986522,
	"shield-star": 987451,
	"shield-star-outline": 987452,
	"shield-sun": 987229,
	"shield-sun-outline": 987230,
	"shield-sword": 989374,
	"shield-sword-outline": 989375,
	"shield-sync": 987554,
	"shield-sync-outline": 987555,
	"shimmer": 988485,
	"ship-wheel": 985139,
	"shipping-pallet": 989262,
	"shoe-ballet": 988618,
	"shoe-cleat": 988615,
	"shoe-formal": 985927,
	"shoe-heel": 985928,
	"shoe-print": 986618,
	"shoe-sneaker": 988616,
	"shopping": 984218,
	"shopping-music": 984219,
	"shopping-outline": 987605,
	"shopping-search": 987012,
	"shore": 988409,
	"shovel": 984848,
	"shovel-off": 984849,
	"shower": 985504,
	"shower-head": 985505,
	"shredder": 984220,
	"shuffle": 984221,
	"shuffle-disabled": 984222,
	"shuffle-variant": 984223,
	"shuriken": 988031,
	"sickle": 989376,
	"sigma": 984224,
	"sigma-lower": 984619,
	"sign-caution": 984225,
	"sign-direction": 984961,
	"sign-direction-minus": 987136,
	"sign-direction-plus": 987100,
	"sign-direction-remove": 987101,
	"sign-pole": 988408,
	"sign-real-estate": 987416,
	"sign-text": 984962,
	"signal": 984226,
	"signal-2g": 984850,
	"signal-3g": 984851,
	"signal-4g": 984852,
	"signal-5g": 985711,
	"signal-cellular-1": 985276,
	"signal-cellular-2": 985277,
	"signal-cellular-3": 985278,
	"signal-cellular-outline": 985279,
	"signal-distance-variant": 986724,
	"signal-hspa": 984853,
	"signal-hspa-plus": 984854,
	"signal-off": 984963,
	"signal-variant": 984586,
	"signature": 986619,
	"signature-freehand": 986620,
	"signature-image": 986621,
	"signature-text": 986622,
	"silo": 985929,
	"silverware": 984227,
	"silverware-clean": 987102,
	"silverware-fork": 984228,
	"silverware-fork-knife": 985712,
	"silverware-spoon": 984229,
	"silverware-variant": 984230,
	"sim": 984231,
	"sim-alert": 984232,
	"sim-alert-outline": 988627,
	"sim-off": 984233,
	"sim-off-outline": 988628,
	"sim-outline": 988629,
	"simple-icons": 987933,
	"sina-weibo": 985823,
	"sine-wave": 985435,
	"sitemap": 984234,
	"sitemap-outline": 989596,
	"size-l": 988070,
	"size-m": 988069,
	"size-s": 988068,
	"size-xl": 988071,
	"size-xs": 988067,
	"size-xxl": 988072,
	"size-xxs": 988066,
	"size-xxxl": 988073,
	"skate": 986421,
	"skate-off": 984729,
	"skateboard": 988354,
	"skateboarding": 984321,
	"skew-less": 986422,
	"skew-more": 986423,
	"ski": 987908,
	"ski-cross-country": 987909,
	"ski-water": 987910,
	"skip-backward": 984235,
	"skip-backward-outline": 986917,
	"skip-forward": 984236,
	"skip-forward-outline": 986918,
	"skip-next": 984237,
	"skip-next-circle": 984673,
	"skip-next-circle-outline": 984674,
	"skip-next-outline": 986919,
	"skip-previous": 984238,
	"skip-previous-circle": 984675,
	"skip-previous-circle-outline": 984676,
	"skip-previous-outline": 986920,
	"skull": 984716,
	"skull-crossbones": 986054,
	"skull-crossbones-outline": 986055,
	"skull-outline": 986056,
	"skull-scan": 988359,
	"skull-scan-outline": 988360,
	"skype": 984239,
	"skype-business": 984240,
	"slack": 984241,
	"slash-forward": 987103,
	"slash-forward-box": 987104,
	"sledding": 984091,
	"sleep": 984242,
	"sleep-off": 984243,
	"slide": 988581,
	"slope-downhill": 986623,
	"slope-uphill": 986624,
	"slot-machine": 987412,
	"slot-machine-outline": 987413,
	"smart-card": 987325,
	"smart-card-off": 989431,
	"smart-card-off-outline": 989432,
	"smart-card-outline": 987326,
	"smart-card-reader": 987327,
	"smart-card-reader-outline": 987328,
	"smog": 985713,
	"smoke": 989081,
	"smoke-detector": 983954,
	"smoke-detector-alert": 989486,
	"smoke-detector-alert-outline": 989487,
	"smoke-detector-off": 989193,
	"smoke-detector-off-outline": 989194,
	"smoke-detector-outline": 989192,
	"smoke-detector-variant": 989195,
	"smoke-detector-variant-alert": 989488,
	"smoke-detector-variant-off": 989196,
	"smoking": 984244,
	"smoking-off": 984245,
	"smoking-pipe": 988173,
	"smoking-pipe-off": 988200,
	"snail": 988791,
	"snake": 988430,
	"snapchat": 984246,
	"snowboard": 987911,
	"snowflake": 984855,
	"snowflake-alert": 986921,
	"snowflake-melt": 987851,
	"snowflake-off": 988387,
	"snowflake-variant": 986922,
	"snowman": 984247,
	"snowmobile": 984797,
	"soccer": 984248,
	"soccer-field": 985140,
	"social-distance-2-meters": 988537,
	"social-distance-6-feet": 988538,
	"sofa": 984249,
	"sofa-outline": 988525,
	"sofa-single": 988526,
	"sofa-single-outline": 988527,
	"solar-panel": 986523,
	"solar-panel-large": 986524,
	"solar-power": 985714,
	"soldering-iron": 987282,
	"solid": 984717,
	"sony-playstation": 984084,
	"sort": 984250,
	"sort-alphabetical-ascending": 984509,
	"sort-alphabetical-ascending-variant": 987464,
	"sort-alphabetical-descending": 984511,
	"sort-alphabetical-descending-variant": 987465,
	"sort-alphabetical-variant": 984251,
	"sort-ascending": 984252,
	"sort-bool-ascending": 988037,
	"sort-bool-ascending-variant": 988038,
	"sort-bool-descending": 988039,
	"sort-bool-descending-variant": 988040,
	"sort-calendar-ascending": 988487,
	"sort-calendar-descending": 988488,
	"sort-clock-ascending": 988489,
	"sort-clock-ascending-outline": 988490,
	"sort-clock-descending": 988491,
	"sort-clock-descending-outline": 988492,
	"sort-descending": 984253,
	"sort-numeric-ascending": 988041,
	"sort-numeric-ascending-variant": 985357,
	"sort-numeric-descending": 988042,
	"sort-numeric-descending-variant": 985810,
	"sort-numeric-variant": 984254,
	"sort-reverse-variant": 983868,
	"sort-variant": 984255,
	"sort-variant-lock": 986317,
	"sort-variant-lock-open": 986318,
	"sort-variant-remove": 987463,
	"soundbar": 989147,
	"soundcloud": 984256,
	"source-branch": 984620,
	"source-branch-check": 988367,
	"source-branch-minus": 988363,
	"source-branch-plus": 988362,
	"source-branch-refresh": 988365,
	"source-branch-remove": 988364,
	"source-branch-sync": 988366,
	"source-commit": 984856,
	"source-commit-end": 984857,
	"source-commit-end-local": 984858,
	"source-commit-local": 984859,
	"source-commit-next-local": 984860,
	"source-commit-start": 984861,
	"source-commit-start-next-local": 984862,
	"source-fork": 984257,
	"source-merge": 984621,
	"source-pull": 984258,
	"source-repository": 986319,
	"source-repository-multiple": 986320,
	"soy-sauce": 985070,
	"soy-sauce-off": 988156,
	"spa": 986321,
	"spa-outline": 986322,
	"space-invaders": 986057,
	"space-station": 988035,
	"spade": 986725,
	"speaker": 984259,
	"speaker-bluetooth": 985506,
	"speaker-multiple": 986424,
	"speaker-off": 984260,
	"speaker-wireless": 984863,
	"spear": 989253,
	"speedometer": 984261,
	"speedometer-medium": 987013,
	"speedometer-slow": 987014,
	"spellcheck": 984262,
	"sphere": 989524,
	"sphere-off": 989525,
	"spider": 987626,
	"spider-thread": 987627,
	"spider-web": 986058,
	"spirit-level": 988401,
	"spoon-sugar": 988201,
	"spotify": 984263,
	"spotlight": 984264,
	"spotlight-beam": 984265,
	"spray": 984677,
	"spray-bottle": 985824,
	"sprinkler": 987231,
	"sprinkler-fire": 989597,
	"sprinkler-variant": 987232,
	"sprout": 986726,
	"sprout-outline": 986727,
	"square": 984932,
	"square-circle": 988416,
	"square-edit-outline": 985356,
	"square-medium": 985619,
	"square-medium-outline": 985620,
	"square-off": 987886,
	"square-off-outline": 987887,
	"square-opacity": 989268,
	"square-outline": 984931,
	"square-root": 984964,
	"square-root-box": 985507,
	"square-rounded": 988411,
	"square-rounded-outline": 988412,
	"square-small": 985621,
	"square-wave": 988283,
	"squeegee": 985825,
	"ssh": 985280,
	"stack-exchange": 984587,
	"stack-overflow": 984268,
	"stackpath": 983897,
	"stadium": 987129,
	"stadium-variant": 984864,
	"stairs": 984269,
	"stairs-box": 988062,
	"stairs-down": 987838,
	"stairs-up": 987837,
	"stamper": 986425,
	"standard-definition": 985071,
	"star": 984270,
	"star-box": 985715,
	"star-box-multiple": 987782,
	"star-box-multiple-outline": 987783,
	"star-box-outline": 985716,
	"star-check": 988518,
	"star-check-outline": 988522,
	"star-circle": 984271,
	"star-circle-outline": 985508,
	"star-cog": 988776,
	"star-cog-outline": 988777,
	"star-crescent": 985465,
	"star-david": 985466,
	"star-face": 985509,
	"star-four-points": 985826,
	"star-four-points-outline": 985827,
	"star-half": 983622,
	"star-half-full": 984272,
	"star-minus": 988516,
	"star-minus-outline": 988520,
	"star-off": 984273,
	"star-off-outline": 988507,
	"star-outline": 984274,
	"star-plus": 988515,
	"star-plus-outline": 988519,
	"star-remove": 988517,
	"star-remove-outline": 988521,
	"star-settings": 988778,
	"star-settings-outline": 988779,
	"star-shooting": 988993,
	"star-shooting-outline": 988994,
	"star-three-points": 985828,
	"star-three-points-outline": 985829,
	"state-machine": 987631,
	"steam": 984275,
	"steering": 984276,
	"steering-off": 985358,
	"step-backward": 984277,
	"step-backward-2": 984278,
	"step-forward": 984279,
	"step-forward-2": 984280,
	"stethoscope": 984281,
	"sticker": 988004,
	"sticker-alert": 988005,
	"sticker-alert-outline": 988006,
	"sticker-check": 988007,
	"sticker-check-outline": 988008,
	"sticker-circle-outline": 984528,
	"sticker-emoji": 984965,
	"sticker-minus": 988009,
	"sticker-minus-outline": 988010,
	"sticker-outline": 988011,
	"sticker-plus": 988012,
	"sticker-plus-outline": 988013,
	"sticker-remove": 988014,
	"sticker-remove-outline": 988015,
	"sticker-text": 989070,
	"sticker-text-outline": 989071,
	"stocking": 984282,
	"stomach": 987283,
	"stool": 989533,
	"stool-outline": 989534,
	"stop": 984283,
	"stop-circle": 984678,
	"stop-circle-outline": 984679,
	"store": 984284,
	"store-24-hour": 984285,
	"store-alert": 989377,
	"store-alert-outline": 989378,
	"store-check": 989379,
	"store-check-outline": 989380,
	"store-clock": 989381,
	"store-clock-outline": 989382,
	"store-cog": 989383,
	"store-cog-outline": 989384,
	"store-edit": 989385,
	"store-edit-outline": 989386,
	"store-marker": 989387,
	"store-marker-outline": 989388,
	"store-minus": 988766,
	"store-minus-outline": 989389,
	"store-off": 989390,
	"store-off-outline": 989391,
	"store-outline": 988001,
	"store-plus": 988767,
	"store-plus-outline": 989392,
	"store-remove": 988768,
	"store-remove-outline": 989393,
	"store-search": 989394,
	"store-search-outline": 989395,
	"store-settings": 989396,
	"store-settings-outline": 989397,
	"storefront": 985031,
	"storefront-outline": 987329,
	"stove": 984286,
	"strategy": 987606,
	"stretch-to-page": 986923,
	"stretch-to-page-outline": 986924,
	"string-lights": 987834,
	"string-lights-off": 987835,
	"subdirectory-arrow-left": 984588,
	"subdirectory-arrow-right": 984589,
	"submarine": 988524,
	"subtitles": 985622,
	"subtitles-outline": 985623,
	"subway": 984748,
	"subway-alert-variant": 986525,
	"subway-variant": 984287,
	"summit": 984966,
	"sun-compass": 989605,
	"sun-snowflake": 989078,
	"sun-thermometer": 989398,
	"sun-thermometer-outline": 989399,
	"sun-wireless": 989182,
	"sun-wireless-outline": 989183,
	"sunglasses": 984288,
	"surfing": 988998,
	"surround-sound": 984517,
	"surround-sound-2-0": 985072,
	"surround-sound-2-1": 988969,
	"surround-sound-3-1": 985073,
	"surround-sound-5-1": 985074,
	"surround-sound-5-1-2": 988970,
	"surround-sound-7-1": 985075,
	"svg": 984865,
	"swap-horizontal": 984289,
	"swap-horizontal-bold": 986061,
	"swap-horizontal-circle": 987105,
	"swap-horizontal-circle-outline": 987106,
	"swap-horizontal-variant": 985281,
	"swap-vertical": 984290,
	"swap-vertical-bold": 986062,
	"swap-vertical-circle": 987107,
	"swap-vertical-circle-outline": 987108,
	"swap-vertical-variant": 985282,
	"swim": 984291,
	"switch": 984292,
	"sword": 984293,
	"sword-cross": 984967,
	"syllabary-hangul": 987955,
	"syllabary-hiragana": 987956,
	"syllabary-katakana": 987957,
	"syllabary-katakana-halfwidth": 987958,
	"symbol": 988417,
	"symfony": 985830,
	"sync": 984294,
	"sync-alert": 984295,
	"sync-circle": 988024,
	"sync-off": 984296,
	"tab": 984297,
	"tab-minus": 985931,
	"tab-plus": 984924,
	"tab-remove": 985932,
	"tab-search": 989598,
	"tab-unselected": 984298,
	"table": 984299,
	"table-account": 988089,
	"table-alert": 988090,
	"table-arrow-down": 988091,
	"table-arrow-left": 988092,
	"table-arrow-right": 988093,
	"table-arrow-up": 988094,
	"table-border": 985624,
	"table-cancel": 988095,
	"table-chair": 987233,
	"table-check": 988096,
	"table-clock": 988097,
	"table-cog": 988098,
	"table-column": 985141,
	"table-column-plus-after": 984300,
	"table-column-plus-before": 984301,
	"table-column-remove": 984302,
	"table-column-width": 984303,
	"table-edit": 984304,
	"table-eye": 987284,
	"table-eye-off": 988099,
	"table-furniture": 984508,
	"table-headers-eye": 987677,
	"table-headers-eye-off": 987678,
	"table-heart": 988100,
	"table-key": 988101,
	"table-large": 984305,
	"table-large-plus": 987015,
	"table-large-remove": 987016,
	"table-lock": 988102,
	"table-merge-cells": 985510,
	"table-minus": 988103,
	"table-multiple": 988104,
	"table-network": 988105,
	"table-of-contents": 985142,
	"table-off": 988106,
	"table-picnic": 988995,
	"table-pivot": 989244,
	"table-plus": 985717,
	"table-refresh": 988064,
	"table-remove": 985718,
	"table-row": 985143,
	"table-row-height": 984306,
	"table-row-plus-after": 984307,
	"table-row-plus-before": 984308,
	"table-row-remove": 984309,
	"table-search": 985359,
	"table-settings": 985144,
	"table-split-cell": 988202,
	"table-star": 988107,
	"table-sync": 988065,
	"table-tennis": 986728,
	"tablet": 984310,
	"tablet-android": 984311,
	"tablet-cellphone": 985511,
	"tablet-dashboard": 986830,
	"taco": 984930,
	"tag": 984313,
	"tag-arrow-down": 988971,
	"tag-arrow-down-outline": 988972,
	"tag-arrow-left": 988973,
	"tag-arrow-left-outline": 988974,
	"tag-arrow-right": 988975,
	"tag-arrow-right-outline": 988976,
	"tag-arrow-up": 988977,
	"tag-arrow-up-outline": 988978,
	"tag-faces": 984314,
	"tag-heart": 984715,
	"tag-heart-outline": 986063,
	"tag-minus": 985360,
	"tag-minus-outline": 987679,
	"tag-multiple": 984315,
	"tag-multiple-outline": 987895,
	"tag-off": 987680,
	"tag-off-outline": 987681,
	"tag-outline": 984316,
	"tag-plus": 984866,
	"tag-plus-outline": 987682,
	"tag-remove": 984867,
	"tag-remove-outline": 987683,
	"tag-search": 989447,
	"tag-search-outline": 989448,
	"tag-text": 987684,
	"tag-text-outline": 984317,
	"tailwind": 988159,
	"tangram": 984312,
	"tank": 986426,
	"tanker-truck": 987109,
	"tape-drive": 988895,
	"tape-measure": 985933,
	"target": 984318,
	"target-account": 986064,
	"target-variant": 985719,
	"taxi": 984319,
	"tea": 986526,
	"tea-outline": 986527,
	"teamviewer": 984320,
	"teddy-bear": 989435,
	"telescope": 985934,
	"television": 984322,
	"television-ambient-light": 987990,
	"television-box": 985145,
	"television-classic": 985076,
	"television-classic-off": 985146,
	"television-guide": 984323,
	"television-off": 985147,
	"television-pause": 987017,
	"television-play": 986831,
	"television-shimmer": 987408,
	"television-stop": 987018,
	"temperature-celsius": 984324,
	"temperature-fahrenheit": 984325,
	"temperature-kelvin": 984326,
	"tennis": 986528,
	"tennis-ball": 984327,
	"tent": 984328,
	"terraform": 987234,
	"terrain": 984329,
	"test-tube": 984680,
	"test-tube-empty": 985361,
	"test-tube-off": 985362,
	"text": 985512,
	"text-account": 988528,
	"text-box": 983578,
	"text-box-check": 986790,
	"text-box-check-outline": 986791,
	"text-box-minus": 986792,
	"text-box-minus-outline": 986793,
	"text-box-multiple": 985783,
	"text-box-multiple-outline": 985784,
	"text-box-outline": 985581,
	"text-box-plus": 986794,
	"text-box-plus-outline": 986795,
	"text-box-remove": 986796,
	"text-box-remove-outline": 986797,
	"text-box-search": 986798,
	"text-box-search-outline": 986799,
	"text-long": 985514,
	"text-recognition": 987453,
	"text-search": 988088,
	"text-shadow": 984681,
	"text-short": 985513,
	"text-to-speech": 984330,
	"text-to-speech-off": 984331,
	"texture": 984332,
	"texture-box": 987110,
	"theater": 984333,
	"theme-light-dark": 984334,
	"thermometer": 984335,
	"thermometer-alert": 986625,
	"thermometer-bluetooth": 989333,
	"thermometer-chevron-down": 986626,
	"thermometer-chevron-up": 986627,
	"thermometer-high": 987330,
	"thermometer-lines": 984336,
	"thermometer-low": 987331,
	"thermometer-minus": 986628,
	"thermometer-off": 988465,
	"thermometer-plus": 986629,
	"thermostat": 983955,
	"thermostat-box": 985233,
	"thought-bubble": 985078,
	"thought-bubble-outline": 985079,
	"thumb-down": 984337,
	"thumb-down-outline": 984338,
	"thumb-up": 984339,
	"thumb-up-outline": 984340,
	"thumbs-up-down": 984341,
	"thumbs-up-down-outline": 989460,
	"ticket": 984342,
	"ticket-account": 984343,
	"ticket-confirmation": 984344,
	"ticket-confirmation-outline": 988074,
	"ticket-outline": 985363,
	"ticket-percent": 984868,
	"ticket-percent-outline": 988203,
	"tie": 984345,
	"tilde": 984869,
	"tilde-off": 989427,
	"timelapse": 984346,
	"timeline": 986065,
	"timeline-alert": 987029,
	"timeline-alert-outline": 987032,
	"timeline-check": 988466,
	"timeline-check-outline": 988467,
	"timeline-clock": 987643,
	"timeline-clock-outline": 987644,
	"timeline-help": 987033,
	"timeline-help-outline": 987034,
	"timeline-minus": 988468,
	"timeline-minus-outline": 988469,
	"timeline-outline": 986066,
	"timeline-plus": 987030,
	"timeline-plus-outline": 987031,
	"timeline-remove": 988470,
	"timeline-remove-outline": 988471,
	"timeline-text": 986067,
	"timeline-text-outline": 986068,
	"timer": 988075,
	"timer-10": 984348,
	"timer-3": 984349,
	"timer-cog": 989477,
	"timer-cog-outline": 989478,
	"timer-off": 988076,
	"timer-off-outline": 984350,
	"timer-outline": 984347,
	"timer-sand": 984351,
	"timer-sand-complete": 989599,
	"timer-sand-empty": 984749,
	"timer-sand-full": 984972,
	"timer-sand-paused": 989600,
	"timer-settings": 989475,
	"timer-settings-outline": 989476,
	"timetable": 984352,
	"tire": 989334,
	"toaster": 987235,
	"toaster-off": 987575,
	"toaster-oven": 986323,
	"toggle-switch": 984353,
	"toggle-switch-off": 984354,
	"toggle-switch-off-outline": 985625,
	"toggle-switch-outline": 985626,
	"toilet": 985515,
	"toolbox": 985516,
	"toolbox-outline": 985517,
	"tools": 987236,
	"tooltip": 984355,
	"tooltip-account": 983052,
	"tooltip-cellphone": 989243,
	"tooltip-check": 988508,
	"tooltip-check-outline": 988509,
	"tooltip-edit": 984356,
	"tooltip-edit-outline": 987845,
	"tooltip-image": 984357,
	"tooltip-image-outline": 986069,
	"tooltip-minus": 988510,
	"tooltip-minus-outline": 988511,
	"tooltip-outline": 984358,
	"tooltip-plus": 986070,
	"tooltip-plus-outline": 984359,
	"tooltip-remove": 988512,
	"tooltip-remove-outline": 988513,
	"tooltip-text": 984360,
	"tooltip-text-outline": 986071,
	"tooth": 985283,
	"tooth-outline": 984361,
	"toothbrush": 987433,
	"toothbrush-electric": 987436,
	"toothbrush-paste": 987434,
	"torch": 988678,
	"tortoise": 986427,
	"toslink": 987832,
	"tournament": 985518,
	"tow-truck": 985148,
	"tower-beach": 984705,
	"tower-fire": 984706,
	"town-hall": 989301,
	"toy-brick": 987784,
	"toy-brick-marker": 987785,
	"toy-brick-marker-outline": 987786,
	"toy-brick-minus": 987787,
	"toy-brick-minus-outline": 987788,
	"toy-brick-outline": 987789,
	"toy-brick-plus": 987790,
	"toy-brick-plus-outline": 987791,
	"toy-brick-remove": 987792,
	"toy-brick-remove-outline": 987793,
	"toy-brick-search": 987794,
	"toy-brick-search-outline": 987795,
	"track-light": 985364,
	"trackpad": 985080,
	"trackpad-lock": 985395,
	"tractor": 985234,
	"tractor-variant": 988356,
	"trademark": 985720,
	"traffic-cone": 988028,
	"traffic-light": 984363,
	"traffic-light-outline": 989226,
	"train": 984364,
	"train-car": 986072,
	"train-car-passenger": 988979,
	"train-car-passenger-door": 988980,
	"train-car-passenger-door-open": 988981,
	"train-car-passenger-variant": 988982,
	"train-variant": 985284,
	"tram": 984365,
	"tram-side": 987111,
	"transcribe": 984366,
	"transcribe-close": 984367,
	"transfer": 987237,
	"transfer-down": 986529,
	"transfer-left": 986530,
	"transfer-right": 984368,
	"transfer-up": 986531,
	"transit-connection": 986428,
	"transit-connection-horizontal": 988486,
	"transit-connection-variant": 986429,
	"transit-detour": 987019,
	"transit-skip": 988437,
	"transit-transfer": 984750,
	"transition": 985365,
	"transition-masked": 985366,
	"translate": 984522,
	"translate-off": 986630,
	"transmission-tower": 986430,
	"transmission-tower-export": 989484,
	"transmission-tower-import": 989485,
	"trash-can": 985721,
	"trash-can-outline": 985722,
	"tray": 987796,
	"tray-alert": 987797,
	"tray-arrow-down": 983328,
	"tray-arrow-up": 983325,
	"tray-full": 987798,
	"tray-minus": 987799,
	"tray-plus": 987800,
	"tray-remove": 987801,
	"treasure-chest": 984870,
	"tree": 984369,
	"tree-outline": 986729,
	"trello": 984370,
	"trending-down": 984371,
	"trending-neutral": 984372,
	"trending-up": 984373,
	"triangle": 984374,
	"triangle-outline": 984375,
	"triangle-wave": 988284,
	"triforce": 986073,
	"trophy": 984376,
	"trophy-award": 984377,
	"trophy-broken": 986532,
	"trophy-outline": 984378,
	"trophy-variant": 984379,
	"trophy-variant-outline": 984380,
	"truck": 984381,
	"truck-cargo-container": 989400,
	"truck-check": 986324,
	"truck-check-outline": 987802,
	"truck-delivery": 984382,
	"truck-delivery-outline": 987803,
	"truck-fast": 984968,
	"truck-fast-outline": 987804,
	"truck-flatbed": 989329,
	"truck-minus": 989614,
	"truck-minus-outline": 989629,
	"truck-outline": 987805,
	"truck-plus": 989613,
	"truck-plus-outline": 989628,
	"truck-remove": 989615,
	"truck-remove-outline": 989630,
	"truck-snowflake": 989606,
	"truck-trailer": 984871,
	"trumpet": 987286,
	"tshirt-crew": 985723,
	"tshirt-crew-outline": 984383,
	"tshirt-v": 985724,
	"tshirt-v-outline": 984384,
	"tumble-dryer": 985367,
	"tumble-dryer-alert": 987578,
	"tumble-dryer-off": 987579,
	"tune": 984622,
	"tune-variant": 988482,
	"tune-vertical": 984682,
	"tune-vertical-variant": 988483,
	"tunnel": 989245,
	"tunnel-outline": 989246,
	"turkey": 988955,
	"turnstile": 986325,
	"turnstile-outline": 986326,
	"turtle": 986327,
	"twitch": 984387,
	"twitter": 984388,
	"two-factor-authentication": 985519,
	"typewriter": 986925,
	"ubisoft": 986074,
	"ubuntu": 984392,
	"ufo": 987332,
	"ufo-outline": 987333,
	"ultra-high-definition": 985081,
	"umbraco": 984393,
	"umbrella": 984394,
	"umbrella-beach": 989322,
	"umbrella-beach-outline": 989323,
	"umbrella-closed": 985520,
	"umbrella-closed-outline": 988130,
	"umbrella-closed-variant": 988129,
	"umbrella-outline": 984395,
	"undo": 984396,
	"undo-variant": 984397,
	"unfold-less-horizontal": 984398,
	"unfold-less-vertical": 984928,
	"unfold-more-horizontal": 984399,
	"unfold-more-vertical": 984929,
	"ungroup": 984400,
	"unicode": 986832,
	"unicorn": 988610,
	"unicorn-variant": 988611,
	"unicycle": 988645,
	"unity": 984751,
	"unreal": 985521,
	"update": 984752,
	"upload": 984402,
	"upload-lock": 988019,
	"upload-lock-outline": 988020,
	"upload-multiple": 985149,
	"upload-network": 984822,
	"upload-network-outline": 986328,
	"upload-off": 987334,
	"upload-off-outline": 987335,
	"upload-outline": 986631,
	"usb": 984403,
	"usb-flash-drive": 987806,
	"usb-flash-drive-outline": 987807,
	"usb-port": 987632,
	"vacuum": 989601,
	"vacuum-outline": 989602,
	"valve": 987238,
	"valve-closed": 987239,
	"valve-open": 987240,
	"van-passenger": 985082,
	"van-utility": 985083,
	"vanish": 985084,
	"vanish-quarter": 988500,
	"vanity-light": 987617,
	"variable": 985831,
	"variable-box": 987409,
	"vector-arrange-above": 984404,
	"vector-arrange-below": 984405,
	"vector-bezier": 985832,
	"vector-circle": 984406,
	"vector-circle-variant": 984407,
	"vector-combine": 984408,
	"vector-curve": 984409,
	"vector-difference": 984410,
	"vector-difference-ab": 984411,
	"vector-difference-ba": 984412,
	"vector-ellipse": 985235,
	"vector-intersection": 984413,
	"vector-line": 984414,
	"vector-link": 987112,
	"vector-point": 984415,
	"vector-polygon": 984416,
	"vector-polygon-variant": 989270,
	"vector-polyline": 984417,
	"vector-polyline-edit": 987685,
	"vector-polyline-minus": 987686,
	"vector-polyline-plus": 987687,
	"vector-polyline-remove": 987688,
	"vector-radius": 984906,
	"vector-rectangle": 984518,
	"vector-selection": 984418,
	"vector-square": 983041,
	"vector-square-close": 989271,
	"vector-square-edit": 989401,
	"vector-square-minus": 989402,
	"vector-square-open": 989272,
	"vector-square-plus": 989403,
	"vector-square-remove": 989404,
	"vector-triangle": 984419,
	"vector-union": 984420,
	"vhs": 985627,
	"vibrate": 984422,
	"vibrate-off": 986329,
	"video": 984423,
	"video-3d": 985085,
	"video-3d-off": 988121,
	"video-3d-variant": 986833,
	"video-4k-box": 985150,
	"video-account": 985369,
	"video-box": 983293,
	"video-box-off": 983294,
	"video-check": 987241,
	"video-check-outline": 987242,
	"video-high-definition": 988462,
	"video-image": 985370,
	"video-input-antenna": 985151,
	"video-input-component": 985152,
	"video-input-hdmi": 985153,
	"video-input-scart": 987020,
	"video-input-svideo": 985154,
	"video-marker": 989609,
	"video-marker-outline": 989610,
	"video-minus": 985522,
	"video-minus-outline": 983738,
	"video-off": 984424,
	"video-off-outline": 986075,
	"video-outline": 986076,
	"video-plus": 985523,
	"video-plus-outline": 983507,
	"video-stabilization": 985371,
	"video-switch": 984425,
	"video-switch-outline": 984976,
	"video-vintage": 985628,
	"video-wireless": 986834,
	"video-wireless-outline": 986835,
	"view-agenda": 984426,
	"view-agenda-outline": 987608,
	"view-array": 984427,
	"view-array-outline": 988293,
	"view-carousel": 984428,
	"view-carousel-outline": 988294,
	"view-column": 984429,
	"view-column-outline": 988295,
	"view-comfy": 986730,
	"view-comfy-outline": 988296,
	"view-compact": 986731,
	"view-compact-outline": 986732,
	"view-dashboard": 984430,
	"view-dashboard-edit": 989511,
	"view-dashboard-edit-outline": 989512,
	"view-dashboard-outline": 985629,
	"view-dashboard-variant": 985155,
	"view-dashboard-variant-outline": 988297,
	"view-day": 984431,
	"view-day-outline": 988298,
	"view-gallery": 989320,
	"view-gallery-outline": 989321,
	"view-grid": 984432,
	"view-grid-outline": 987609,
	"view-grid-plus": 987021,
	"view-grid-plus-outline": 987610,
	"view-headline": 984433,
	"view-list": 984434,
	"view-list-outline": 988299,
	"view-module": 984435,
	"view-module-outline": 988300,
	"view-parallel": 984872,
	"view-parallel-outline": 988301,
	"view-quilt": 984436,
	"view-quilt-outline": 988302,
	"view-sequential": 984873,
	"view-sequential-outline": 988303,
	"view-split-horizontal": 986059,
	"view-split-vertical": 986060,
	"view-stream": 984437,
	"view-stream-outline": 988304,
	"view-week": 984438,
	"view-week-outline": 988305,
	"vimeo": 984439,
	"violin": 984591,
	"virtual-reality": 985236,
	"virus": 988086,
	"virus-off": 989409,
	"virus-off-outline": 989410,
	"virus-outline": 988087,
	"vlc": 984444,
	"voicemail": 984445,
	"volleyball": 985524,
	"volume-high": 984446,
	"volume-low": 984447,
	"volume-medium": 984448,
	"volume-minus": 984926,
	"volume-mute": 984927,
	"volume-off": 984449,
	"volume-plus": 984925,
	"volume-source": 987424,
	"volume-variant-off": 986632,
	"volume-vibrate": 987425,
	"vote": 985631,
	"vote-outline": 985632,
	"vpn": 984450,
	"vuejs": 985156,
	"vuetify": 986733,
	"walk": 984451,
	"wall": 985086,
	"wall-sconce": 985372,
	"wall-sconce-flat": 985373,
	"wall-sconce-flat-outline": 989129,
	"wall-sconce-flat-variant": 984092,
	"wall-sconce-flat-variant-outline": 989130,
	"wall-sconce-outline": 989131,
	"wall-sconce-round": 984904,
	"wall-sconce-round-outline": 989132,
	"wall-sconce-round-variant": 985374,
	"wall-sconce-round-variant-outline": 989133,
	"wallet": 984452,
	"wallet-giftcard": 984453,
	"wallet-membership": 984454,
	"wallet-outline": 986077,
	"wallet-plus": 987022,
	"wallet-plus-outline": 987023,
	"wallet-travel": 984455,
	"wallpaper": 986633,
	"wan": 984456,
	"wardrobe": 987024,
	"wardrobe-outline": 987025,
	"warehouse": 987009,
	"washing-machine": 984874,
	"washing-machine-alert": 987580,
	"washing-machine-off": 987581,
	"watch": 984457,
	"watch-export": 984458,
	"watch-export-variant": 985237,
	"watch-import": 984459,
	"watch-import-variant": 985238,
	"watch-variant": 985239,
	"watch-vibrate": 984753,
	"watch-vibrate-off": 986330,
	"water": 984460,
	"water-alert": 988418,
	"water-alert-outline": 988419,
	"water-boiler": 987026,
	"water-boiler-alert": 987571,
	"water-boiler-off": 987572,
	"water-check": 988420,
	"water-check-outline": 988421,
	"water-circle": 989190,
	"water-minus": 988422,
	"water-minus-outline": 988423,
	"water-off": 984461,
	"water-off-outline": 988424,
	"water-opacity": 989269,
	"water-outline": 986634,
	"water-percent": 984462,
	"water-percent-alert": 988425,
	"water-plus": 988426,
	"water-plus-outline": 988427,
	"water-polo": 987808,
	"water-pump": 984463,
	"water-pump-off": 987027,
	"water-remove": 988428,
	"water-remove-outline": 988429,
	"water-sync": 989126,
	"water-well": 987243,
	"water-well-outline": 987244,
	"waterfall": 989257,
	"watering-can": 988289,
	"watering-can-outline": 988290,
	"watermark": 984594,
	"wave": 986926,
	"waveform": 988285,
	"waves": 984973,
	"waves-arrow-left": 989273,
	"waves-arrow-right": 989274,
	"waves-arrow-up": 989275,
	"waze": 986078,
	"weather-cloudy": 984464,
	"weather-cloudy-alert": 986927,
	"weather-cloudy-arrow-right": 986734,
	"weather-cloudy-clock": 989430,
	"weather-fog": 984465,
	"weather-hail": 984466,
	"weather-hazy": 986928,
	"weather-hurricane": 985240,
	"weather-lightning": 984467,
	"weather-lightning-rainy": 984702,
	"weather-night": 984468,
	"weather-night-partly-cloudy": 986929,
	"weather-partly-cloudy": 984469,
	"weather-partly-lightning": 986930,
	"weather-partly-rainy": 986931,
	"weather-partly-snowy": 986932,
	"weather-partly-snowy-rainy": 986933,
	"weather-pouring": 984470,
	"weather-rainy": 984471,
	"weather-snowy": 984472,
	"weather-snowy-heavy": 986934,
	"weather-snowy-rainy": 984703,
	"weather-sunny": 984473,
	"weather-sunny-alert": 986935,
	"weather-sunny-off": 988388,
	"weather-sunset": 984474,
	"weather-sunset-down": 984475,
	"weather-sunset-up": 984476,
	"weather-tornado": 986936,
	"weather-windy": 984477,
	"weather-windy-variant": 984478,
	"web": 984479,
	"web-box": 987028,
	"web-cancel": 989072,
	"web-check": 984969,
	"web-clock": 987722,
	"web-minus": 987296,
	"web-off": 985742,
	"web-plus": 983091,
	"web-refresh": 989073,
	"web-remove": 984401,
	"web-sync": 989074,
	"webcam": 984480,
	"webcam-off": 988983,
	"webhook": 984623,
	"webpack": 984875,
	"webrtc": 987720,
	"wechat": 984593,
	"weight": 984481,
	"weight-gram": 986431,
	"weight-kilogram": 984482,
	"weight-lifter": 987485,
	"weight-pound": 985525,
	"whatsapp": 984483,
	"wheel-barrow": 988402,
	"wheelchair-accessibility": 984484,
	"whistle": 985526,
	"whistle-outline": 987836,
	"white-balance-auto": 984485,
	"white-balance-incandescent": 984486,
	"white-balance-iridescent": 984487,
	"white-balance-sunny": 984488,
	"widgets": 984876,
	"widgets-outline": 987989,
	"wifi": 984489,
	"wifi-alert": 988853,
	"wifi-arrow-down": 988854,
	"wifi-arrow-left": 988855,
	"wifi-arrow-left-right": 988856,
	"wifi-arrow-right": 988857,
	"wifi-arrow-up": 988858,
	"wifi-arrow-up-down": 988859,
	"wifi-cancel": 988860,
	"wifi-check": 988861,
	"wifi-cog": 988862,
	"wifi-lock": 988863,
	"wifi-lock-open": 988864,
	"wifi-marker": 988865,
	"wifi-minus": 988866,
	"wifi-off": 984490,
	"wifi-plus": 988867,
	"wifi-refresh": 988868,
	"wifi-remove": 988869,
	"wifi-settings": 988870,
	"wifi-star": 986635,
	"wifi-strength-1": 985375,
	"wifi-strength-1-alert": 985376,
	"wifi-strength-1-lock": 985377,
	"wifi-strength-1-lock-open": 988875,
	"wifi-strength-2": 985378,
	"wifi-strength-2-alert": 985379,
	"wifi-strength-2-lock": 985380,
	"wifi-strength-2-lock-open": 988876,
	"wifi-strength-3": 985381,
	"wifi-strength-3-alert": 985382,
	"wifi-strength-3-lock": 985383,
	"wifi-strength-3-lock-open": 988877,
	"wifi-strength-4": 985384,
	"wifi-strength-4-alert": 985385,
	"wifi-strength-4-lock": 985386,
	"wifi-strength-4-lock-open": 988878,
	"wifi-strength-alert-outline": 985387,
	"wifi-strength-lock-open-outline": 988879,
	"wifi-strength-lock-outline": 985388,
	"wifi-strength-off": 985389,
	"wifi-strength-off-outline": 985390,
	"wifi-strength-outline": 985391,
	"wifi-sync": 988871,
	"wikipedia": 984492,
	"wind-turbine": 986533,
	"wind-turbine-alert": 989611,
	"wind-turbine-check": 989612,
	"window-close": 984493,
	"window-closed": 984494,
	"window-closed-variant": 987611,
	"window-maximize": 984495,
	"window-minimize": 984496,
	"window-open": 984497,
	"window-open-variant": 987612,
	"window-restore": 984498,
	"window-shutter": 987420,
	"window-shutter-alert": 987421,
	"window-shutter-open": 987422,
	"windsock": 988666,
	"wiper": 985833,
	"wiper-wash": 986534,
	"wiper-wash-alert": 989407,
	"wizard-hat": 988279,
	"wordpress": 984500,
	"wrap": 984502,
	"wrap-disabled": 986079,
	"wrench": 984503,
	"wrench-clock": 989603,
	"wrench-outline": 986080,
	"xamarin": 985157,
	"xml": 984512,
	"xmpp": 985087,
	"yahoo": 985935,
	"yeast": 984513,
	"yin-yang": 984704,
	"yoga": 987516,
	"youtube": 984515,
	"youtube-gaming": 985160,
	"youtube-studio": 985159,
	"youtube-subscription": 986432,
	"youtube-tv": 984136,
	"yurt": 988438,
	"z-wave": 985834,
	"zend": 985835,
	"zigbee": 986433,
	"zip-box": 984516,
	"zip-box-outline": 987130,
	"zip-disk": 985635,
	"zodiac-aquarius": 985725,
	"zodiac-aries": 985726,
	"zodiac-cancer": 985727,
	"zodiac-capricorn": 985728,
	"zodiac-gemini": 985729,
	"zodiac-leo": 985730,
	"zodiac-libra": 985731,
	"zodiac-pisces": 985732,
	"zodiac-sagittarius": 985733,
	"zodiac-scorpio": 985734,
	"zodiac-taurus": 985735,
	"zodiac-virgo": 985736,
	"blank": 63116
}
export default iconMap;